import {
  GraphQLResolveInfo,
  GraphQLScalarType,
  GraphQLScalarTypeConfig,
} from 'graphql';
import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
import {
  FieldPolicy,
  FieldReadFunction,
  TypePolicies,
  TypePolicy,
} from '@apollo/client/cache';

export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & {
  [P in K]-?: NonNullable<T[P]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** RFC 3339 formatted datetime string */
  Time: { input: string; output: string };
};

export type AdminPerformanceResponse = {
  __typename?: 'AdminPerformanceResponse';
  rate24: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
  ytd: Scalars['Float']['output'];
};

export type AdminSignInAsResponse = {
  __typename?: 'AdminSignInAsResponse';
  authIdentityID: Scalars['ID']['output'];
  token: Scalars['String']['output'];
  totpEnabled: Scalars['Boolean']['output'];
};

export type AdminUserResponse = {
  __typename?: 'AdminUserResponse';
  address?: Maybe<Scalars['String']['output']>;
  amountToInvest?: Maybe<Scalars['Int']['output']>;
  authIdentities: Array<AuthIdentityResponse>;
  authProvider: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  controlledByUser?: Maybe<UserResponse>;
  country?: Maybe<Scalars['String']['output']>;
  currenciesLocked: Array<Scalars['Int']['output']>;
  customStatuses: Array<CustomUserStatus>;
  dateOfBirth?: Maybe<Scalars['Time']['output']>;
  dateOfSignup: Scalars['Time']['output'];
  deletedAt?: Maybe<Scalars['Time']['output']>;
  exchanges: Array<UserExchangeResponse>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hadCreditCard: Scalars['Boolean']['output'];
  hasActiveSubscription: Scalars['Boolean']['output'];
  hasUnpaidInvoices: Scalars['Boolean']['output'];
  houseNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mollieStatus: MollieStatus;
  moneyPaid: Scalars['Float']['output'];
  nextRebalancingOn?: Maybe<Scalars['Time']['output']>;
  paymentSources: Array<PaymentSource>;
  pendingDiscount: Scalars['Float']['output'];
  personalReferalCode: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  profileValid: Scalars['Boolean']['output'];
  referralCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
  stripeStatus: StripeStatus;
  totpEnabled: Scalars['Boolean']['output'];
  trialEndDate?: Maybe<Scalars['Time']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AdminUserResponseAuthIdentitiesArgs = {
  providers?: InputMaybe<Array<AuthIdentityProvider>>;
};

export type AdminUsersResponse = {
  __typename?: 'AdminUsersResponse';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
  totalAum: Scalars['Float']['output'];
  totalPaid: Scalars['Float']['output'];
  users: Array<AdminUserResponse>;
};

export type AggregatedDataRow = {
  __typename?: 'AggregatedDataRow';
  date: Scalars['Time']['output'];
  value: Scalars['Float']['output'];
};

export enum AuthIdentityProvider {
  Email = 'EMAIL',
  Google = 'GOOGLE',
}

export type AuthIdentityResponse = {
  __typename?: 'AuthIdentityResponse';
  confirmedAt?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  deletedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  provider: AuthIdentityProvider;
  uid: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type Currency = {
  __typename?: 'Currency';
  btc24RateValue: Scalars['Float']['output'];
  btcValue: Scalars['Float']['output'];
  eur24RateValue: Scalars['Float']['output'];
  eurValue: Scalars['Float']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isFiat: Scalars['Boolean']['output'];
  messari: Scalars['String']['output'];
  piechartColor: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  targetForSale: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  usd24RateValue: Scalars['Float']['output'];
  usdValue: Scalars['Float']['output'];
};

export type CurrencyInput = {
  id: Scalars['Int']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
};

export type CurrencyPortfolioPercentageCostResponse = {
  __typename?: 'CurrencyPortfolioPercentageCostResponse';
  amount: Scalars['Float']['output'];
  partitionAction: PortfolioPartitionAction;
};

export enum CustomUserStatus {
  Activate = 'ACTIVATE',
  Active = 'ACTIVE',
  BelowLimit = 'BELOW_LIMIT',
  Cancelled = 'CANCELLED',
  Free = 'FREE',
  InvalidKey = 'INVALID_KEY',
  NotVerified = 'NOT_VERIFIED',
  NoFunds = 'NO_FUNDS',
  NoKey = 'NO_KEY',
  NoPaymentDetails = 'NO_PAYMENT_DETAILS',
  OpenInvoice = 'OPEN_INVOICE',
  RebalanceEmailSent = 'REBALANCE_EMAIL_SENT',
  Removed = 'REMOVED',
  SignedUp = 'SIGNED_UP',
  Trial = 'TRIAL',
}

export type DirectInvoicePaymentResponse = {
  __typename?: 'DirectInvoicePaymentResponse';
  checkoutURL: Scalars['String']['output'];
};

export enum ExchangeCode {
  Bitvavo = 'BITVAVO',
  Kraken = 'KRAKEN',
}

export type ExchangeResponse = {
  __typename?: 'ExchangeResponse';
  exchangeCode: ExchangeCode;
  exchangeName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type ExpectedPortfolioRowResponse = {
  __typename?: 'ExpectedPortfolioRowResponse';
  amountCoins: Scalars['Float']['output'];
  /** @deprecated change24Percentage should be used */
  change24: Scalars['Float']['output'];
  change24Amount: Scalars['Float']['output'];
  change24Percentage: Scalars['Float']['output'];
  cost: Scalars['Float']['output'];
  currency: Currency;
  currentCost: Scalars['Float']['output'];
  effectiveDate: Scalars['Time']['output'];
  percentage: Scalars['Float']['output'];
  status: ExpectedPortfolioTokenStatus;
  usdChange24Amount: Scalars['Float']['output'];
  usdChange24Percentage: Scalars['Float']['output'];
  usdCost: Scalars['Float']['output'];
};

export enum ExpectedPortfolioTokenStatus {
  Existing = 'EXISTING',
  New = 'NEW',
  Removed = 'REMOVED',
}

export type GoogleSignInResponse = {
  __typename?: 'GoogleSignInResponse';
  authIdentityID: Scalars['ID']['output'];
  profileValid: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
  totpEnabled: Scalars['Boolean']['output'];
};

export type GoogleSignUpResponse = {
  __typename?: 'GoogleSignUpResponse';
  authIdentityID: Scalars['ID']['output'];
  profileValid: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
  totpEnabled: Scalars['Boolean']['output'];
};

export enum InvoiceActiveFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  NotActive = 'NOT_ACTIVE',
}

export type InvoiceListResponse = {
  __typename?: 'InvoiceListResponse';
  activeTotal: Scalars['Float']['output'];
  invoices: Array<InvoiceResponse>;
};

export enum InvoicePaymentStatus {
  InvoiceStatusCanceled = 'INVOICE_STATUS_CANCELED',
  InvoiceStatusCharged = 'INVOICE_STATUS_CHARGED',
  InvoiceStatusComplete = 'INVOICE_STATUS_COMPLETE',
  InvoiceStatusFailedOnce = 'INVOICE_STATUS_FAILED_ONCE',
  InvoiceStatusFailedTwice = 'INVOICE_STATUS_FAILED_TWICE',
  InvoiceStatusSubmitted = 'INVOICE_STATUS_SUBMITTED',
  InvoiceStatusUnpaid = 'INVOICE_STATUS_UNPAID',
}

export type InvoiceResponse = {
  __typename?: 'InvoiceResponse';
  amount: Scalars['Int']['output'];
  cost: Scalars['Float']['output'];
  costExVat: Scalars['Float']['output'];
  dueDate: Scalars['Time']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  status: InvoicePaymentStatus;
  strategy?: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
  url: Scalars['String']['output'];
  user: UserResponse;
  vat: Scalars['Float']['output'];
  vatAmount: Scalars['Float']['output'];
};

export enum InvoicesFilterByStatus {
  Paid = 'PAID',
  Pay = 'PAY',
  Submitted = 'SUBMITTED',
}

export type InvoicesOrderBy = {
  Direction?: InputMaybe<OrderByDirection>;
  Field: InvoicesOrderByField;
};

export enum InvoicesOrderByField {
  Amount = 'AMOUNT',
  Cost = 'COST',
  CreatedAt = 'CREATED_AT',
  DueDate = 'DUE_DATE',
  UpdatedAt = 'UPDATED_AT',
  UsersFirstName = 'USERS__FIRST_NAME',
  UsersLastName = 'USERS__LAST_NAME',
}

export type KeyInput = {
  key: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};

export enum KeysStatus {
  InvalidKeys = 'INVALID_KEYS',
  NoEnoughFunds = 'NO_ENOUGH_FUNDS',
  NoKeys = 'NO_KEYS',
  Ok = 'OK',
}

export enum LastRebalanceReasonType {
  Deposit = 'DEPOSIT',
  Failed = 'FAILED',
  FailedInit = 'FAILED_INIT',
  FailedReinit = 'FAILED_REINIT',
  FailedTransactions = 'FAILED_TRANSACTIONS',
  FailedUserIsLocked = 'FAILED_USER_IS_LOCKED',
  Fromdemo = 'FROMDEMO',
  Liquidate = 'LIQUIDATE',
  Manual = 'MANUAL',
  ManualCommand = 'MANUAL_COMMAND',
  Scheduled = 'SCHEDULED',
  Starttrial = 'STARTTRIAL',
}

export type MolliePaymentResponse = {
  __typename?: 'MolliePaymentResponse';
  createdAt: Scalars['Time']['output'];
  details: Scalars['String']['output'];
  method: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum MollieStatus {
  NoCc = 'NO_CC',
  Ok = 'OK',
}

export type MollieTransitPaymentLinkResponse = {
  __typename?: 'MollieTransitPaymentLinkResponse';
  checkoutURL: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  AdminCancelUserSubscription: UserResponse;
  addKeys: UserExchangeResponse;
  adminManageUsersTotp: Array<UserResponse>;
  adminRebalanceUser: UserResponse;
  adminRemoveKeys: UserResponse;
  adminSendEmail: Scalars['Boolean']['output'];
  adminSignInAs: AdminSignInAsResponse;
  adminSignOutAs: SignInResponse;
  cancelSubscription: UserExchangeResponse;
  changeCredentials: UserResponse;
  depositAmount: UserResponse;
  directMolliePayment: DirectInvoicePaymentResponse;
  editProfile: UserResponse;
  googleSignIn: GoogleSignInResponse;
  googleSignUp: GoogleSignUpResponse;
  newMollieClient: NewMollieClientResponse;
  portfolioLiquidation: UserResponse;
  portfolioRebalance: UserResponse;
  removeUser: RemoveUserResponse;
  resendVerificationEmail: Scalars['Boolean']['output'];
  resetPassword: ResetPasswordResponse;
  sendResetPasswordEmail: SendResetPasswordEmailResponse;
  signIn: SignInResponse;
  signOut: SignOutResponse;
  signUp: SignUpResponse;
  startSubscription: StartTrialStatus;
  totpDisable: TotpDisableResponse;
  totpGenerate: Scalars['String']['output'];
  totpSetup?: Maybe<TotpValidateResponse>;
  totpVerify?: Maybe<TotpVerifyResponse>;
};

export type MutationAdminCancelUserSubscriptionArgs = {
  exchangeId: Scalars['Int']['input'];
  userID: Scalars['Int']['input'];
};

export type MutationAddKeysArgs = {
  exchangeId: Scalars['Int']['input'];
  keys: Array<KeyInput>;
};

export type MutationAdminManageUsersTotpArgs = {
  enable: Scalars['Boolean']['input'];
  usersIDs: Array<Scalars['Int']['input']>;
};

export type MutationAdminRebalanceUserArgs = {
  exchangeId: Scalars['Int']['input'];
  userID: Scalars['Int']['input'];
};

export type MutationAdminRemoveKeysArgs = {
  exchangeId: Scalars['Int']['input'];
  userID: Scalars['Int']['input'];
};

export type MutationAdminSendEmailArgs = {
  atiFilterLess?: InputMaybe<Scalars['Int']['input']>;
  atiFilterMore?: InputMaybe<Scalars['Int']['input']>;
  aumFilterLess?: InputMaybe<Scalars['Float']['input']>;
  aumFilterMore?: InputMaybe<Scalars['Float']['input']>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  customStatusFilter?: InputMaybe<Array<CustomUserStatus>>;
  dateOfSignUpLess?: InputMaybe<Scalars['Time']['input']>;
  dateOfSignUpMore?: InputMaybe<Scalars['Time']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exchangeId?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<Array<UserStatus>>;
  templateId: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type MutationAdminSignInAsArgs = {
  userID: Scalars['Int']['input'];
};

export type MutationCancelSubscriptionArgs = {
  exchangeId: Scalars['Int']['input'];
};

export type MutationChangeCredentialsArgs = {
  currentPassword: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDepositAmountArgs = {
  currencies: Array<CurrencyInput>;
  exchangeId: Scalars['Int']['input'];
};

export type MutationDirectMolliePaymentArgs = {
  invoiceId: Scalars['Int']['input'];
  paymentMode?: InputMaybe<Scalars['String']['input']>;
};

export type MutationEditProfileArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  amountToInvest?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Time']['input']>;
  exchangeId?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notUsPerson?: InputMaybe<Scalars['Boolean']['input']>;
  olderThan18AndTermsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  sendMeNews?: InputMaybe<Scalars['Boolean']['input']>;
  sharedReferralCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type MutationGoogleSignInArgs = {
  token: Scalars['String']['input'];
};

export type MutationGoogleSignUpArgs = {
  token: Scalars['String']['input'];
};

export type MutationNewMollieClientArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type MutationPortfolioLiquidationArgs = {
  currencyId: Scalars['Int']['input'];
  exchangeId: Scalars['Int']['input'];
  percents: Scalars['Float']['input'];
};

export type MutationPortfolioRebalanceArgs = {
  exchangeId: Scalars['Int']['input'];
};

export type MutationRemoveUserArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
};

export type MutationResendVerificationEmailArgs = {
  authIdentityId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
};

export type MutationSendResetPasswordEmailArgs = {
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  captchaV2Token?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSignInArgs = {
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  captchaV2Token?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  remember: Scalars['Boolean']['input'];
};

export type MutationSignUpArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  amountToInvest?: InputMaybe<Scalars['Int']['input']>;
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  captchaV2Token?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  notUsPerson?: InputMaybe<Scalars['Boolean']['input']>;
  olderThan18AndTermsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  passwordRepeat: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  sendMeNews?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type MutationStartSubscriptionArgs = {
  currencies: Array<CurrencyInput>;
  exchangeId: Scalars['Int']['input'];
};

export type MutationTotpDisableArgs = {
  code: Scalars['String']['input'];
};

export type MutationTotpSetupArgs = {
  code: Scalars['String']['input'];
};

export type MutationTotpVerifyArgs = {
  code: Scalars['String']['input'];
};

export type NewMollieClientResponse = {
  __typename?: 'NewMollieClientResponse';
  checkoutURL: Scalars['String']['output'];
};

export type NotificationResponse = {
  __typename?: 'NotificationResponse';
  CreatedAt?: Maybe<Scalars['Time']['output']>;
  NotificationId: Scalars['ID']['output'];
  NotificationSource: Scalars['String']['output'];
  NotificationType: NotificationType;
};

export enum NotificationType {
  BuySellFailed = 'buy_sell_failed',
  BuySellFinished = 'buy_sell_finished',
  BuySellInProgress = 'buy_sell_in_progress',
  PortfolioUpdateFailed = 'portfolio_update_failed',
  PortfolioUpdateFinished = 'portfolio_update_finished',
  PortfolioUpdateInProgress = 'portfolio_update_in_progress',
  UserExchangeLockedBitvavo = 'user_exchange_locked_bitvavo',
  UserExchangeLockedKraken = 'user_exchange_locked_kraken',
}

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT',
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM',
}

export type PaymentSource = {
  __typename?: 'PaymentSource';
  brand: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lastFour: Scalars['String']['output'];
};

export enum PortfolioCurrency {
  Eur = 'EUR',
  Usd = 'USD',
}

export enum PortfolioPartitionAction {
  Deposit = 'DEPOSIT',
  Starttrial = 'STARTTRIAL',
  Withdraw = 'WITHDRAW',
}

export type PortfolioRowResponse = {
  __typename?: 'PortfolioRowResponse';
  amountCoins: Scalars['Float']['output'];
  /** @deprecated change24Percentage should be used */
  change24: Scalars['Float']['output'];
  change24Amount: Scalars['Float']['output'];
  change24Percentage: Scalars['Float']['output'];
  cost: Scalars['Float']['output'];
  currency: Currency;
  effectiveDate: Scalars['Time']['output'];
  enoughToStartSubscription: Scalars['Boolean']['output'];
  percentage: Scalars['Float']['output'];
  usdChange24Amount: Scalars['Float']['output'];
  usdChange24Percentage: Scalars['Float']['output'];
  usdCost: Scalars['Float']['output'];
};

export type PortfolioTotalsResponse = {
  __typename?: 'PortfolioTotalsResponse';
  eurCostChange24Percentage: Scalars['Float']['output'];
  eurCostChange24Total: Scalars['Float']['output'];
  eurCostTotal: Scalars['Float']['output'];
  nextRebalancingOn: Scalars['Time']['output'];
  usdCostChange24Percentage: Scalars['Float']['output'];
  usdCostChange24total: Scalars['Float']['output'];
  usdCostTotal: Scalars['Float']['output'];
};

export type PrivatePortfolioRowResponse = {
  __typename?: 'PrivatePortfolioRowResponse';
  amountCoins: Scalars['Float']['output'];
  /** @deprecated change24Percentage should be used */
  change24: Scalars['Float']['output'];
  change24Amount: Scalars['Float']['output'];
  change24Percentage: Scalars['Float']['output'];
  cost: Scalars['Float']['output'];
  currency: Currency;
  effectiveDate: Scalars['Time']['output'];
  enoughToStartSubscription: Scalars['Boolean']['output'];
  percentage: Scalars['Float']['output'];
  usdChange24Amount: Scalars['Float']['output'];
  usdChange24Percentage: Scalars['Float']['output'];
  usdCost: Scalars['Float']['output'];
};

export type Query = {
  __typename?: 'Query';
  adminGetInvoices: InvoiceListResponse;
  adminGetPerformance: AdminPerformanceResponse;
  adminGetUser?: Maybe<UserResponse>;
  adminGetUsers: AdminUsersResponse;
  getDemoPortfolio: Array<PortfolioRowResponse>;
  getDemoPortfolioGraphData: Array<Maybe<AggregatedDataRow>>;
  getDepositCurrenciesOptions: Array<PrivatePortfolioRowResponse>;
  getExchanges: Array<ExchangeResponse>;
  getExpectedPortfolio: Array<ExpectedPortfolioRowResponse>;
  getIndexPortfolio: Array<PortfolioRowResponse>;
  getIndexPortfolioSortedForSale: Array<PortfolioRowResponse>;
  getInvoice: InvoiceResponse;
  getInvoices: Array<InvoiceResponse>;
  getMolliePaymentInfo: MolliePaymentResponse;
  getMollieTransitPaymentLink: MollieTransitPaymentLinkResponse;
  getPortfolioCurrencyPercentageCost: CurrencyPortfolioPercentageCostResponse;
  getPortfolioGraphData: Array<AggregatedDataRow>;
  getPortfolioTotals: PortfolioTotalsResponse;
  getPrivatePortfolio: Array<PrivatePortfolioRowResponse>;
  getUser: UserResponse;
  getUserExchanges: Array<UserExchangeResponse>;
  getUserNotifications: Array<NotificationResponse>;
  portfolioCurrency?: Maybe<PortfolioCurrency>;
  selectedExchange?: Maybe<ExchangeCode>;
  updatePortfolioPopupWasShown?: Maybe<Scalars['Boolean']['output']>;
};

export type QueryAdminGetInvoicesArgs = {
  active?: InputMaybe<InvoiceActiveFilter>;
  assetsUnderManagement?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy>>;
  statusFilter?: InputMaybe<InvoicesFilterByStatus>;
  usersIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type QueryAdminGetUserArgs = {
  userId: Scalars['Int']['input'];
};

export type QueryAdminGetUsersArgs = {
  atiFilterLess?: InputMaybe<Scalars['Int']['input']>;
  atiFilterMore?: InputMaybe<Scalars['Int']['input']>;
  aumFilterLess?: InputMaybe<Scalars['Float']['input']>;
  aumFilterMore?: InputMaybe<Scalars['Float']['input']>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  customStatusFilter?: InputMaybe<Array<CustomUserStatus>>;
  dateOfSignUpLess?: InputMaybe<Scalars['Time']['input']>;
  dateOfSignUpMore?: InputMaybe<Scalars['Time']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exchangeId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  statusFilter?: InputMaybe<Array<UserStatus>>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetDemoPortfolioArgs = {
  exchangeId: Scalars['Int']['input'];
};

export type QueryGetDemoPortfolioGraphDataArgs = {
  exchangeId: Scalars['Int']['input'];
  from?: InputMaybe<Scalars['Time']['input']>;
  till?: InputMaybe<Scalars['Time']['input']>;
};

export type QueryGetDepositCurrenciesOptionsArgs = {
  await?: InputMaybe<Scalars['Boolean']['input']>;
  exchangeId: Scalars['Int']['input'];
  tradableOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetExpectedPortfolioArgs = {
  exchangeId: Scalars['Int']['input'];
};

export type QueryGetIndexPortfolioArgs = {
  await?: InputMaybe<Scalars['Boolean']['input']>;
  awaitSeconds?: InputMaybe<Scalars['Int']['input']>;
  exchangeId: Scalars['Int']['input'];
  tradableOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetIndexPortfolioSortedForSaleArgs = {
  exchangeId: Scalars['Int']['input'];
};

export type QueryGetInvoiceArgs = {
  invoiceID: Scalars['Int']['input'];
};

export type QueryGetMollieTransitPaymentLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type QueryGetPortfolioCurrencyPercentageCostArgs = {
  currencies: Array<CurrencyInput>;
  exchangeId: Scalars['Int']['input'];
  partitionAction: PortfolioPartitionAction;
};

export type QueryGetPortfolioGraphDataArgs = {
  exchangeId: Scalars['Int']['input'];
  from?: InputMaybe<Scalars['Time']['input']>;
  till?: InputMaybe<Scalars['Time']['input']>;
};

export type QueryGetPortfolioTotalsArgs = {
  exchangeId: Scalars['Int']['input'];
};

export type QueryGetPrivatePortfolioArgs = {
  await?: InputMaybe<Scalars['Boolean']['input']>;
  exchangeId: Scalars['Int']['input'];
  tradableOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoveUserResponse = {
  __typename?: 'RemoveUserResponse';
  invoiceToPayId: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  success: Scalars['Boolean']['output'];
};

export type SendResetPasswordEmailResponse = {
  __typename?: 'SendResetPasswordEmailResponse';
  success: Scalars['Boolean']['output'];
};

export type SignInResponse = {
  __typename?: 'SignInResponse';
  authIdentityID: Scalars['ID']['output'];
  token: Scalars['String']['output'];
  totpEnabled: Scalars['Boolean']['output'];
};

export type SignOutResponse = {
  __typename?: 'SignOutResponse';
  success: Scalars['Boolean']['output'];
};

export type SignUpResponse = {
  __typename?: 'SignUpResponse';
  authIdentityId: Scalars['ID']['output'];
  token: Scalars['String']['output'];
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC',
}

export enum StartTrialStatus {
  ActiveUser = 'ACTIVE_USER',
  ErrInvalidKeys = 'ERR_INVALID_KEYS',
  ErrNotEnoughFunds = 'ERR_NOT_ENOUGH_FUNDS',
  ErrNoKeys = 'ERR_NO_KEYS',
  ErrNoPaymentData = 'ERR_NO_PAYMENT_DATA',
  ErrStatus = 'ERR_STATUS',
  ErrTrialIsOver = 'ERR_TRIAL_IS_OVER',
  Ok = 'OK',
}

export enum StripeStatus {
  NoCc = 'NO_CC',
  Ok = 'OK',
}

export type TotpDisableResponse = {
  __typename?: 'TotpDisableResponse';
  success: Scalars['Boolean']['output'];
};

export type TotpValidateResponse = {
  __typename?: 'TotpValidateResponse';
  backupCodes: Array<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type TotpVerifyResponse = {
  __typename?: 'TotpVerifyResponse';
  token: Scalars['String']['output'];
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT',
}

export type UserExchangeResponse = {
  __typename?: 'UserExchangeResponse';
  aumBelowMinimum: Scalars['Boolean']['output'];
  exchangeCode: ExchangeCode;
  exchangeID: Scalars['ID']['output'];
  fiatCurrencies: Array<Currency>;
  keysCreatedAt?: Maybe<Scalars['Time']['output']>;
  keysStatus: KeysStatus;
  /** @deprecated lastRebalanceReasonResponse should be used */
  lastRebalanceReason?: Maybe<LastRebalanceReasonType>;
  lastRebalanceReasonRequest?: Maybe<LastRebalanceReasonType>;
  lastRebalanceReasonResponse?: Maybe<LastRebalanceReasonType>;
  moneyUnderManagement: Scalars['Float']['output'];
  nextRebalanceDate?: Maybe<Scalars['Time']['output']>;
  onlyFiatInPortfolio: Scalars['Boolean']['output'];
  portfolioOutdated: Scalars['Boolean']['output'];
  rebalancingDate?: Maybe<Scalars['Time']['output']>;
  sentToRebalancing: Scalars['Boolean']['output'];
  subscriptionInitiatedDate?: Maybe<Scalars['Time']['output']>;
  subscriptionStartDate?: Maybe<Scalars['Time']['output']>;
  targetForSaleCurrencies: Array<Currency>;
  wizardStatus: WizardStatusType;
};

export type UserResponse = {
  __typename?: 'UserResponse';
  address?: Maybe<Scalars['String']['output']>;
  amountToInvest?: Maybe<Scalars['Int']['output']>;
  authIdentities: Array<AuthIdentityResponse>;
  authProvider: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  controlledByUser?: Maybe<UserResponse>;
  country?: Maybe<Scalars['String']['output']>;
  currenciesLocked: Array<Scalars['Int']['output']>;
  dateOfBirth?: Maybe<Scalars['Time']['output']>;
  dateOfSignup: Scalars['Time']['output'];
  deletedAt?: Maybe<Scalars['Time']['output']>;
  exchanges: Array<UserExchangeResponse>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hadCreditCard: Scalars['Boolean']['output'];
  hasActiveSubscription: Scalars['Boolean']['output'];
  hasUnpaidInvoices: Scalars['Boolean']['output'];
  houseNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mollieStatus: MollieStatus;
  moneyPaid: Scalars['Float']['output'];
  nextRebalancingOn?: Maybe<Scalars['Time']['output']>;
  paymentSources: Array<PaymentSource>;
  pendingDiscount: Scalars['Float']['output'];
  personalReferalCode: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  profileValid: Scalars['Boolean']['output'];
  referralCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
  stripeStatus: StripeStatus;
  totpEnabled: Scalars['Boolean']['output'];
  trialEndDate?: Maybe<Scalars['Time']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type UserResponseAuthIdentitiesArgs = {
  providers?: InputMaybe<Array<AuthIdentityProvider>>;
};

export enum UserStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  EmailNotVerified = 'EMAIL_NOT_VERIFIED',
  NoCc = 'NO_CC',
}

export type UsersOrderBy = {
  Direction?: InputMaybe<OrderByDirection>;
  Field: UsersOrderByField;
};

export enum UsersOrderByField {
  AmountToInvest = 'AMOUNT_TO_INVEST',
  AssetsUnderManagement = 'ASSETS_UNDER_MANAGEMENT',
  Country = 'COUNTRY',
  DateOfSignup = 'DATE_OF_SIGNUP',
  EmailAddress = 'EMAIL_ADDRESS',
  FirstName = 'FIRST_NAME',
  Kosten = 'KOSTEN',
  LastName = 'LAST_NAME',
  RebalancingDate = 'REBALANCING_DATE',
}

export enum WizardStatusType {
  Disabled = 'DISABLED',
  NoKeys = 'NO_KEYS',
  NoMoney = 'NO_MONEY',
  StartSubscription = 'START_SUBSCRIPTION',
  StartTrial = 'START_TRIAL',
}

export type AdminUsersFiltersDataQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminUsersFiltersDataQuery = {
  __typename?: 'Query';
  getExchanges: Array<{
    __typename?: 'ExchangeResponse';
    id: number;
    exchangeName: string;
  }>;
  adminGetUsers: {
    __typename?: 'AdminUsersResponse';
    users: Array<{
      __typename?: 'AdminUserResponse';
      id: string;
      country?: string | null | undefined;
      amountToInvest?: number | null | undefined;
    }>;
  };
};

export type AdminAllUsersQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<UsersOrderBy> | UsersOrderBy>;
  atiFilter?: InputMaybe<Scalars['Int']['input']>;
  countries?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  customStatusFilter?: InputMaybe<Array<CustomUserStatus> | CustomUserStatus>;
  exchangeId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  userIDs?: InputMaybe<
    Array<Scalars['Int']['input']> | Scalars['Int']['input']
  >;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AdminAllUsersQuery = {
  __typename?: 'Query';
  adminGetUsers: {
    __typename?: 'AdminUsersResponse';
    total: number;
    totalAum: number;
    totalPaid: number;
    users: Array<{
      __typename?: 'AdminUserResponse';
      id: string;
      dateOfSignup: string;
      firstName?: string | null | undefined;
      lastName?: string | null | undefined;
      phone?: string | null | undefined;
      customStatuses: Array<CustomUserStatus>;
      amountToInvest?: number | null | undefined;
      moneyPaid: number;
      totpEnabled: boolean;
      hasUnpaidInvoices: boolean;
      hasActiveSubscription: boolean;
      mollieStatus: MollieStatus;
      trialEndDate?: string | null | undefined;
      authIdentities: Array<{
        __typename?: 'AuthIdentityResponse';
        provider: AuthIdentityProvider;
        uid: string;
      }>;
      exchanges: Array<{
        __typename?: 'UserExchangeResponse';
        exchangeID: string;
        exchangeCode: ExchangeCode;
        moneyUnderManagement: number;
        keysStatus: KeysStatus;
        rebalancingDate?: string | null | undefined;
      }>;
    }>;
  };
  adminGetInvoices: { __typename?: 'InvoiceListResponse'; activeTotal: number };
};

export type AdminUserStatusAndActiveSubscriptionQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type AdminUserStatusAndActiveSubscriptionQuery = {
  __typename?: 'Query';
  adminGetUser?:
    | {
        __typename?: 'UserResponse';
        id: string;
        status: UserStatus;
        hasActiveSubscription: boolean;
      }
    | null
    | undefined;
};

export type AdminUsersFirstAndLastNamesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminUsersFirstAndLastNamesQuery = {
  __typename?: 'Query';
  adminGetUsers: {
    __typename?: 'AdminUsersResponse';
    users: Array<{
      __typename?: 'AdminUserResponse';
      id: string;
      firstName?: string | null | undefined;
      lastName?: string | null | undefined;
    }>;
  };
};

export type AdminInvoicesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  status?: InputMaybe<InvoicesFilterByStatus>;
  orderBy?: InputMaybe<Array<InvoicesOrderBy> | InvoicesOrderBy>;
}>;

export type AdminInvoicesQuery = {
  __typename?: 'Query';
  adminGetInvoices: {
    __typename?: 'InvoiceListResponse';
    invoices: Array<{
      __typename?: 'InvoiceResponse';
      id: string;
      dueDate: string;
      cost: number;
      costExVat: number;
      url: string;
      user: {
        __typename?: 'UserResponse';
        id: string;
        firstName?: string | null | undefined;
        lastName?: string | null | undefined;
      };
    }>;
  };
};

export type AdminIndexPerformanceQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AdminIndexPerformanceQuery = {
  __typename?: 'Query';
  adminGetPerformance: {
    __typename?: 'AdminPerformanceResponse';
    rate24: number;
    ytd: number;
    year: number;
    start: number;
  };
};

export type AdminDisableUsersTotpMutationVariables = Exact<{
  userIDs: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type AdminDisableUsersTotpMutation = {
  __typename?: 'Mutation';
  adminManageUsersTotp: Array<{
    __typename?: 'UserResponse';
    id: string;
    totpEnabled: boolean;
  }>;
};

export type AdminCancelUserSubscriptionMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  exchangeId: Scalars['Int']['input'];
}>;

export type AdminCancelUserSubscriptionMutation = {
  __typename?: 'Mutation';
  AdminCancelUserSubscription: {
    __typename?: 'UserResponse';
    id: string;
    exchanges: Array<{
      __typename?: 'UserExchangeResponse';
      exchangeID: string;
      subscriptionStartDate?: string | null | undefined;
      wizardStatus: WizardStatusType;
      moneyUnderManagement: number;
      nextRebalanceDate?: string | null | undefined;
    }>;
  };
};

export type AdminSignInAsMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type AdminSignInAsMutation = {
  __typename?: 'Mutation';
  adminSignInAs: {
    __typename?: 'AdminSignInAsResponse';
    token: string;
    authIdentityID: string;
  };
};

export type AdminSignOutAsMutationVariables = Exact<{ [key: string]: never }>;

export type AdminSignOutAsMutation = {
  __typename?: 'Mutation';
  adminSignOutAs: {
    __typename?: 'SignInResponse';
    token: string;
    authIdentityID: string;
  };
};

export type SendAdminEmailsMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
  userIDs?: InputMaybe<
    Array<Scalars['Int']['input']> | Scalars['Int']['input']
  >;
  atiFilter?: InputMaybe<Scalars['Int']['input']>;
  countries?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  exchangeId?: InputMaybe<Scalars['Int']['input']>;
  customStatusFilter?: InputMaybe<Array<CustomUserStatus> | CustomUserStatus>;
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
}>;

export type SendAdminEmailsMutation = {
  __typename?: 'Mutation';
  adminSendEmail: boolean;
};

export type AdminRebalanceUserMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  exchangeId: Scalars['Int']['input'];
}>;

export type AdminRebalanceUserMutation = {
  __typename?: 'Mutation';
  adminRebalanceUser: {
    __typename?: 'UserResponse';
    id: string;
    nextRebalancingOn?: string | null | undefined;
  };
};

export type AdminRemoveUserKeysMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  exchangeId: Scalars['Int']['input'];
}>;

export type AdminRemoveUserKeysMutation = {
  __typename?: 'Mutation';
  adminRemoveKeys: {
    __typename?: 'UserResponse';
    id: string;
    status: UserStatus;
    hasActiveSubscription: boolean;
    nextRebalancingOn?: string | null | undefined;
    exchanges: Array<{
      __typename?: 'UserExchangeResponse';
      exchangeID: string;
      exchangeCode: ExchangeCode;
      keysStatus: KeysStatus;
      moneyUnderManagement: number;
    }>;
  };
};

export type AppBarDataQueryVariables = Exact<{ [key: string]: never }>;

export type AppBarDataQuery = {
  __typename?: 'Query';
  getUser: {
    __typename?: 'UserResponse';
    id: string;
    firstName?: string | null | undefined;
    lastName?: string | null | undefined;
    isAdmin: boolean;
  };
};

export type AppMenuDataQueryVariables = Exact<{ [key: string]: never }>;

export type AppMenuDataQuery = {
  __typename?: 'Query';
  getUser: {
    __typename?: 'UserResponse';
    id: string;
    isAdmin: boolean;
    controlledByUser?:
      | { __typename?: 'UserResponse'; id: string }
      | null
      | undefined;
  };
};

export type SignInMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  remember: Scalars['Boolean']['input'];
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  captchaV2Token?: InputMaybe<Scalars['String']['input']>;
}>;

export type SignInMutation = {
  __typename?: 'Mutation';
  signIn: {
    __typename?: 'SignInResponse';
    token: string;
    totpEnabled: boolean;
    authIdentityID: string;
  };
};

export type SignUpMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  confPassword: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  captchaV2Token?: InputMaybe<Scalars['String']['input']>;
}>;

export type SignUpMutation = {
  __typename?: 'Mutation';
  signUp: {
    __typename?: 'SignUpResponse';
    token: string;
    authIdentityId: string;
  };
};

export type GoogleSignInMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type GoogleSignInMutation = {
  __typename?: 'Mutation';
  googleSignIn: {
    __typename?: 'GoogleSignInResponse';
    token: string;
    totpEnabled: boolean;
    authIdentityID: string;
  };
};

export type GoogleSignUpMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type GoogleSignUpMutation = {
  __typename?: 'Mutation';
  googleSignUp: {
    __typename?: 'GoogleSignUpResponse';
    token: string;
    totpEnabled: boolean;
    authIdentityID: string;
  };
};

export type SignOutMutationVariables = Exact<{ [key: string]: never }>;

export type SignOutMutation = {
  __typename?: 'Mutation';
  signOut: { __typename?: 'SignOutResponse'; success: boolean };
};

export type PortfolioRowDataFragment = {
  __typename?: 'PortfolioRowResponse';
  change24Amount: number;
  usdChange24Amount: number;
  change24Percentage: number;
  usdChange24Percentage: number;
  cost: number;
  usdCost: number;
  percentage: number;
  amountCoins: number;
  currency: {
    __typename?: 'Currency';
    id: string;
    symbol: string;
    title: string;
    icon?: string | null | undefined;
    isFiat: boolean;
    piechartColor: string;
    messari: string;
    eurValue: number;
    usdValue: number;
  };
};

export type PrivatePortfolioRowDataFragment = {
  __typename?: 'PrivatePortfolioRowResponse';
  change24Amount: number;
  usdChange24Amount: number;
  change24Percentage: number;
  usdChange24Percentage: number;
  cost: number;
  usdCost: number;
  percentage: number;
  amountCoins: number;
  currency: {
    __typename?: 'Currency';
    id: string;
    symbol: string;
    title: string;
    icon?: string | null | undefined;
    isFiat: boolean;
    piechartColor: string;
    messari: string;
    eurValue: number;
    usdValue: number;
  };
};

export type ExpectedPortfolioRowDataFragment = {
  __typename?: 'ExpectedPortfolioRowResponse';
  change24Amount: number;
  usdChange24Amount: number;
  cost: number;
  currentCost: number;
  usdCost: number;
  percentage: number;
  amountCoins: number;
  status: ExpectedPortfolioTokenStatus;
  currency: {
    __typename?: 'Currency';
    id: string;
    symbol: string;
    title: string;
    icon?: string | null | undefined;
    isFiat: boolean;
    piechartColor: string;
    messari: string;
  };
};

export type UpdatePortfolioPopupWasShownQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UpdatePortfolioPopupWasShownQuery = {
  __typename?: 'Query';
  updatePortfolioPopupWasShown?: boolean | null | undefined;
};

export type DashboardDataQueryVariables = Exact<{
  exchangeId: Scalars['Int']['input'];
}>;

export type DashboardDataQuery = {
  __typename?: 'Query';
  getPortfolioGraphData: Array<{
    __typename?: 'AggregatedDataRow';
    date: string;
    value: number;
  }>;
  getPortfolioTotals: {
    __typename?: 'PortfolioTotalsResponse';
    eurCostTotal: number;
    eurCostChange24Total: number;
    eurCostChange24Percentage: number;
    usdCostTotal: number;
    usdCostChange24total: number;
    usdCostChange24Percentage: number;
  };
  getIndexPortfolio: Array<{
    __typename?: 'PortfolioRowResponse';
    change24Amount: number;
    usdChange24Amount: number;
    change24Percentage: number;
    usdChange24Percentage: number;
    cost: number;
    usdCost: number;
    percentage: number;
    amountCoins: number;
    currency: {
      __typename?: 'Currency';
      id: string;
      symbol: string;
      title: string;
      icon?: string | null | undefined;
      isFiat: boolean;
      piechartColor: string;
      messari: string;
      eurValue: number;
      usdValue: number;
    };
  }>;
  getPrivatePortfolio: Array<{
    __typename?: 'PrivatePortfolioRowResponse';
    change24Amount: number;
    usdChange24Amount: number;
    change24Percentage: number;
    usdChange24Percentage: number;
    cost: number;
    usdCost: number;
    percentage: number;
    amountCoins: number;
    currency: {
      __typename?: 'Currency';
      id: string;
      symbol: string;
      title: string;
      icon?: string | null | undefined;
      isFiat: boolean;
      piechartColor: string;
      messari: string;
      eurValue: number;
      usdValue: number;
    };
  }>;
};

export type PortfolioCurrencyQueryVariables = Exact<{ [key: string]: never }>;

export type PortfolioCurrencyQuery = {
  __typename?: 'Query';
  portfolioCurrency?: PortfolioCurrency | null | undefined;
};

export type ExpectedPortfolioQueryVariables = Exact<{
  exchangeId: Scalars['Int']['input'];
}>;

export type ExpectedPortfolioQuery = {
  __typename?: 'Query';
  getExpectedPortfolio: Array<{
    __typename?: 'ExpectedPortfolioRowResponse';
    change24Amount: number;
    usdChange24Amount: number;
    cost: number;
    currentCost: number;
    usdCost: number;
    percentage: number;
    amountCoins: number;
    status: ExpectedPortfolioTokenStatus;
    currency: {
      __typename?: 'Currency';
      id: string;
      symbol: string;
      title: string;
      icon?: string | null | undefined;
      isFiat: boolean;
      piechartColor: string;
      messari: string;
    };
  }>;
};

export type CurrencyPercentageCostQueryVariables = Exact<{
  partitionAction: PortfolioPartitionAction;
  exchangeId: Scalars['Int']['input'];
  currencies: Array<CurrencyInput> | CurrencyInput;
}>;

export type CurrencyPercentageCostQuery = {
  __typename?: 'Query';
  getPortfolioCurrencyPercentageCost: {
    __typename?: 'CurrencyPortfolioPercentageCostResponse';
    amount: number;
  };
};

export type PortfolioLiquidateMutationVariables = Exact<{
  exchangeId: Scalars['Int']['input'];
  currencyId: Scalars['Int']['input'];
  percent: Scalars['Float']['input'];
}>;

export type PortfolioLiquidateMutation = {
  __typename?: 'Mutation';
  portfolioLiquidation: { __typename?: 'UserResponse'; id: string };
};

export type PortfolioDepositMutationVariables = Exact<{
  exchangeId: Scalars['Int']['input'];
  currencies: Array<CurrencyInput> | CurrencyInput;
}>;

export type PortfolioDepositMutation = {
  __typename?: 'Mutation';
  depositAmount: { __typename?: 'UserResponse'; id: string };
};

export type PortfolioRebalanceMutationVariables = Exact<{
  exchangeId: Scalars['Int']['input'];
}>;

export type PortfolioRebalanceMutation = {
  __typename?: 'Mutation';
  portfolioRebalance: { __typename?: 'UserResponse'; id: string };
};

export type AllExchangesDataFragment = {
  __typename?: 'UserExchangeResponse';
  exchangeID: string;
  exchangeCode: ExchangeCode;
  keysStatus: KeysStatus;
  wizardStatus: WizardStatusType;
  portfolioOutdated: boolean;
  sentToRebalancing: boolean;
  lastRebalanceReasonRequest?: LastRebalanceReasonType | null | undefined;
  lastRebalanceReasonResponse?: LastRebalanceReasonType | null | undefined;
  moneyUnderManagement: number;
  aumBelowMinimum: boolean;
  subscriptionInitiatedDate?: string | null | undefined;
  subscriptionStartDate?: string | null | undefined;
  nextRebalanceDate?: string | null | undefined;
  onlyFiatInPortfolio: boolean;
  fiatCurrencies: Array<{
    __typename?: 'Currency';
    id: string;
    symbol: string;
  }>;
  targetForSaleCurrencies: Array<{
    __typename?: 'Currency';
    id: string;
    symbol: string;
    isFiat: boolean;
  }>;
};

export type CurrencyListItemDataFragment = {
  __typename?: 'PortfolioRowResponse';
  currency: { __typename?: 'Currency'; id: string; symbol: string };
};

export type UserExchangeProviderDataQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UserExchangeProviderDataQuery = {
  __typename?: 'Query';
  selectedExchange?: ExchangeCode | null | undefined;
  getUser: {
    __typename?: 'UserResponse';
    id: string;
    isAdmin: boolean;
    profileValid: boolean;
  };
  getUserExchanges: Array<{
    __typename?: 'UserExchangeResponse';
    exchangeID: string;
    exchangeCode: ExchangeCode;
    keysStatus: KeysStatus;
    wizardStatus: WizardStatusType;
    portfolioOutdated: boolean;
    sentToRebalancing: boolean;
    lastRebalanceReasonRequest?: LastRebalanceReasonType | null | undefined;
    lastRebalanceReasonResponse?: LastRebalanceReasonType | null | undefined;
    moneyUnderManagement: number;
    aumBelowMinimum: boolean;
    subscriptionInitiatedDate?: string | null | undefined;
    subscriptionStartDate?: string | null | undefined;
    nextRebalanceDate?: string | null | undefined;
    onlyFiatInPortfolio: boolean;
    fiatCurrencies: Array<{
      __typename?: 'Currency';
      id: string;
      symbol: string;
    }>;
    targetForSaleCurrencies: Array<{
      __typename?: 'Currency';
      id: string;
      symbol: string;
      isFiat: boolean;
    }>;
  }>;
};

export type UserExchangesQueryVariables = Exact<{ [key: string]: never }>;

export type UserExchangesQuery = {
  __typename?: 'Query';
  getUserExchanges: Array<{
    __typename?: 'UserExchangeResponse';
    exchangeID: string;
    exchangeCode: ExchangeCode;
    keysStatus: KeysStatus;
    wizardStatus: WizardStatusType;
    portfolioOutdated: boolean;
    sentToRebalancing: boolean;
    lastRebalanceReasonRequest?: LastRebalanceReasonType | null | undefined;
    lastRebalanceReasonResponse?: LastRebalanceReasonType | null | undefined;
    moneyUnderManagement: number;
    aumBelowMinimum: boolean;
    subscriptionInitiatedDate?: string | null | undefined;
    subscriptionStartDate?: string | null | undefined;
    nextRebalanceDate?: string | null | undefined;
    onlyFiatInPortfolio: boolean;
    fiatCurrencies: Array<{
      __typename?: 'Currency';
      id: string;
      symbol: string;
    }>;
    targetForSaleCurrencies: Array<{
      __typename?: 'Currency';
      id: string;
      symbol: string;
      isFiat: boolean;
    }>;
  }>;
};

export type UserExchangesStartDatesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UserExchangesStartDatesQuery = {
  __typename?: 'Query';
  getUserExchanges: Array<{
    __typename?: 'UserExchangeResponse';
    exchangeID: string;
    exchangeCode: ExchangeCode;
    subscriptionStartDate?: string | null | undefined;
  }>;
};

export type SelectedExchangeQueryVariables = Exact<{ [key: string]: never }>;

export type SelectedExchangeQuery = {
  __typename?: 'Query';
  selectedExchange?: ExchangeCode | null | undefined;
};

export type ExchangesSubscriptionInitiatedDatesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ExchangesSubscriptionInitiatedDatesQuery = {
  __typename?: 'Query';
  getUserExchanges: Array<{
    __typename?: 'UserExchangeResponse';
    exchangeID: string;
    subscriptionInitiatedDate?: string | null | undefined;
  }>;
};

export type DepositCurrenciesOptionsQueryVariables = Exact<{
  exchangeId: Scalars['Int']['input'];
}>;

export type DepositCurrenciesOptionsQuery = {
  __typename?: 'Query';
  getDepositCurrenciesOptions: Array<{
    __typename?: 'PrivatePortfolioRowResponse';
    cost: number;
    enoughToStartSubscription: boolean;
    currency: { __typename?: 'Currency'; id: string; symbol: string };
  }>;
};

export type WithdrawCurrenciesOptionsQueryVariables = Exact<{
  exchangeId: Scalars['Int']['input'];
}>;

export type WithdrawCurrenciesOptionsQuery = {
  __typename?: 'Query';
  getIndexPortfolioSortedForSale: Array<{
    __typename?: 'PortfolioRowResponse';
    currency: { __typename?: 'Currency'; id: string; symbol: string };
  }>;
};

export type AddExchangeKeysMutationVariables = Exact<{
  exchangeId: Scalars['Int']['input'];
  key: Scalars['String']['input'];
  secretKey: Scalars['String']['input'];
}>;

export type AddExchangeKeysMutation = {
  __typename?: 'Mutation';
  addKeys: {
    __typename?: 'UserExchangeResponse';
    exchangeID: string;
    aumBelowMinimum: boolean;
    moneyUnderManagement: number;
    nextRebalanceDate?: string | null | undefined;
    wizardStatus: WizardStatusType;
    subscriptionStartDate?: string | null | undefined;
    subscriptionInitiatedDate?: string | null | undefined;
    onlyFiatInPortfolio: boolean;
  };
};

export type StartSubscriptionMutationVariables = Exact<{
  exchangeId: Scalars['Int']['input'];
  currencies: Array<CurrencyInput> | CurrencyInput;
}>;

export type StartSubscriptionMutation = {
  __typename?: 'Mutation';
  startSubscription: StartTrialStatus;
};

export type DisableSubscriptionMutationVariables = Exact<{
  exchangeId: Scalars['Int']['input'];
}>;

export type DisableSubscriptionMutation = {
  __typename?: 'Mutation';
  cancelSubscription: {
    __typename?: 'UserExchangeResponse';
    exchangeID: string;
  };
};

export type CommonInvoiceDataFragment = {
  __typename?: 'InvoiceResponse';
  id: string;
  dueDate: string;
  cost: number;
  costExVat: number;
  url: string;
  status: InvoicePaymentStatus;
};

export type InvoicesQueryVariables = Exact<{ [key: string]: never }>;

export type InvoicesQuery = {
  __typename?: 'Query';
  getInvoices: Array<{
    __typename?: 'InvoiceResponse';
    id: string;
    dueDate: string;
    url: string;
    status: InvoicePaymentStatus;
  }>;
};

export type InvoiceQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type InvoiceQuery = {
  __typename?: 'Query';
  getInvoice: {
    __typename?: 'InvoiceResponse';
    id: string;
    dueDate: string;
    cost: number;
    costExVat: number;
    url: string;
    status: InvoicePaymentStatus;
  };
};

export type MainDataQueryVariables = Exact<{ [key: string]: never }>;

export type MainDataQuery = {
  __typename?: 'Query';
  getUser: {
    __typename?: 'UserResponse';
    id: string;
    isAdmin: boolean;
    status: UserStatus;
    companyName?: string | null | undefined;
    authProvider: string;
    trialEndDate?: string | null | undefined;
    mollieStatus: MollieStatus;
    hasActiveSubscription: boolean;
    hasUnpaidInvoices: boolean;
    profileValid: boolean;
    controlledByUser?:
      | { __typename?: 'UserResponse'; id: string }
      | null
      | undefined;
  };
  getUserExchanges: Array<{
    __typename?: 'UserExchangeResponse';
    exchangeID: string;
    exchangeCode: ExchangeCode;
    keysStatus: KeysStatus;
    wizardStatus: WizardStatusType;
    portfolioOutdated: boolean;
    sentToRebalancing: boolean;
    lastRebalanceReasonRequest?: LastRebalanceReasonType | null | undefined;
    lastRebalanceReasonResponse?: LastRebalanceReasonType | null | undefined;
    moneyUnderManagement: number;
    aumBelowMinimum: boolean;
    subscriptionInitiatedDate?: string | null | undefined;
    subscriptionStartDate?: string | null | undefined;
    nextRebalanceDate?: string | null | undefined;
    onlyFiatInPortfolio: boolean;
    fiatCurrencies: Array<{
      __typename?: 'Currency';
      id: string;
      symbol: string;
    }>;
    targetForSaleCurrencies: Array<{
      __typename?: 'Currency';
      id: string;
      symbol: string;
      isFiat: boolean;
    }>;
  }>;
  getMolliePaymentInfo: {
    __typename?: 'MolliePaymentResponse';
    method: string;
    status: string;
    createdAt: string;
    details: string;
  };
};

export type PaymentProviderDataQueryVariables = Exact<{ [key: string]: never }>;

export type PaymentProviderDataQuery = {
  __typename?: 'Query';
  getUser: {
    __typename?: 'UserResponse';
    id: string;
    isAdmin: boolean;
    trialEndDate?: string | null | undefined;
    mollieStatus: MollieStatus;
    hasActiveSubscription: boolean;
    hasUnpaidInvoices: boolean;
  };
};

export type MolliePaymentInfoQueryVariables = Exact<{ [key: string]: never }>;

export type MolliePaymentInfoQuery = {
  __typename?: 'Query';
  getMolliePaymentInfo: {
    __typename?: 'MolliePaymentResponse';
    method: string;
    status: string;
    createdAt: string;
    details: string;
  };
};

export type GetMollieTransitPaymentLinkQueryVariables = Exact<{
  token: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetMollieTransitPaymentLinkQuery = {
  __typename?: 'Query';
  getMollieTransitPaymentLink: {
    __typename?: 'MollieTransitPaymentLinkResponse';
    checkoutURL: string;
  };
};

export type CreateNewMollieClientMutationVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateNewMollieClientMutation = {
  __typename?: 'Mutation';
  newMollieClient: {
    __typename?: 'NewMollieClientResponse';
    checkoutURL: string;
  };
};

export type DirectMolliePaymentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DirectMolliePaymentMutation = {
  __typename?: 'Mutation';
  directMolliePayment: {
    __typename?: 'DirectInvoicePaymentResponse';
    checkoutURL: string;
  };
};

export type InitialUserDataFragment = {
  __typename?: 'UserResponse';
  id: string;
  isAdmin: boolean;
  status: UserStatus;
  companyName?: string | null | undefined;
  authProvider: string;
  trialEndDate?: string | null | undefined;
  mollieStatus: MollieStatus;
  hasActiveSubscription: boolean;
  hasUnpaidInvoices: boolean;
  profileValid: boolean;
  controlledByUser?:
    | { __typename?: 'UserResponse'; id: string }
    | null
    | undefined;
};

export type UserIdQueryVariables = Exact<{ [key: string]: never }>;

export type UserIdQuery = {
  __typename?: 'Query';
  getUser: { __typename?: 'UserResponse'; id: string };
};

export type UserCompanyNameQueryVariables = Exact<{ [key: string]: never }>;

export type UserCompanyNameQuery = {
  __typename?: 'Query';
  getUser: {
    __typename?: 'UserResponse';
    id: string;
    companyName?: string | null | undefined;
  };
};

export type UserAuthIdentitiesQueryVariables = Exact<{ [key: string]: never }>;

export type UserAuthIdentitiesQuery = {
  __typename?: 'Query';
  getUser: {
    __typename?: 'UserResponse';
    id: string;
    authIdentities: Array<{
      __typename?: 'AuthIdentityResponse';
      id: string;
      provider: AuthIdentityProvider;
      uid: string;
    }>;
  };
};

export type UserHasActiveSubscriptionQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UserHasActiveSubscriptionQuery = {
  __typename?: 'Query';
  getUser: {
    __typename?: 'UserResponse';
    id: string;
    hasActiveSubscription: boolean;
  };
};

export type GetUserTotpStatusQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserTotpStatusQuery = {
  __typename?: 'Query';
  getUser: { __typename?: 'UserResponse'; id: string; totpEnabled: boolean };
};

export type UserAdminStatusDataFragment = {
  __typename?: 'UserResponse';
  id: string;
  isAdmin: boolean;
};

export type UserAdminStatusQueryVariables = Exact<{ [key: string]: never }>;

export type UserAdminStatusQuery = {
  __typename?: 'Query';
  getUser: { __typename?: 'UserResponse'; id: string; isAdmin: boolean };
};

export type UserProfileQueryVariables = Exact<{ [key: string]: never }>;

export type UserProfileQuery = {
  __typename?: 'Query';
  getUser: {
    __typename?: 'UserResponse';
    id: string;
    firstName?: string | null | undefined;
    lastName?: string | null | undefined;
    companyName?: string | null | undefined;
    vatNumber?: string | null | undefined;
    phone?: string | null | undefined;
    address?: string | null | undefined;
    houseNumber?: string | null | undefined;
    zip?: string | null | undefined;
    city?: string | null | undefined;
    country?: string | null | undefined;
    amountToInvest?: number | null | undefined;
  };
};

export type ControllingUserQueryVariables = Exact<{ [key: string]: never }>;

export type ControllingUserQuery = {
  __typename?: 'Query';
  getUser: {
    __typename?: 'UserResponse';
    id: string;
    controlledByUser?:
      | { __typename?: 'UserResponse'; id: string }
      | null
      | undefined;
  };
};

export type UserSubscriptionReferralCodeAndDiscountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UserSubscriptionReferralCodeAndDiscountQuery = {
  __typename?: 'Query';
  getUser: {
    __typename?: 'UserResponse';
    id: string;
    personalReferalCode: string;
    pendingDiscount: number;
  };
};

export type UserTrialEndDateQueryVariables = Exact<{ [key: string]: never }>;

export type UserTrialEndDateQuery = {
  __typename?: 'Query';
  getUser: {
    __typename?: 'UserResponse';
    id: string;
    trialEndDate?: string | null | undefined;
  };
};

export type UserValidProfileQueryVariables = Exact<{ [key: string]: never }>;

export type UserValidProfileQuery = {
  __typename?: 'Query';
  getUser: { __typename?: 'UserResponse'; id: string; profileValid: boolean };
};

export type UserChatBoxDataQueryVariables = Exact<{ [key: string]: never }>;

export type UserChatBoxDataQuery = {
  __typename?: 'Query';
  getUser: {
    __typename?: 'UserResponse';
    id: string;
    firstName?: string | null | undefined;
    lastName?: string | null | undefined;
    phone?: string | null | undefined;
    authIdentities: Array<{
      __typename?: 'AuthIdentityResponse';
      uid: string;
      provider: AuthIdentityProvider;
    }>;
  };
};

export type UserNotificationsQueryVariables = Exact<{ [key: string]: never }>;

export type UserNotificationsQuery = {
  __typename?: 'Query';
  getUserNotifications: Array<{
    __typename?: 'NotificationResponse';
    id: string;
    type: NotificationType;
  }>;
};

export type GenerateQrCodeMutationVariables = Exact<{ [key: string]: never }>;

export type GenerateQrCodeMutation = {
  __typename?: 'Mutation';
  totpGenerate: string;
};

export type TotpVerifyMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type TotpVerifyMutation = {
  __typename?: 'Mutation';
  totpVerify?:
    | { __typename?: 'TotpVerifyResponse'; token: string }
    | null
    | undefined;
};

export type TotpSetupMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type TotpSetupMutation = {
  __typename?: 'Mutation';
  totpSetup?:
    | { __typename?: 'TotpValidateResponse'; backupCodes: Array<string> }
    | null
    | undefined;
};

export type TotpDisableMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type TotpDisableMutation = {
  __typename?: 'Mutation';
  totpDisable: { __typename?: 'TotpDisableResponse'; success: boolean };
};

export type ResendVerificationEmailMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ResendVerificationEmailMutation = {
  __typename?: 'Mutation';
  resendVerificationEmail: boolean;
};

export type EditUserProfileMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  amountToInvest?: InputMaybe<Scalars['Int']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  olderThan18AndTermsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  sendMeNews?: InputMaybe<Scalars['Boolean']['input']>;
  notUsPerson?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type EditUserProfileMutation = {
  __typename?: 'Mutation';
  editProfile: {
    __typename?: 'UserResponse';
    id: string;
    firstName?: string | null | undefined;
    lastName?: string | null | undefined;
    companyName?: string | null | undefined;
    vatNumber?: string | null | undefined;
    address?: string | null | undefined;
    city?: string | null | undefined;
    phone?: string | null | undefined;
    houseNumber?: string | null | undefined;
    zip?: string | null | undefined;
    country?: string | null | undefined;
    amountToInvest?: number | null | undefined;
    profileValid: boolean;
  };
};

export type ChangeUserEmailMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  currentPassword: Scalars['String']['input'];
}>;

export type ChangeUserEmailMutation = {
  __typename?: 'Mutation';
  changeCredentials: { __typename?: 'UserResponse'; id: string };
};

export type ChangeUserPasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
}>;

export type ChangeUserPasswordMutation = {
  __typename?: 'Mutation';
  changeCredentials: { __typename?: 'UserResponse'; id: string };
};

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;

export type ResetPasswordMutation = {
  __typename?: 'Mutation';
  resetPassword: { __typename?: 'ResetPasswordResponse'; success: boolean };
};

export type SendRestPasswordEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  captchaV2Token?: InputMaybe<Scalars['String']['input']>;
}>;

export type SendRestPasswordEmailMutation = {
  __typename?: 'Mutation';
  sendResetPasswordEmail: {
    __typename?: 'SendResetPasswordEmailResponse';
    success: boolean;
  };
};

export type RemoveAccountMutationVariables = Exact<{
  currentPassword?: InputMaybe<Scalars['String']['input']>;
}>;

export type RemoveAccountMutation = {
  __typename?: 'Mutation';
  removeUser: { __typename?: 'RemoveUserResponse'; success: boolean };
};

export const PortfolioRowDataFragmentDoc = gql`
  fragment portfolioRowData on PortfolioRowResponse {
    change24Amount
    usdChange24Amount
    change24Percentage
    usdChange24Percentage
    cost
    usdCost
    currency {
      id
      symbol
      title
      icon
      isFiat
      piechartColor
      messari
      eurValue
      usdValue
    }
    percentage
    amountCoins
  }
`;
export const PrivatePortfolioRowDataFragmentDoc = gql`
  fragment privatePortfolioRowData on PrivatePortfolioRowResponse {
    change24Amount
    usdChange24Amount
    change24Percentage
    usdChange24Percentage
    cost
    usdCost
    currency {
      id
      symbol
      title
      icon
      isFiat
      piechartColor
      messari
      eurValue
      usdValue
    }
    percentage
    amountCoins
  }
`;
export const ExpectedPortfolioRowDataFragmentDoc = gql`
  fragment expectedPortfolioRowData on ExpectedPortfolioRowResponse {
    change24Amount
    usdChange24Amount
    cost
    currentCost
    usdCost
    currency {
      id
      symbol
      title
      icon
      isFiat
      piechartColor
      messari
    }
    percentage
    amountCoins
    status
  }
`;
export const AllExchangesDataFragmentDoc = gql`
  fragment allExchangesData on UserExchangeResponse {
    exchangeID
    exchangeCode
    keysStatus
    wizardStatus
    fiatCurrencies {
      id
      symbol
    }
    targetForSaleCurrencies {
      id
      symbol
      isFiat
    }
    portfolioOutdated
    sentToRebalancing
    lastRebalanceReasonRequest
    lastRebalanceReasonResponse
    moneyUnderManagement
    aumBelowMinimum
    subscriptionInitiatedDate
    subscriptionStartDate
    nextRebalanceDate
    onlyFiatInPortfolio
  }
`;
export const CurrencyListItemDataFragmentDoc = gql`
  fragment currencyListItemData on PortfolioRowResponse {
    currency {
      id
      symbol
    }
  }
`;
export const CommonInvoiceDataFragmentDoc = gql`
  fragment commonInvoiceData on InvoiceResponse {
    id
    dueDate
    cost
    costExVat
    url
    status
  }
`;
export const InitialUserDataFragmentDoc = gql`
  fragment initialUserData on UserResponse {
    id
    isAdmin
    status
    companyName
    authProvider
    trialEndDate
    mollieStatus
    hasActiveSubscription
    hasUnpaidInvoices
    profileValid
    controlledByUser {
      id
    }
  }
`;
export const UserAdminStatusDataFragmentDoc = gql`
  fragment userAdminStatusData on UserResponse {
    id
    isAdmin
  }
`;
export const AdminUsersFiltersDataDocument = gql`
  query adminUsersFiltersData {
    getExchanges {
      id
      exchangeName
    }
    adminGetUsers {
      users {
        id
        country
        amountToInvest
      }
    }
  }
`;

/**
 * __useAdminUsersFiltersDataQuery__
 *
 * To run a query within a React component, call `useAdminUsersFiltersDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUsersFiltersDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUsersFiltersDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminUsersFiltersDataQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AdminUsersFiltersDataQuery,
    AdminUsersFiltersDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    AdminUsersFiltersDataQuery,
    AdminUsersFiltersDataQueryVariables
  >(AdminUsersFiltersDataDocument, options);
}
export function useAdminUsersFiltersDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AdminUsersFiltersDataQuery,
    AdminUsersFiltersDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    AdminUsersFiltersDataQuery,
    AdminUsersFiltersDataQueryVariables
  >(AdminUsersFiltersDataDocument, options);
}
// @ts-ignore
export function useAdminUsersFiltersDataSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AdminUsersFiltersDataQuery,
    AdminUsersFiltersDataQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  AdminUsersFiltersDataQuery,
  AdminUsersFiltersDataQueryVariables
>;
export function useAdminUsersFiltersDataSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AdminUsersFiltersDataQuery,
        AdminUsersFiltersDataQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  AdminUsersFiltersDataQuery | undefined,
  AdminUsersFiltersDataQueryVariables
>;
export function useAdminUsersFiltersDataSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AdminUsersFiltersDataQuery,
        AdminUsersFiltersDataQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    AdminUsersFiltersDataQuery,
    AdminUsersFiltersDataQueryVariables
  >(AdminUsersFiltersDataDocument, options);
}
export type AdminUsersFiltersDataQueryHookResult = ReturnType<
  typeof useAdminUsersFiltersDataQuery
>;
export type AdminUsersFiltersDataLazyQueryHookResult = ReturnType<
  typeof useAdminUsersFiltersDataLazyQuery
>;
export type AdminUsersFiltersDataSuspenseQueryHookResult = ReturnType<
  typeof useAdminUsersFiltersDataSuspenseQuery
>;
export type AdminUsersFiltersDataQueryResult = ApolloReactCommon.QueryResult<
  AdminUsersFiltersDataQuery,
  AdminUsersFiltersDataQueryVariables
>;
export function refetchAdminUsersFiltersDataQuery(
  variables?: AdminUsersFiltersDataQueryVariables
) {
  return { query: AdminUsersFiltersDataDocument, variables: variables };
}
export const AdminAllUsersDocument = gql`
  query adminAllUsers(
    $orderBy: [UsersOrderBy!]
    $atiFilter: Int
    $countries: [String!]
    $customStatusFilter: [CustomUserStatus!]
    $exchangeId: Int
    $email: String
    $username: String
    $userIDs: [Int!]
    $offset: Int
    $limit: Int
  ) {
    adminGetUsers(
      orderBy: $orderBy
      atiFilterLess: $atiFilter
      atiFilterMore: $atiFilter
      countries: $countries
      customStatusFilter: $customStatusFilter
      exchangeId: $exchangeId
      email: $email
      username: $username
      userIds: $userIDs
      offset: $offset
      limit: $limit
    ) {
      total
      totalAum
      totalPaid
      users {
        id
        authIdentities {
          provider
          uid
        }
        dateOfSignup
        firstName
        lastName
        phone
        customStatuses
        exchanges {
          exchangeID
          exchangeCode
          moneyUnderManagement
          keysStatus
          rebalancingDate
        }
        amountToInvest
        moneyPaid
        totpEnabled
        hasUnpaidInvoices
        hasActiveSubscription
        mollieStatus
        trialEndDate
      }
    }
    adminGetInvoices {
      activeTotal
    }
  }
`;

/**
 * __useAdminAllUsersQuery__
 *
 * To run a query within a React component, call `useAdminAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAllUsersQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      atiFilter: // value for 'atiFilter'
 *      countries: // value for 'countries'
 *      customStatusFilter: // value for 'customStatusFilter'
 *      exchangeId: // value for 'exchangeId'
 *      email: // value for 'email'
 *      username: // value for 'username'
 *      userIDs: // value for 'userIDs'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdminAllUsersQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AdminAllUsersQuery,
    AdminAllUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    AdminAllUsersQuery,
    AdminAllUsersQueryVariables
  >(AdminAllUsersDocument, options);
}
export function useAdminAllUsersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AdminAllUsersQuery,
    AdminAllUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    AdminAllUsersQuery,
    AdminAllUsersQueryVariables
  >(AdminAllUsersDocument, options);
}
// @ts-ignore
export function useAdminAllUsersSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AdminAllUsersQuery,
    AdminAllUsersQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  AdminAllUsersQuery,
  AdminAllUsersQueryVariables
>;
export function useAdminAllUsersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AdminAllUsersQuery,
        AdminAllUsersQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  AdminAllUsersQuery | undefined,
  AdminAllUsersQueryVariables
>;
export function useAdminAllUsersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AdminAllUsersQuery,
        AdminAllUsersQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    AdminAllUsersQuery,
    AdminAllUsersQueryVariables
  >(AdminAllUsersDocument, options);
}
export type AdminAllUsersQueryHookResult = ReturnType<
  typeof useAdminAllUsersQuery
>;
export type AdminAllUsersLazyQueryHookResult = ReturnType<
  typeof useAdminAllUsersLazyQuery
>;
export type AdminAllUsersSuspenseQueryHookResult = ReturnType<
  typeof useAdminAllUsersSuspenseQuery
>;
export type AdminAllUsersQueryResult = ApolloReactCommon.QueryResult<
  AdminAllUsersQuery,
  AdminAllUsersQueryVariables
>;
export function refetchAdminAllUsersQuery(
  variables?: AdminAllUsersQueryVariables
) {
  return { query: AdminAllUsersDocument, variables: variables };
}
export const AdminUserStatusAndActiveSubscriptionDocument = gql`
  query adminUserStatusAndActiveSubscription($userId: Int!) {
    adminGetUser(userId: $userId) {
      id
      status
      hasActiveSubscription
    }
  }
`;

/**
 * __useAdminUserStatusAndActiveSubscriptionQuery__
 *
 * To run a query within a React component, call `useAdminUserStatusAndActiveSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserStatusAndActiveSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserStatusAndActiveSubscriptionQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminUserStatusAndActiveSubscriptionQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    AdminUserStatusAndActiveSubscriptionQuery,
    AdminUserStatusAndActiveSubscriptionQueryVariables
  > &
    (
      | {
          variables: AdminUserStatusAndActiveSubscriptionQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    AdminUserStatusAndActiveSubscriptionQuery,
    AdminUserStatusAndActiveSubscriptionQueryVariables
  >(AdminUserStatusAndActiveSubscriptionDocument, options);
}
export function useAdminUserStatusAndActiveSubscriptionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AdminUserStatusAndActiveSubscriptionQuery,
    AdminUserStatusAndActiveSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    AdminUserStatusAndActiveSubscriptionQuery,
    AdminUserStatusAndActiveSubscriptionQueryVariables
  >(AdminUserStatusAndActiveSubscriptionDocument, options);
}
// @ts-ignore
export function useAdminUserStatusAndActiveSubscriptionSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AdminUserStatusAndActiveSubscriptionQuery,
    AdminUserStatusAndActiveSubscriptionQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  AdminUserStatusAndActiveSubscriptionQuery,
  AdminUserStatusAndActiveSubscriptionQueryVariables
>;
export function useAdminUserStatusAndActiveSubscriptionSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AdminUserStatusAndActiveSubscriptionQuery,
        AdminUserStatusAndActiveSubscriptionQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  AdminUserStatusAndActiveSubscriptionQuery | undefined,
  AdminUserStatusAndActiveSubscriptionQueryVariables
>;
export function useAdminUserStatusAndActiveSubscriptionSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AdminUserStatusAndActiveSubscriptionQuery,
        AdminUserStatusAndActiveSubscriptionQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    AdminUserStatusAndActiveSubscriptionQuery,
    AdminUserStatusAndActiveSubscriptionQueryVariables
  >(AdminUserStatusAndActiveSubscriptionDocument, options);
}
export type AdminUserStatusAndActiveSubscriptionQueryHookResult = ReturnType<
  typeof useAdminUserStatusAndActiveSubscriptionQuery
>;
export type AdminUserStatusAndActiveSubscriptionLazyQueryHookResult =
  ReturnType<typeof useAdminUserStatusAndActiveSubscriptionLazyQuery>;
export type AdminUserStatusAndActiveSubscriptionSuspenseQueryHookResult =
  ReturnType<typeof useAdminUserStatusAndActiveSubscriptionSuspenseQuery>;
export type AdminUserStatusAndActiveSubscriptionQueryResult =
  ApolloReactCommon.QueryResult<
    AdminUserStatusAndActiveSubscriptionQuery,
    AdminUserStatusAndActiveSubscriptionQueryVariables
  >;
export function refetchAdminUserStatusAndActiveSubscriptionQuery(
  variables: AdminUserStatusAndActiveSubscriptionQueryVariables
) {
  return {
    query: AdminUserStatusAndActiveSubscriptionDocument,
    variables: variables,
  };
}
export const AdminUsersFirstAndLastNamesDocument = gql`
  query adminUsersFirstAndLastNames {
    adminGetUsers {
      users {
        id
        firstName
        lastName
      }
    }
  }
`;

/**
 * __useAdminUsersFirstAndLastNamesQuery__
 *
 * To run a query within a React component, call `useAdminUsersFirstAndLastNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUsersFirstAndLastNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUsersFirstAndLastNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminUsersFirstAndLastNamesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AdminUsersFirstAndLastNamesQuery,
    AdminUsersFirstAndLastNamesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    AdminUsersFirstAndLastNamesQuery,
    AdminUsersFirstAndLastNamesQueryVariables
  >(AdminUsersFirstAndLastNamesDocument, options);
}
export function useAdminUsersFirstAndLastNamesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AdminUsersFirstAndLastNamesQuery,
    AdminUsersFirstAndLastNamesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    AdminUsersFirstAndLastNamesQuery,
    AdminUsersFirstAndLastNamesQueryVariables
  >(AdminUsersFirstAndLastNamesDocument, options);
}
// @ts-ignore
export function useAdminUsersFirstAndLastNamesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AdminUsersFirstAndLastNamesQuery,
    AdminUsersFirstAndLastNamesQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  AdminUsersFirstAndLastNamesQuery,
  AdminUsersFirstAndLastNamesQueryVariables
>;
export function useAdminUsersFirstAndLastNamesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AdminUsersFirstAndLastNamesQuery,
        AdminUsersFirstAndLastNamesQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  AdminUsersFirstAndLastNamesQuery | undefined,
  AdminUsersFirstAndLastNamesQueryVariables
>;
export function useAdminUsersFirstAndLastNamesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AdminUsersFirstAndLastNamesQuery,
        AdminUsersFirstAndLastNamesQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    AdminUsersFirstAndLastNamesQuery,
    AdminUsersFirstAndLastNamesQueryVariables
  >(AdminUsersFirstAndLastNamesDocument, options);
}
export type AdminUsersFirstAndLastNamesQueryHookResult = ReturnType<
  typeof useAdminUsersFirstAndLastNamesQuery
>;
export type AdminUsersFirstAndLastNamesLazyQueryHookResult = ReturnType<
  typeof useAdminUsersFirstAndLastNamesLazyQuery
>;
export type AdminUsersFirstAndLastNamesSuspenseQueryHookResult = ReturnType<
  typeof useAdminUsersFirstAndLastNamesSuspenseQuery
>;
export type AdminUsersFirstAndLastNamesQueryResult =
  ApolloReactCommon.QueryResult<
    AdminUsersFirstAndLastNamesQuery,
    AdminUsersFirstAndLastNamesQueryVariables
  >;
export function refetchAdminUsersFirstAndLastNamesQuery(
  variables?: AdminUsersFirstAndLastNamesQueryVariables
) {
  return { query: AdminUsersFirstAndLastNamesDocument, variables: variables };
}
export const AdminInvoicesDocument = gql`
  query adminInvoices(
    $ids: [Int!]
    $status: InvoicesFilterByStatus
    $orderBy: [InvoicesOrderBy!]
  ) {
    adminGetInvoices(usersIDs: $ids, statusFilter: $status, orderBy: $orderBy) {
      invoices {
        id
        dueDate
        cost
        costExVat
        url
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

/**
 * __useAdminInvoicesQuery__
 *
 * To run a query within a React component, call `useAdminInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminInvoicesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      status: // value for 'status'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAdminInvoicesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AdminInvoicesQuery,
    AdminInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    AdminInvoicesQuery,
    AdminInvoicesQueryVariables
  >(AdminInvoicesDocument, options);
}
export function useAdminInvoicesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AdminInvoicesQuery,
    AdminInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    AdminInvoicesQuery,
    AdminInvoicesQueryVariables
  >(AdminInvoicesDocument, options);
}
// @ts-ignore
export function useAdminInvoicesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AdminInvoicesQuery,
    AdminInvoicesQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  AdminInvoicesQuery,
  AdminInvoicesQueryVariables
>;
export function useAdminInvoicesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AdminInvoicesQuery,
        AdminInvoicesQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  AdminInvoicesQuery | undefined,
  AdminInvoicesQueryVariables
>;
export function useAdminInvoicesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AdminInvoicesQuery,
        AdminInvoicesQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    AdminInvoicesQuery,
    AdminInvoicesQueryVariables
  >(AdminInvoicesDocument, options);
}
export type AdminInvoicesQueryHookResult = ReturnType<
  typeof useAdminInvoicesQuery
>;
export type AdminInvoicesLazyQueryHookResult = ReturnType<
  typeof useAdminInvoicesLazyQuery
>;
export type AdminInvoicesSuspenseQueryHookResult = ReturnType<
  typeof useAdminInvoicesSuspenseQuery
>;
export type AdminInvoicesQueryResult = ApolloReactCommon.QueryResult<
  AdminInvoicesQuery,
  AdminInvoicesQueryVariables
>;
export function refetchAdminInvoicesQuery(
  variables?: AdminInvoicesQueryVariables
) {
  return { query: AdminInvoicesDocument, variables: variables };
}
export const AdminIndexPerformanceDocument = gql`
  query adminIndexPerformance {
    adminGetPerformance {
      rate24
      ytd
      year
      start
    }
  }
`;

/**
 * __useAdminIndexPerformanceQuery__
 *
 * To run a query within a React component, call `useAdminIndexPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminIndexPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminIndexPerformanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminIndexPerformanceQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AdminIndexPerformanceQuery,
    AdminIndexPerformanceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    AdminIndexPerformanceQuery,
    AdminIndexPerformanceQueryVariables
  >(AdminIndexPerformanceDocument, options);
}
export function useAdminIndexPerformanceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AdminIndexPerformanceQuery,
    AdminIndexPerformanceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    AdminIndexPerformanceQuery,
    AdminIndexPerformanceQueryVariables
  >(AdminIndexPerformanceDocument, options);
}
// @ts-ignore
export function useAdminIndexPerformanceSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AdminIndexPerformanceQuery,
    AdminIndexPerformanceQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  AdminIndexPerformanceQuery,
  AdminIndexPerformanceQueryVariables
>;
export function useAdminIndexPerformanceSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AdminIndexPerformanceQuery,
        AdminIndexPerformanceQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  AdminIndexPerformanceQuery | undefined,
  AdminIndexPerformanceQueryVariables
>;
export function useAdminIndexPerformanceSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AdminIndexPerformanceQuery,
        AdminIndexPerformanceQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    AdminIndexPerformanceQuery,
    AdminIndexPerformanceQueryVariables
  >(AdminIndexPerformanceDocument, options);
}
export type AdminIndexPerformanceQueryHookResult = ReturnType<
  typeof useAdminIndexPerformanceQuery
>;
export type AdminIndexPerformanceLazyQueryHookResult = ReturnType<
  typeof useAdminIndexPerformanceLazyQuery
>;
export type AdminIndexPerformanceSuspenseQueryHookResult = ReturnType<
  typeof useAdminIndexPerformanceSuspenseQuery
>;
export type AdminIndexPerformanceQueryResult = ApolloReactCommon.QueryResult<
  AdminIndexPerformanceQuery,
  AdminIndexPerformanceQueryVariables
>;
export function refetchAdminIndexPerformanceQuery(
  variables?: AdminIndexPerformanceQueryVariables
) {
  return { query: AdminIndexPerformanceDocument, variables: variables };
}
export const AdminDisableUsersTotpDocument = gql`
  mutation adminDisableUsersTOTP($userIDs: [Int!]!) {
    adminManageUsersTotp(enable: false, usersIDs: $userIDs) {
      id
      totpEnabled
    }
  }
`;
export type AdminDisableUsersTotpMutationFn =
  ApolloReactCommon.MutationFunction<
    AdminDisableUsersTotpMutation,
    AdminDisableUsersTotpMutationVariables
  >;

/**
 * __useAdminDisableUsersTotpMutation__
 *
 * To run a mutation, you first call `useAdminDisableUsersTotpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDisableUsersTotpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDisableUsersTotpMutation, { data, loading, error }] = useAdminDisableUsersTotpMutation({
 *   variables: {
 *      userIDs: // value for 'userIDs'
 *   },
 * });
 */
export function useAdminDisableUsersTotpMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AdminDisableUsersTotpMutation,
    AdminDisableUsersTotpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    AdminDisableUsersTotpMutation,
    AdminDisableUsersTotpMutationVariables
  >(AdminDisableUsersTotpDocument, options);
}
export type AdminDisableUsersTotpMutationHookResult = ReturnType<
  typeof useAdminDisableUsersTotpMutation
>;
export type AdminDisableUsersTotpMutationResult =
  ApolloReactCommon.MutationResult<AdminDisableUsersTotpMutation>;
export type AdminDisableUsersTotpMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AdminDisableUsersTotpMutation,
    AdminDisableUsersTotpMutationVariables
  >;
export const AdminCancelUserSubscriptionDocument = gql`
  mutation adminCancelUserSubscription($userId: Int!, $exchangeId: Int!) {
    AdminCancelUserSubscription(userID: $userId, exchangeId: $exchangeId) {
      id
      exchanges {
        exchangeID
        subscriptionStartDate
        wizardStatus
        moneyUnderManagement
        nextRebalanceDate
      }
    }
  }
`;
export type AdminCancelUserSubscriptionMutationFn =
  ApolloReactCommon.MutationFunction<
    AdminCancelUserSubscriptionMutation,
    AdminCancelUserSubscriptionMutationVariables
  >;

/**
 * __useAdminCancelUserSubscriptionMutation__
 *
 * To run a mutation, you first call `useAdminCancelUserSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCancelUserSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCancelUserSubscriptionMutation, { data, loading, error }] = useAdminCancelUserSubscriptionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      exchangeId: // value for 'exchangeId'
 *   },
 * });
 */
export function useAdminCancelUserSubscriptionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AdminCancelUserSubscriptionMutation,
    AdminCancelUserSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    AdminCancelUserSubscriptionMutation,
    AdminCancelUserSubscriptionMutationVariables
  >(AdminCancelUserSubscriptionDocument, options);
}
export type AdminCancelUserSubscriptionMutationHookResult = ReturnType<
  typeof useAdminCancelUserSubscriptionMutation
>;
export type AdminCancelUserSubscriptionMutationResult =
  ApolloReactCommon.MutationResult<AdminCancelUserSubscriptionMutation>;
export type AdminCancelUserSubscriptionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AdminCancelUserSubscriptionMutation,
    AdminCancelUserSubscriptionMutationVariables
  >;
export const AdminSignInAsDocument = gql`
  mutation adminSignInAs($userId: Int!) {
    adminSignInAs(userID: $userId) {
      token
      authIdentityID
    }
  }
`;
export type AdminSignInAsMutationFn = ApolloReactCommon.MutationFunction<
  AdminSignInAsMutation,
  AdminSignInAsMutationVariables
>;

/**
 * __useAdminSignInAsMutation__
 *
 * To run a mutation, you first call `useAdminSignInAsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSignInAsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSignInAsMutation, { data, loading, error }] = useAdminSignInAsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminSignInAsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AdminSignInAsMutation,
    AdminSignInAsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    AdminSignInAsMutation,
    AdminSignInAsMutationVariables
  >(AdminSignInAsDocument, options);
}
export type AdminSignInAsMutationHookResult = ReturnType<
  typeof useAdminSignInAsMutation
>;
export type AdminSignInAsMutationResult =
  ApolloReactCommon.MutationResult<AdminSignInAsMutation>;
export type AdminSignInAsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AdminSignInAsMutation,
    AdminSignInAsMutationVariables
  >;
export const AdminSignOutAsDocument = gql`
  mutation adminSignOutAs {
    adminSignOutAs {
      token
      authIdentityID
    }
  }
`;
export type AdminSignOutAsMutationFn = ApolloReactCommon.MutationFunction<
  AdminSignOutAsMutation,
  AdminSignOutAsMutationVariables
>;

/**
 * __useAdminSignOutAsMutation__
 *
 * To run a mutation, you first call `useAdminSignOutAsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSignOutAsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSignOutAsMutation, { data, loading, error }] = useAdminSignOutAsMutation({
 *   variables: {
 *   },
 * });
 */
export function useAdminSignOutAsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AdminSignOutAsMutation,
    AdminSignOutAsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    AdminSignOutAsMutation,
    AdminSignOutAsMutationVariables
  >(AdminSignOutAsDocument, options);
}
export type AdminSignOutAsMutationHookResult = ReturnType<
  typeof useAdminSignOutAsMutation
>;
export type AdminSignOutAsMutationResult =
  ApolloReactCommon.MutationResult<AdminSignOutAsMutation>;
export type AdminSignOutAsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AdminSignOutAsMutation,
    AdminSignOutAsMutationVariables
  >;
export const SendAdminEmailsDocument = gql`
  mutation sendAdminEmails(
    $templateId: String!
    $userIDs: [Int!]
    $atiFilter: Int
    $countries: [String!]
    $exchangeId: Int
    $customStatusFilter: [CustomUserStatus!]
    $email: String
    $username: String
  ) {
    adminSendEmail(
      templateId: $templateId
      userIds: $userIDs
      atiFilterLess: $atiFilter
      atiFilterMore: $atiFilter
      countries: $countries
      exchangeId: $exchangeId
      customStatusFilter: $customStatusFilter
      email: $email
      username: $username
    )
  }
`;
export type SendAdminEmailsMutationFn = ApolloReactCommon.MutationFunction<
  SendAdminEmailsMutation,
  SendAdminEmailsMutationVariables
>;

/**
 * __useSendAdminEmailsMutation__
 *
 * To run a mutation, you first call `useSendAdminEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAdminEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAdminEmailsMutation, { data, loading, error }] = useSendAdminEmailsMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      userIDs: // value for 'userIDs'
 *      atiFilter: // value for 'atiFilter'
 *      countries: // value for 'countries'
 *      exchangeId: // value for 'exchangeId'
 *      customStatusFilter: // value for 'customStatusFilter'
 *      email: // value for 'email'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useSendAdminEmailsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendAdminEmailsMutation,
    SendAdminEmailsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    SendAdminEmailsMutation,
    SendAdminEmailsMutationVariables
  >(SendAdminEmailsDocument, options);
}
export type SendAdminEmailsMutationHookResult = ReturnType<
  typeof useSendAdminEmailsMutation
>;
export type SendAdminEmailsMutationResult =
  ApolloReactCommon.MutationResult<SendAdminEmailsMutation>;
export type SendAdminEmailsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SendAdminEmailsMutation,
    SendAdminEmailsMutationVariables
  >;
export const AdminRebalanceUserDocument = gql`
  mutation adminRebalanceUser($userId: Int!, $exchangeId: Int!) {
    adminRebalanceUser(userID: $userId, exchangeId: $exchangeId) {
      id
      nextRebalancingOn
    }
  }
`;
export type AdminRebalanceUserMutationFn = ApolloReactCommon.MutationFunction<
  AdminRebalanceUserMutation,
  AdminRebalanceUserMutationVariables
>;

/**
 * __useAdminRebalanceUserMutation__
 *
 * To run a mutation, you first call `useAdminRebalanceUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRebalanceUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRebalanceUserMutation, { data, loading, error }] = useAdminRebalanceUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      exchangeId: // value for 'exchangeId'
 *   },
 * });
 */
export function useAdminRebalanceUserMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AdminRebalanceUserMutation,
    AdminRebalanceUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    AdminRebalanceUserMutation,
    AdminRebalanceUserMutationVariables
  >(AdminRebalanceUserDocument, options);
}
export type AdminRebalanceUserMutationHookResult = ReturnType<
  typeof useAdminRebalanceUserMutation
>;
export type AdminRebalanceUserMutationResult =
  ApolloReactCommon.MutationResult<AdminRebalanceUserMutation>;
export type AdminRebalanceUserMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AdminRebalanceUserMutation,
    AdminRebalanceUserMutationVariables
  >;
export const AdminRemoveUserKeysDocument = gql`
  mutation adminRemoveUserKeys($userId: Int!, $exchangeId: Int!) {
    adminRemoveKeys(userID: $userId, exchangeId: $exchangeId) {
      id
      status
      exchanges {
        exchangeID
        exchangeCode
        keysStatus
        moneyUnderManagement
      }
      hasActiveSubscription
      nextRebalancingOn
    }
  }
`;
export type AdminRemoveUserKeysMutationFn = ApolloReactCommon.MutationFunction<
  AdminRemoveUserKeysMutation,
  AdminRemoveUserKeysMutationVariables
>;

/**
 * __useAdminRemoveUserKeysMutation__
 *
 * To run a mutation, you first call `useAdminRemoveUserKeysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRemoveUserKeysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRemoveUserKeysMutation, { data, loading, error }] = useAdminRemoveUserKeysMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      exchangeId: // value for 'exchangeId'
 *   },
 * });
 */
export function useAdminRemoveUserKeysMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AdminRemoveUserKeysMutation,
    AdminRemoveUserKeysMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    AdminRemoveUserKeysMutation,
    AdminRemoveUserKeysMutationVariables
  >(AdminRemoveUserKeysDocument, options);
}
export type AdminRemoveUserKeysMutationHookResult = ReturnType<
  typeof useAdminRemoveUserKeysMutation
>;
export type AdminRemoveUserKeysMutationResult =
  ApolloReactCommon.MutationResult<AdminRemoveUserKeysMutation>;
export type AdminRemoveUserKeysMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AdminRemoveUserKeysMutation,
    AdminRemoveUserKeysMutationVariables
  >;
export const AppBarDataDocument = gql`
  query appBarData {
    getUser {
      id
      firstName
      lastName
      isAdmin
    }
  }
`;

/**
 * __useAppBarDataQuery__
 *
 * To run a query within a React component, call `useAppBarDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppBarDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppBarDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppBarDataQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AppBarDataQuery,
    AppBarDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<AppBarDataQuery, AppBarDataQueryVariables>(
    AppBarDataDocument,
    options
  );
}
export function useAppBarDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AppBarDataQuery,
    AppBarDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    AppBarDataQuery,
    AppBarDataQueryVariables
  >(AppBarDataDocument, options);
}
// @ts-ignore
export function useAppBarDataSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AppBarDataQuery,
    AppBarDataQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  AppBarDataQuery,
  AppBarDataQueryVariables
>;
export function useAppBarDataSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AppBarDataQuery,
        AppBarDataQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  AppBarDataQuery | undefined,
  AppBarDataQueryVariables
>;
export function useAppBarDataSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AppBarDataQuery,
        AppBarDataQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    AppBarDataQuery,
    AppBarDataQueryVariables
  >(AppBarDataDocument, options);
}
export type AppBarDataQueryHookResult = ReturnType<typeof useAppBarDataQuery>;
export type AppBarDataLazyQueryHookResult = ReturnType<
  typeof useAppBarDataLazyQuery
>;
export type AppBarDataSuspenseQueryHookResult = ReturnType<
  typeof useAppBarDataSuspenseQuery
>;
export type AppBarDataQueryResult = ApolloReactCommon.QueryResult<
  AppBarDataQuery,
  AppBarDataQueryVariables
>;
export function refetchAppBarDataQuery(variables?: AppBarDataQueryVariables) {
  return { query: AppBarDataDocument, variables: variables };
}
export const AppMenuDataDocument = gql`
  query appMenuData {
    getUser {
      id
      isAdmin
      controlledByUser {
        id
      }
    }
  }
`;

/**
 * __useAppMenuDataQuery__
 *
 * To run a query within a React component, call `useAppMenuDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppMenuDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppMenuDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppMenuDataQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    AppMenuDataQuery,
    AppMenuDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<AppMenuDataQuery, AppMenuDataQueryVariables>(
    AppMenuDataDocument,
    options
  );
}
export function useAppMenuDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    AppMenuDataQuery,
    AppMenuDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    AppMenuDataQuery,
    AppMenuDataQueryVariables
  >(AppMenuDataDocument, options);
}
// @ts-ignore
export function useAppMenuDataSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    AppMenuDataQuery,
    AppMenuDataQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  AppMenuDataQuery,
  AppMenuDataQueryVariables
>;
export function useAppMenuDataSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AppMenuDataQuery,
        AppMenuDataQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  AppMenuDataQuery | undefined,
  AppMenuDataQueryVariables
>;
export function useAppMenuDataSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        AppMenuDataQuery,
        AppMenuDataQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    AppMenuDataQuery,
    AppMenuDataQueryVariables
  >(AppMenuDataDocument, options);
}
export type AppMenuDataQueryHookResult = ReturnType<typeof useAppMenuDataQuery>;
export type AppMenuDataLazyQueryHookResult = ReturnType<
  typeof useAppMenuDataLazyQuery
>;
export type AppMenuDataSuspenseQueryHookResult = ReturnType<
  typeof useAppMenuDataSuspenseQuery
>;
export type AppMenuDataQueryResult = ApolloReactCommon.QueryResult<
  AppMenuDataQuery,
  AppMenuDataQueryVariables
>;
export function refetchAppMenuDataQuery(variables?: AppMenuDataQueryVariables) {
  return { query: AppMenuDataDocument, variables: variables };
}
export const SignInDocument = gql`
  mutation signIn(
    $email: String!
    $password: String!
    $remember: Boolean!
    $captchaToken: String
    $captchaV2Token: String
  ) {
    signIn(
      email: $email
      password: $password
      remember: $remember
      captchaToken: $captchaToken
      captchaV2Token: $captchaV2Token
    ) {
      token
      totpEnabled
      authIdentityID
    }
  }
`;
export type SignInMutationFn = ApolloReactCommon.MutationFunction<
  SignInMutation,
  SignInMutationVariables
>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      remember: // value for 'remember'
 *      captchaToken: // value for 'captchaToken'
 *      captchaV2Token: // value for 'captchaV2Token'
 *   },
 * });
 */
export function useSignInMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SignInMutation,
    SignInMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<SignInMutation, SignInMutationVariables>(
    SignInDocument,
    options
  );
}
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult =
  ApolloReactCommon.MutationResult<SignInMutation>;
export type SignInMutationOptions = ApolloReactCommon.BaseMutationOptions<
  SignInMutation,
  SignInMutationVariables
>;
export const SignUpDocument = gql`
  mutation signUp(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
    $confPassword: String!
    $referralCode: String
    $captchaToken: String
    $captchaV2Token: String
  ) {
    signUp(
      firstName: $firstName
      lastName: $lastName
      email: $email
      password: $password
      passwordRepeat: $confPassword
      referralCode: $referralCode
      captchaToken: $captchaToken
      captchaV2Token: $captchaV2Token
    ) {
      token
      authIdentityId
    }
  }
`;
export type SignUpMutationFn = ApolloReactCommon.MutationFunction<
  SignUpMutation,
  SignUpMutationVariables
>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      confPassword: // value for 'confPassword'
 *      referralCode: // value for 'referralCode'
 *      captchaToken: // value for 'captchaToken'
 *      captchaV2Token: // value for 'captchaV2Token'
 *   },
 * });
 */
export function useSignUpMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SignUpMutation,
    SignUpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<SignUpMutation, SignUpMutationVariables>(
    SignUpDocument,
    options
  );
}
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult =
  ApolloReactCommon.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = ApolloReactCommon.BaseMutationOptions<
  SignUpMutation,
  SignUpMutationVariables
>;
export const GoogleSignInDocument = gql`
  mutation googleSignIn($token: String!) {
    googleSignIn(token: $token) {
      token
      totpEnabled
      authIdentityID
    }
  }
`;
export type GoogleSignInMutationFn = ApolloReactCommon.MutationFunction<
  GoogleSignInMutation,
  GoogleSignInMutationVariables
>;

/**
 * __useGoogleSignInMutation__
 *
 * To run a mutation, you first call `useGoogleSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleSignInMutation, { data, loading, error }] = useGoogleSignInMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGoogleSignInMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    GoogleSignInMutation,
    GoogleSignInMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    GoogleSignInMutation,
    GoogleSignInMutationVariables
  >(GoogleSignInDocument, options);
}
export type GoogleSignInMutationHookResult = ReturnType<
  typeof useGoogleSignInMutation
>;
export type GoogleSignInMutationResult =
  ApolloReactCommon.MutationResult<GoogleSignInMutation>;
export type GoogleSignInMutationOptions = ApolloReactCommon.BaseMutationOptions<
  GoogleSignInMutation,
  GoogleSignInMutationVariables
>;
export const GoogleSignUpDocument = gql`
  mutation googleSignUp($token: String!) {
    googleSignUp(token: $token) {
      token
      totpEnabled
      authIdentityID
    }
  }
`;
export type GoogleSignUpMutationFn = ApolloReactCommon.MutationFunction<
  GoogleSignUpMutation,
  GoogleSignUpMutationVariables
>;

/**
 * __useGoogleSignUpMutation__
 *
 * To run a mutation, you first call `useGoogleSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleSignUpMutation, { data, loading, error }] = useGoogleSignUpMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGoogleSignUpMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    GoogleSignUpMutation,
    GoogleSignUpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    GoogleSignUpMutation,
    GoogleSignUpMutationVariables
  >(GoogleSignUpDocument, options);
}
export type GoogleSignUpMutationHookResult = ReturnType<
  typeof useGoogleSignUpMutation
>;
export type GoogleSignUpMutationResult =
  ApolloReactCommon.MutationResult<GoogleSignUpMutation>;
export type GoogleSignUpMutationOptions = ApolloReactCommon.BaseMutationOptions<
  GoogleSignUpMutation,
  GoogleSignUpMutationVariables
>;
export const SignOutDocument = gql`
  mutation signOut {
    signOut {
      success
    }
  }
`;
export type SignOutMutationFn = ApolloReactCommon.MutationFunction<
  SignOutMutation,
  SignOutMutationVariables
>;

/**
 * __useSignOutMutation__
 *
 * To run a mutation, you first call `useSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutMutation, { data, loading, error }] = useSignOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SignOutMutation,
    SignOutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    SignOutMutation,
    SignOutMutationVariables
  >(SignOutDocument, options);
}
export type SignOutMutationHookResult = ReturnType<typeof useSignOutMutation>;
export type SignOutMutationResult =
  ApolloReactCommon.MutationResult<SignOutMutation>;
export type SignOutMutationOptions = ApolloReactCommon.BaseMutationOptions<
  SignOutMutation,
  SignOutMutationVariables
>;
export const UpdatePortfolioPopupWasShownDocument = gql`
  query updatePortfolioPopupWasShown {
    updatePortfolioPopupWasShown @client
  }
`;

/**
 * __useUpdatePortfolioPopupWasShownQuery__
 *
 * To run a query within a React component, call `useUpdatePortfolioPopupWasShownQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioPopupWasShownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatePortfolioPopupWasShownQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpdatePortfolioPopupWasShownQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UpdatePortfolioPopupWasShownQuery,
    UpdatePortfolioPopupWasShownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    UpdatePortfolioPopupWasShownQuery,
    UpdatePortfolioPopupWasShownQueryVariables
  >(UpdatePortfolioPopupWasShownDocument, options);
}
export function useUpdatePortfolioPopupWasShownLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UpdatePortfolioPopupWasShownQuery,
    UpdatePortfolioPopupWasShownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    UpdatePortfolioPopupWasShownQuery,
    UpdatePortfolioPopupWasShownQueryVariables
  >(UpdatePortfolioPopupWasShownDocument, options);
}
// @ts-ignore
export function useUpdatePortfolioPopupWasShownSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    UpdatePortfolioPopupWasShownQuery,
    UpdatePortfolioPopupWasShownQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  UpdatePortfolioPopupWasShownQuery,
  UpdatePortfolioPopupWasShownQueryVariables
>;
export function useUpdatePortfolioPopupWasShownSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UpdatePortfolioPopupWasShownQuery,
        UpdatePortfolioPopupWasShownQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  UpdatePortfolioPopupWasShownQuery | undefined,
  UpdatePortfolioPopupWasShownQueryVariables
>;
export function useUpdatePortfolioPopupWasShownSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UpdatePortfolioPopupWasShownQuery,
        UpdatePortfolioPopupWasShownQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    UpdatePortfolioPopupWasShownQuery,
    UpdatePortfolioPopupWasShownQueryVariables
  >(UpdatePortfolioPopupWasShownDocument, options);
}
export type UpdatePortfolioPopupWasShownQueryHookResult = ReturnType<
  typeof useUpdatePortfolioPopupWasShownQuery
>;
export type UpdatePortfolioPopupWasShownLazyQueryHookResult = ReturnType<
  typeof useUpdatePortfolioPopupWasShownLazyQuery
>;
export type UpdatePortfolioPopupWasShownSuspenseQueryHookResult = ReturnType<
  typeof useUpdatePortfolioPopupWasShownSuspenseQuery
>;
export type UpdatePortfolioPopupWasShownQueryResult =
  ApolloReactCommon.QueryResult<
    UpdatePortfolioPopupWasShownQuery,
    UpdatePortfolioPopupWasShownQueryVariables
  >;
export function refetchUpdatePortfolioPopupWasShownQuery(
  variables?: UpdatePortfolioPopupWasShownQueryVariables
) {
  return { query: UpdatePortfolioPopupWasShownDocument, variables: variables };
}
export const DashboardDataDocument = gql`
  query dashboardData($exchangeId: Int!) {
    getPortfolioGraphData(exchangeId: $exchangeId) {
      date
      value
    }
    getPortfolioTotals(exchangeId: $exchangeId) {
      eurCostTotal
      eurCostChange24Total
      eurCostChange24Percentage
      usdCostTotal
      usdCostChange24total
      usdCostChange24Percentage
    }
    getIndexPortfolio(exchangeId: $exchangeId) {
      ...portfolioRowData
    }
    getPrivatePortfolio(exchangeId: $exchangeId, tradableOnly: false) {
      ...privatePortfolioRowData
    }
  }
  ${PortfolioRowDataFragmentDoc}
  ${PrivatePortfolioRowDataFragmentDoc}
`;

/**
 * __useDashboardDataQuery__
 *
 * To run a query within a React component, call `useDashboardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardDataQuery({
 *   variables: {
 *      exchangeId: // value for 'exchangeId'
 *   },
 * });
 */
export function useDashboardDataQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    DashboardDataQuery,
    DashboardDataQueryVariables
  > &
    (
      | { variables: DashboardDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    DashboardDataQuery,
    DashboardDataQueryVariables
  >(DashboardDataDocument, options);
}
export function useDashboardDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    DashboardDataQuery,
    DashboardDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    DashboardDataQuery,
    DashboardDataQueryVariables
  >(DashboardDataDocument, options);
}
// @ts-ignore
export function useDashboardDataSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    DashboardDataQuery,
    DashboardDataQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  DashboardDataQuery,
  DashboardDataQueryVariables
>;
export function useDashboardDataSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        DashboardDataQuery,
        DashboardDataQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  DashboardDataQuery | undefined,
  DashboardDataQueryVariables
>;
export function useDashboardDataSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        DashboardDataQuery,
        DashboardDataQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    DashboardDataQuery,
    DashboardDataQueryVariables
  >(DashboardDataDocument, options);
}
export type DashboardDataQueryHookResult = ReturnType<
  typeof useDashboardDataQuery
>;
export type DashboardDataLazyQueryHookResult = ReturnType<
  typeof useDashboardDataLazyQuery
>;
export type DashboardDataSuspenseQueryHookResult = ReturnType<
  typeof useDashboardDataSuspenseQuery
>;
export type DashboardDataQueryResult = ApolloReactCommon.QueryResult<
  DashboardDataQuery,
  DashboardDataQueryVariables
>;
export function refetchDashboardDataQuery(
  variables: DashboardDataQueryVariables
) {
  return { query: DashboardDataDocument, variables: variables };
}
export const PortfolioCurrencyDocument = gql`
  query portfolioCurrency {
    portfolioCurrency @client
  }
`;

/**
 * __usePortfolioCurrencyQuery__
 *
 * To run a query within a React component, call `usePortfolioCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfolioCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfolioCurrencyQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortfolioCurrencyQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PortfolioCurrencyQuery,
    PortfolioCurrencyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    PortfolioCurrencyQuery,
    PortfolioCurrencyQueryVariables
  >(PortfolioCurrencyDocument, options);
}
export function usePortfolioCurrencyLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PortfolioCurrencyQuery,
    PortfolioCurrencyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    PortfolioCurrencyQuery,
    PortfolioCurrencyQueryVariables
  >(PortfolioCurrencyDocument, options);
}
// @ts-ignore
export function usePortfolioCurrencySuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    PortfolioCurrencyQuery,
    PortfolioCurrencyQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  PortfolioCurrencyQuery,
  PortfolioCurrencyQueryVariables
>;
export function usePortfolioCurrencySuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        PortfolioCurrencyQuery,
        PortfolioCurrencyQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  PortfolioCurrencyQuery | undefined,
  PortfolioCurrencyQueryVariables
>;
export function usePortfolioCurrencySuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        PortfolioCurrencyQuery,
        PortfolioCurrencyQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    PortfolioCurrencyQuery,
    PortfolioCurrencyQueryVariables
  >(PortfolioCurrencyDocument, options);
}
export type PortfolioCurrencyQueryHookResult = ReturnType<
  typeof usePortfolioCurrencyQuery
>;
export type PortfolioCurrencyLazyQueryHookResult = ReturnType<
  typeof usePortfolioCurrencyLazyQuery
>;
export type PortfolioCurrencySuspenseQueryHookResult = ReturnType<
  typeof usePortfolioCurrencySuspenseQuery
>;
export type PortfolioCurrencyQueryResult = ApolloReactCommon.QueryResult<
  PortfolioCurrencyQuery,
  PortfolioCurrencyQueryVariables
>;
export function refetchPortfolioCurrencyQuery(
  variables?: PortfolioCurrencyQueryVariables
) {
  return { query: PortfolioCurrencyDocument, variables: variables };
}
export const ExpectedPortfolioDocument = gql`
  query expectedPortfolio($exchangeId: Int!) {
    getExpectedPortfolio(exchangeId: $exchangeId) {
      ...expectedPortfolioRowData
    }
  }
  ${ExpectedPortfolioRowDataFragmentDoc}
`;

/**
 * __useExpectedPortfolioQuery__
 *
 * To run a query within a React component, call `useExpectedPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpectedPortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpectedPortfolioQuery({
 *   variables: {
 *      exchangeId: // value for 'exchangeId'
 *   },
 * });
 */
export function useExpectedPortfolioQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ExpectedPortfolioQuery,
    ExpectedPortfolioQueryVariables
  > &
    (
      | { variables: ExpectedPortfolioQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    ExpectedPortfolioQuery,
    ExpectedPortfolioQueryVariables
  >(ExpectedPortfolioDocument, options);
}
export function useExpectedPortfolioLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ExpectedPortfolioQuery,
    ExpectedPortfolioQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    ExpectedPortfolioQuery,
    ExpectedPortfolioQueryVariables
  >(ExpectedPortfolioDocument, options);
}
// @ts-ignore
export function useExpectedPortfolioSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    ExpectedPortfolioQuery,
    ExpectedPortfolioQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  ExpectedPortfolioQuery,
  ExpectedPortfolioQueryVariables
>;
export function useExpectedPortfolioSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        ExpectedPortfolioQuery,
        ExpectedPortfolioQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  ExpectedPortfolioQuery | undefined,
  ExpectedPortfolioQueryVariables
>;
export function useExpectedPortfolioSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        ExpectedPortfolioQuery,
        ExpectedPortfolioQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    ExpectedPortfolioQuery,
    ExpectedPortfolioQueryVariables
  >(ExpectedPortfolioDocument, options);
}
export type ExpectedPortfolioQueryHookResult = ReturnType<
  typeof useExpectedPortfolioQuery
>;
export type ExpectedPortfolioLazyQueryHookResult = ReturnType<
  typeof useExpectedPortfolioLazyQuery
>;
export type ExpectedPortfolioSuspenseQueryHookResult = ReturnType<
  typeof useExpectedPortfolioSuspenseQuery
>;
export type ExpectedPortfolioQueryResult = ApolloReactCommon.QueryResult<
  ExpectedPortfolioQuery,
  ExpectedPortfolioQueryVariables
>;
export function refetchExpectedPortfolioQuery(
  variables: ExpectedPortfolioQueryVariables
) {
  return { query: ExpectedPortfolioDocument, variables: variables };
}
export const CurrencyPercentageCostDocument = gql`
  query currencyPercentageCost(
    $partitionAction: PortfolioPartitionAction!
    $exchangeId: Int!
    $currencies: [CurrencyInput!]!
  ) {
    getPortfolioCurrencyPercentageCost(
      partitionAction: $partitionAction
      exchangeId: $exchangeId
      currencies: $currencies
    ) {
      amount
    }
  }
`;

/**
 * __useCurrencyPercentageCostQuery__
 *
 * To run a query within a React component, call `useCurrencyPercentageCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrencyPercentageCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrencyPercentageCostQuery({
 *   variables: {
 *      partitionAction: // value for 'partitionAction'
 *      exchangeId: // value for 'exchangeId'
 *      currencies: // value for 'currencies'
 *   },
 * });
 */
export function useCurrencyPercentageCostQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    CurrencyPercentageCostQuery,
    CurrencyPercentageCostQueryVariables
  > &
    (
      | { variables: CurrencyPercentageCostQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    CurrencyPercentageCostQuery,
    CurrencyPercentageCostQueryVariables
  >(CurrencyPercentageCostDocument, options);
}
export function useCurrencyPercentageCostLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CurrencyPercentageCostQuery,
    CurrencyPercentageCostQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    CurrencyPercentageCostQuery,
    CurrencyPercentageCostQueryVariables
  >(CurrencyPercentageCostDocument, options);
}
// @ts-ignore
export function useCurrencyPercentageCostSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    CurrencyPercentageCostQuery,
    CurrencyPercentageCostQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  CurrencyPercentageCostQuery,
  CurrencyPercentageCostQueryVariables
>;
export function useCurrencyPercentageCostSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        CurrencyPercentageCostQuery,
        CurrencyPercentageCostQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  CurrencyPercentageCostQuery | undefined,
  CurrencyPercentageCostQueryVariables
>;
export function useCurrencyPercentageCostSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        CurrencyPercentageCostQuery,
        CurrencyPercentageCostQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    CurrencyPercentageCostQuery,
    CurrencyPercentageCostQueryVariables
  >(CurrencyPercentageCostDocument, options);
}
export type CurrencyPercentageCostQueryHookResult = ReturnType<
  typeof useCurrencyPercentageCostQuery
>;
export type CurrencyPercentageCostLazyQueryHookResult = ReturnType<
  typeof useCurrencyPercentageCostLazyQuery
>;
export type CurrencyPercentageCostSuspenseQueryHookResult = ReturnType<
  typeof useCurrencyPercentageCostSuspenseQuery
>;
export type CurrencyPercentageCostQueryResult = ApolloReactCommon.QueryResult<
  CurrencyPercentageCostQuery,
  CurrencyPercentageCostQueryVariables
>;
export function refetchCurrencyPercentageCostQuery(
  variables: CurrencyPercentageCostQueryVariables
) {
  return { query: CurrencyPercentageCostDocument, variables: variables };
}
export const PortfolioLiquidateDocument = gql`
  mutation portfolioLiquidate(
    $exchangeId: Int!
    $currencyId: Int!
    $percent: Float!
  ) {
    portfolioLiquidation(
      exchangeId: $exchangeId
      currencyId: $currencyId
      percents: $percent
    ) {
      id
    }
  }
`;
export type PortfolioLiquidateMutationFn = ApolloReactCommon.MutationFunction<
  PortfolioLiquidateMutation,
  PortfolioLiquidateMutationVariables
>;

/**
 * __usePortfolioLiquidateMutation__
 *
 * To run a mutation, you first call `usePortfolioLiquidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortfolioLiquidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portfolioLiquidateMutation, { data, loading, error }] = usePortfolioLiquidateMutation({
 *   variables: {
 *      exchangeId: // value for 'exchangeId'
 *      currencyId: // value for 'currencyId'
 *      percent: // value for 'percent'
 *   },
 * });
 */
export function usePortfolioLiquidateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    PortfolioLiquidateMutation,
    PortfolioLiquidateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    PortfolioLiquidateMutation,
    PortfolioLiquidateMutationVariables
  >(PortfolioLiquidateDocument, options);
}
export type PortfolioLiquidateMutationHookResult = ReturnType<
  typeof usePortfolioLiquidateMutation
>;
export type PortfolioLiquidateMutationResult =
  ApolloReactCommon.MutationResult<PortfolioLiquidateMutation>;
export type PortfolioLiquidateMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    PortfolioLiquidateMutation,
    PortfolioLiquidateMutationVariables
  >;
export const PortfolioDepositDocument = gql`
  mutation portfolioDeposit($exchangeId: Int!, $currencies: [CurrencyInput!]!) {
    depositAmount(exchangeId: $exchangeId, currencies: $currencies) {
      id
    }
  }
`;
export type PortfolioDepositMutationFn = ApolloReactCommon.MutationFunction<
  PortfolioDepositMutation,
  PortfolioDepositMutationVariables
>;

/**
 * __usePortfolioDepositMutation__
 *
 * To run a mutation, you first call `usePortfolioDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortfolioDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portfolioDepositMutation, { data, loading, error }] = usePortfolioDepositMutation({
 *   variables: {
 *      exchangeId: // value for 'exchangeId'
 *      currencies: // value for 'currencies'
 *   },
 * });
 */
export function usePortfolioDepositMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    PortfolioDepositMutation,
    PortfolioDepositMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    PortfolioDepositMutation,
    PortfolioDepositMutationVariables
  >(PortfolioDepositDocument, options);
}
export type PortfolioDepositMutationHookResult = ReturnType<
  typeof usePortfolioDepositMutation
>;
export type PortfolioDepositMutationResult =
  ApolloReactCommon.MutationResult<PortfolioDepositMutation>;
export type PortfolioDepositMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    PortfolioDepositMutation,
    PortfolioDepositMutationVariables
  >;
export const PortfolioRebalanceDocument = gql`
  mutation portfolioRebalance($exchangeId: Int!) {
    portfolioRebalance(exchangeId: $exchangeId) {
      id
    }
  }
`;
export type PortfolioRebalanceMutationFn = ApolloReactCommon.MutationFunction<
  PortfolioRebalanceMutation,
  PortfolioRebalanceMutationVariables
>;

/**
 * __usePortfolioRebalanceMutation__
 *
 * To run a mutation, you first call `usePortfolioRebalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortfolioRebalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portfolioRebalanceMutation, { data, loading, error }] = usePortfolioRebalanceMutation({
 *   variables: {
 *      exchangeId: // value for 'exchangeId'
 *   },
 * });
 */
export function usePortfolioRebalanceMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    PortfolioRebalanceMutation,
    PortfolioRebalanceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    PortfolioRebalanceMutation,
    PortfolioRebalanceMutationVariables
  >(PortfolioRebalanceDocument, options);
}
export type PortfolioRebalanceMutationHookResult = ReturnType<
  typeof usePortfolioRebalanceMutation
>;
export type PortfolioRebalanceMutationResult =
  ApolloReactCommon.MutationResult<PortfolioRebalanceMutation>;
export type PortfolioRebalanceMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    PortfolioRebalanceMutation,
    PortfolioRebalanceMutationVariables
  >;
export const UserExchangeProviderDataDocument = gql`
  query userExchangeProviderData {
    getUser {
      id
      isAdmin
      profileValid
    }
    selectedExchange @client
    getUserExchanges {
      ...allExchangesData
    }
  }
  ${AllExchangesDataFragmentDoc}
`;

/**
 * __useUserExchangeProviderDataQuery__
 *
 * To run a query within a React component, call `useUserExchangeProviderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserExchangeProviderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserExchangeProviderDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserExchangeProviderDataQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserExchangeProviderDataQuery,
    UserExchangeProviderDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    UserExchangeProviderDataQuery,
    UserExchangeProviderDataQueryVariables
  >(UserExchangeProviderDataDocument, options);
}
export function useUserExchangeProviderDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserExchangeProviderDataQuery,
    UserExchangeProviderDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    UserExchangeProviderDataQuery,
    UserExchangeProviderDataQueryVariables
  >(UserExchangeProviderDataDocument, options);
}
// @ts-ignore
export function useUserExchangeProviderDataSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    UserExchangeProviderDataQuery,
    UserExchangeProviderDataQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserExchangeProviderDataQuery,
  UserExchangeProviderDataQueryVariables
>;
export function useUserExchangeProviderDataSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserExchangeProviderDataQuery,
        UserExchangeProviderDataQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserExchangeProviderDataQuery | undefined,
  UserExchangeProviderDataQueryVariables
>;
export function useUserExchangeProviderDataSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserExchangeProviderDataQuery,
        UserExchangeProviderDataQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    UserExchangeProviderDataQuery,
    UserExchangeProviderDataQueryVariables
  >(UserExchangeProviderDataDocument, options);
}
export type UserExchangeProviderDataQueryHookResult = ReturnType<
  typeof useUserExchangeProviderDataQuery
>;
export type UserExchangeProviderDataLazyQueryHookResult = ReturnType<
  typeof useUserExchangeProviderDataLazyQuery
>;
export type UserExchangeProviderDataSuspenseQueryHookResult = ReturnType<
  typeof useUserExchangeProviderDataSuspenseQuery
>;
export type UserExchangeProviderDataQueryResult = ApolloReactCommon.QueryResult<
  UserExchangeProviderDataQuery,
  UserExchangeProviderDataQueryVariables
>;
export function refetchUserExchangeProviderDataQuery(
  variables?: UserExchangeProviderDataQueryVariables
) {
  return { query: UserExchangeProviderDataDocument, variables: variables };
}
export const UserExchangesDocument = gql`
  query userExchanges {
    getUserExchanges {
      ...allExchangesData
    }
  }
  ${AllExchangesDataFragmentDoc}
`;

/**
 * __useUserExchangesQuery__
 *
 * To run a query within a React component, call `useUserExchangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserExchangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserExchangesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserExchangesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserExchangesQuery,
    UserExchangesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    UserExchangesQuery,
    UserExchangesQueryVariables
  >(UserExchangesDocument, options);
}
export function useUserExchangesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserExchangesQuery,
    UserExchangesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    UserExchangesQuery,
    UserExchangesQueryVariables
  >(UserExchangesDocument, options);
}
// @ts-ignore
export function useUserExchangesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    UserExchangesQuery,
    UserExchangesQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserExchangesQuery,
  UserExchangesQueryVariables
>;
export function useUserExchangesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserExchangesQuery,
        UserExchangesQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserExchangesQuery | undefined,
  UserExchangesQueryVariables
>;
export function useUserExchangesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserExchangesQuery,
        UserExchangesQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    UserExchangesQuery,
    UserExchangesQueryVariables
  >(UserExchangesDocument, options);
}
export type UserExchangesQueryHookResult = ReturnType<
  typeof useUserExchangesQuery
>;
export type UserExchangesLazyQueryHookResult = ReturnType<
  typeof useUserExchangesLazyQuery
>;
export type UserExchangesSuspenseQueryHookResult = ReturnType<
  typeof useUserExchangesSuspenseQuery
>;
export type UserExchangesQueryResult = ApolloReactCommon.QueryResult<
  UserExchangesQuery,
  UserExchangesQueryVariables
>;
export function refetchUserExchangesQuery(
  variables?: UserExchangesQueryVariables
) {
  return { query: UserExchangesDocument, variables: variables };
}
export const UserExchangesStartDatesDocument = gql`
  query userExchangesStartDates {
    getUserExchanges {
      exchangeID
      exchangeCode
      subscriptionStartDate
    }
  }
`;

/**
 * __useUserExchangesStartDatesQuery__
 *
 * To run a query within a React component, call `useUserExchangesStartDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserExchangesStartDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserExchangesStartDatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserExchangesStartDatesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserExchangesStartDatesQuery,
    UserExchangesStartDatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    UserExchangesStartDatesQuery,
    UserExchangesStartDatesQueryVariables
  >(UserExchangesStartDatesDocument, options);
}
export function useUserExchangesStartDatesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserExchangesStartDatesQuery,
    UserExchangesStartDatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    UserExchangesStartDatesQuery,
    UserExchangesStartDatesQueryVariables
  >(UserExchangesStartDatesDocument, options);
}
// @ts-ignore
export function useUserExchangesStartDatesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    UserExchangesStartDatesQuery,
    UserExchangesStartDatesQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserExchangesStartDatesQuery,
  UserExchangesStartDatesQueryVariables
>;
export function useUserExchangesStartDatesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserExchangesStartDatesQuery,
        UserExchangesStartDatesQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserExchangesStartDatesQuery | undefined,
  UserExchangesStartDatesQueryVariables
>;
export function useUserExchangesStartDatesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserExchangesStartDatesQuery,
        UserExchangesStartDatesQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    UserExchangesStartDatesQuery,
    UserExchangesStartDatesQueryVariables
  >(UserExchangesStartDatesDocument, options);
}
export type UserExchangesStartDatesQueryHookResult = ReturnType<
  typeof useUserExchangesStartDatesQuery
>;
export type UserExchangesStartDatesLazyQueryHookResult = ReturnType<
  typeof useUserExchangesStartDatesLazyQuery
>;
export type UserExchangesStartDatesSuspenseQueryHookResult = ReturnType<
  typeof useUserExchangesStartDatesSuspenseQuery
>;
export type UserExchangesStartDatesQueryResult = ApolloReactCommon.QueryResult<
  UserExchangesStartDatesQuery,
  UserExchangesStartDatesQueryVariables
>;
export function refetchUserExchangesStartDatesQuery(
  variables?: UserExchangesStartDatesQueryVariables
) {
  return { query: UserExchangesStartDatesDocument, variables: variables };
}
export const SelectedExchangeDocument = gql`
  query selectedExchange {
    selectedExchange @client
  }
`;

/**
 * __useSelectedExchangeQuery__
 *
 * To run a query within a React component, call `useSelectedExchangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedExchangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedExchangeQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectedExchangeQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SelectedExchangeQuery,
    SelectedExchangeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    SelectedExchangeQuery,
    SelectedExchangeQueryVariables
  >(SelectedExchangeDocument, options);
}
export function useSelectedExchangeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SelectedExchangeQuery,
    SelectedExchangeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    SelectedExchangeQuery,
    SelectedExchangeQueryVariables
  >(SelectedExchangeDocument, options);
}
// @ts-ignore
export function useSelectedExchangeSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    SelectedExchangeQuery,
    SelectedExchangeQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  SelectedExchangeQuery,
  SelectedExchangeQueryVariables
>;
export function useSelectedExchangeSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        SelectedExchangeQuery,
        SelectedExchangeQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  SelectedExchangeQuery | undefined,
  SelectedExchangeQueryVariables
>;
export function useSelectedExchangeSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        SelectedExchangeQuery,
        SelectedExchangeQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    SelectedExchangeQuery,
    SelectedExchangeQueryVariables
  >(SelectedExchangeDocument, options);
}
export type SelectedExchangeQueryHookResult = ReturnType<
  typeof useSelectedExchangeQuery
>;
export type SelectedExchangeLazyQueryHookResult = ReturnType<
  typeof useSelectedExchangeLazyQuery
>;
export type SelectedExchangeSuspenseQueryHookResult = ReturnType<
  typeof useSelectedExchangeSuspenseQuery
>;
export type SelectedExchangeQueryResult = ApolloReactCommon.QueryResult<
  SelectedExchangeQuery,
  SelectedExchangeQueryVariables
>;
export function refetchSelectedExchangeQuery(
  variables?: SelectedExchangeQueryVariables
) {
  return { query: SelectedExchangeDocument, variables: variables };
}
export const ExchangesSubscriptionInitiatedDatesDocument = gql`
  query exchangesSubscriptionInitiatedDates {
    getUserExchanges {
      exchangeID
      subscriptionInitiatedDate
    }
  }
`;

/**
 * __useExchangesSubscriptionInitiatedDatesQuery__
 *
 * To run a query within a React component, call `useExchangesSubscriptionInitiatedDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExchangesSubscriptionInitiatedDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExchangesSubscriptionInitiatedDatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExchangesSubscriptionInitiatedDatesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ExchangesSubscriptionInitiatedDatesQuery,
    ExchangesSubscriptionInitiatedDatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    ExchangesSubscriptionInitiatedDatesQuery,
    ExchangesSubscriptionInitiatedDatesQueryVariables
  >(ExchangesSubscriptionInitiatedDatesDocument, options);
}
export function useExchangesSubscriptionInitiatedDatesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ExchangesSubscriptionInitiatedDatesQuery,
    ExchangesSubscriptionInitiatedDatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    ExchangesSubscriptionInitiatedDatesQuery,
    ExchangesSubscriptionInitiatedDatesQueryVariables
  >(ExchangesSubscriptionInitiatedDatesDocument, options);
}
// @ts-ignore
export function useExchangesSubscriptionInitiatedDatesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    ExchangesSubscriptionInitiatedDatesQuery,
    ExchangesSubscriptionInitiatedDatesQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  ExchangesSubscriptionInitiatedDatesQuery,
  ExchangesSubscriptionInitiatedDatesQueryVariables
>;
export function useExchangesSubscriptionInitiatedDatesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        ExchangesSubscriptionInitiatedDatesQuery,
        ExchangesSubscriptionInitiatedDatesQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  ExchangesSubscriptionInitiatedDatesQuery | undefined,
  ExchangesSubscriptionInitiatedDatesQueryVariables
>;
export function useExchangesSubscriptionInitiatedDatesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        ExchangesSubscriptionInitiatedDatesQuery,
        ExchangesSubscriptionInitiatedDatesQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    ExchangesSubscriptionInitiatedDatesQuery,
    ExchangesSubscriptionInitiatedDatesQueryVariables
  >(ExchangesSubscriptionInitiatedDatesDocument, options);
}
export type ExchangesSubscriptionInitiatedDatesQueryHookResult = ReturnType<
  typeof useExchangesSubscriptionInitiatedDatesQuery
>;
export type ExchangesSubscriptionInitiatedDatesLazyQueryHookResult = ReturnType<
  typeof useExchangesSubscriptionInitiatedDatesLazyQuery
>;
export type ExchangesSubscriptionInitiatedDatesSuspenseQueryHookResult =
  ReturnType<typeof useExchangesSubscriptionInitiatedDatesSuspenseQuery>;
export type ExchangesSubscriptionInitiatedDatesQueryResult =
  ApolloReactCommon.QueryResult<
    ExchangesSubscriptionInitiatedDatesQuery,
    ExchangesSubscriptionInitiatedDatesQueryVariables
  >;
export function refetchExchangesSubscriptionInitiatedDatesQuery(
  variables?: ExchangesSubscriptionInitiatedDatesQueryVariables
) {
  return {
    query: ExchangesSubscriptionInitiatedDatesDocument,
    variables: variables,
  };
}
export const DepositCurrenciesOptionsDocument = gql`
  query depositCurrenciesOptions($exchangeId: Int!) {
    getDepositCurrenciesOptions(exchangeId: $exchangeId, await: true) {
      currency {
        id
        symbol
      }
      cost
      enoughToStartSubscription
    }
  }
`;

/**
 * __useDepositCurrenciesOptionsQuery__
 *
 * To run a query within a React component, call `useDepositCurrenciesOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepositCurrenciesOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepositCurrenciesOptionsQuery({
 *   variables: {
 *      exchangeId: // value for 'exchangeId'
 *   },
 * });
 */
export function useDepositCurrenciesOptionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    DepositCurrenciesOptionsQuery,
    DepositCurrenciesOptionsQueryVariables
  > &
    (
      | { variables: DepositCurrenciesOptionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    DepositCurrenciesOptionsQuery,
    DepositCurrenciesOptionsQueryVariables
  >(DepositCurrenciesOptionsDocument, options);
}
export function useDepositCurrenciesOptionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    DepositCurrenciesOptionsQuery,
    DepositCurrenciesOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    DepositCurrenciesOptionsQuery,
    DepositCurrenciesOptionsQueryVariables
  >(DepositCurrenciesOptionsDocument, options);
}
// @ts-ignore
export function useDepositCurrenciesOptionsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    DepositCurrenciesOptionsQuery,
    DepositCurrenciesOptionsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  DepositCurrenciesOptionsQuery,
  DepositCurrenciesOptionsQueryVariables
>;
export function useDepositCurrenciesOptionsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        DepositCurrenciesOptionsQuery,
        DepositCurrenciesOptionsQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  DepositCurrenciesOptionsQuery | undefined,
  DepositCurrenciesOptionsQueryVariables
>;
export function useDepositCurrenciesOptionsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        DepositCurrenciesOptionsQuery,
        DepositCurrenciesOptionsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    DepositCurrenciesOptionsQuery,
    DepositCurrenciesOptionsQueryVariables
  >(DepositCurrenciesOptionsDocument, options);
}
export type DepositCurrenciesOptionsQueryHookResult = ReturnType<
  typeof useDepositCurrenciesOptionsQuery
>;
export type DepositCurrenciesOptionsLazyQueryHookResult = ReturnType<
  typeof useDepositCurrenciesOptionsLazyQuery
>;
export type DepositCurrenciesOptionsSuspenseQueryHookResult = ReturnType<
  typeof useDepositCurrenciesOptionsSuspenseQuery
>;
export type DepositCurrenciesOptionsQueryResult = ApolloReactCommon.QueryResult<
  DepositCurrenciesOptionsQuery,
  DepositCurrenciesOptionsQueryVariables
>;
export function refetchDepositCurrenciesOptionsQuery(
  variables: DepositCurrenciesOptionsQueryVariables
) {
  return { query: DepositCurrenciesOptionsDocument, variables: variables };
}
export const WithdrawCurrenciesOptionsDocument = gql`
  query withdrawCurrenciesOptions($exchangeId: Int!) {
    getIndexPortfolioSortedForSale(exchangeId: $exchangeId) {
      ...currencyListItemData
    }
  }
  ${CurrencyListItemDataFragmentDoc}
`;

/**
 * __useWithdrawCurrenciesOptionsQuery__
 *
 * To run a query within a React component, call `useWithdrawCurrenciesOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWithdrawCurrenciesOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWithdrawCurrenciesOptionsQuery({
 *   variables: {
 *      exchangeId: // value for 'exchangeId'
 *   },
 * });
 */
export function useWithdrawCurrenciesOptionsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    WithdrawCurrenciesOptionsQuery,
    WithdrawCurrenciesOptionsQueryVariables
  > &
    (
      | { variables: WithdrawCurrenciesOptionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    WithdrawCurrenciesOptionsQuery,
    WithdrawCurrenciesOptionsQueryVariables
  >(WithdrawCurrenciesOptionsDocument, options);
}
export function useWithdrawCurrenciesOptionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    WithdrawCurrenciesOptionsQuery,
    WithdrawCurrenciesOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    WithdrawCurrenciesOptionsQuery,
    WithdrawCurrenciesOptionsQueryVariables
  >(WithdrawCurrenciesOptionsDocument, options);
}
// @ts-ignore
export function useWithdrawCurrenciesOptionsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    WithdrawCurrenciesOptionsQuery,
    WithdrawCurrenciesOptionsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  WithdrawCurrenciesOptionsQuery,
  WithdrawCurrenciesOptionsQueryVariables
>;
export function useWithdrawCurrenciesOptionsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        WithdrawCurrenciesOptionsQuery,
        WithdrawCurrenciesOptionsQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  WithdrawCurrenciesOptionsQuery | undefined,
  WithdrawCurrenciesOptionsQueryVariables
>;
export function useWithdrawCurrenciesOptionsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        WithdrawCurrenciesOptionsQuery,
        WithdrawCurrenciesOptionsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    WithdrawCurrenciesOptionsQuery,
    WithdrawCurrenciesOptionsQueryVariables
  >(WithdrawCurrenciesOptionsDocument, options);
}
export type WithdrawCurrenciesOptionsQueryHookResult = ReturnType<
  typeof useWithdrawCurrenciesOptionsQuery
>;
export type WithdrawCurrenciesOptionsLazyQueryHookResult = ReturnType<
  typeof useWithdrawCurrenciesOptionsLazyQuery
>;
export type WithdrawCurrenciesOptionsSuspenseQueryHookResult = ReturnType<
  typeof useWithdrawCurrenciesOptionsSuspenseQuery
>;
export type WithdrawCurrenciesOptionsQueryResult =
  ApolloReactCommon.QueryResult<
    WithdrawCurrenciesOptionsQuery,
    WithdrawCurrenciesOptionsQueryVariables
  >;
export function refetchWithdrawCurrenciesOptionsQuery(
  variables: WithdrawCurrenciesOptionsQueryVariables
) {
  return { query: WithdrawCurrenciesOptionsDocument, variables: variables };
}
export const AddExchangeKeysDocument = gql`
  mutation addExchangeKeys(
    $exchangeId: Int!
    $key: String!
    $secretKey: String!
  ) {
    addKeys(exchangeId: $exchangeId, keys: { key: $key, secret: $secretKey }) {
      exchangeID
      aumBelowMinimum
      moneyUnderManagement
      nextRebalanceDate
      wizardStatus
      subscriptionStartDate
      subscriptionInitiatedDate
      onlyFiatInPortfolio
    }
  }
`;
export type AddExchangeKeysMutationFn = ApolloReactCommon.MutationFunction<
  AddExchangeKeysMutation,
  AddExchangeKeysMutationVariables
>;

/**
 * __useAddExchangeKeysMutation__
 *
 * To run a mutation, you first call `useAddExchangeKeysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExchangeKeysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExchangeKeysMutation, { data, loading, error }] = useAddExchangeKeysMutation({
 *   variables: {
 *      exchangeId: // value for 'exchangeId'
 *      key: // value for 'key'
 *      secretKey: // value for 'secretKey'
 *   },
 * });
 */
export function useAddExchangeKeysMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AddExchangeKeysMutation,
    AddExchangeKeysMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    AddExchangeKeysMutation,
    AddExchangeKeysMutationVariables
  >(AddExchangeKeysDocument, options);
}
export type AddExchangeKeysMutationHookResult = ReturnType<
  typeof useAddExchangeKeysMutation
>;
export type AddExchangeKeysMutationResult =
  ApolloReactCommon.MutationResult<AddExchangeKeysMutation>;
export type AddExchangeKeysMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AddExchangeKeysMutation,
    AddExchangeKeysMutationVariables
  >;
export const StartSubscriptionDocument = gql`
  mutation startSubscription(
    $exchangeId: Int!
    $currencies: [CurrencyInput!]!
  ) {
    startSubscription(exchangeId: $exchangeId, currencies: $currencies)
  }
`;
export type StartSubscriptionMutationFn = ApolloReactCommon.MutationFunction<
  StartSubscriptionMutation,
  StartSubscriptionMutationVariables
>;

/**
 * __useStartSubscriptionMutation__
 *
 * To run a mutation, you first call `useStartSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSubscriptionMutation, { data, loading, error }] = useStartSubscriptionMutation({
 *   variables: {
 *      exchangeId: // value for 'exchangeId'
 *      currencies: // value for 'currencies'
 *   },
 * });
 */
export function useStartSubscriptionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    StartSubscriptionMutation,
    StartSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    StartSubscriptionMutation,
    StartSubscriptionMutationVariables
  >(StartSubscriptionDocument, options);
}
export type StartSubscriptionMutationHookResult = ReturnType<
  typeof useStartSubscriptionMutation
>;
export type StartSubscriptionMutationResult =
  ApolloReactCommon.MutationResult<StartSubscriptionMutation>;
export type StartSubscriptionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    StartSubscriptionMutation,
    StartSubscriptionMutationVariables
  >;
export const DisableSubscriptionDocument = gql`
  mutation disableSubscription($exchangeId: Int!) {
    cancelSubscription(exchangeId: $exchangeId) {
      exchangeID
    }
  }
`;
export type DisableSubscriptionMutationFn = ApolloReactCommon.MutationFunction<
  DisableSubscriptionMutation,
  DisableSubscriptionMutationVariables
>;

/**
 * __useDisableSubscriptionMutation__
 *
 * To run a mutation, you first call `useDisableSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableSubscriptionMutation, { data, loading, error }] = useDisableSubscriptionMutation({
 *   variables: {
 *      exchangeId: // value for 'exchangeId'
 *   },
 * });
 */
export function useDisableSubscriptionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DisableSubscriptionMutation,
    DisableSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DisableSubscriptionMutation,
    DisableSubscriptionMutationVariables
  >(DisableSubscriptionDocument, options);
}
export type DisableSubscriptionMutationHookResult = ReturnType<
  typeof useDisableSubscriptionMutation
>;
export type DisableSubscriptionMutationResult =
  ApolloReactCommon.MutationResult<DisableSubscriptionMutation>;
export type DisableSubscriptionMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DisableSubscriptionMutation,
    DisableSubscriptionMutationVariables
  >;
export const InvoicesDocument = gql`
  query invoices {
    getInvoices {
      id
      dueDate
      url
      status
    }
  }
`;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvoicesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    InvoicesQuery,
    InvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<InvoicesQuery, InvoicesQueryVariables>(
    InvoicesDocument,
    options
  );
}
export function useInvoicesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InvoicesQuery,
    InvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(
    InvoicesDocument,
    options
  );
}
// @ts-ignore
export function useInvoicesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    InvoicesQuery,
    InvoicesQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  InvoicesQuery,
  InvoicesQueryVariables
>;
export function useInvoicesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        InvoicesQuery,
        InvoicesQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  InvoicesQuery | undefined,
  InvoicesQueryVariables
>;
export function useInvoicesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        InvoicesQuery,
        InvoicesQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    InvoicesQuery,
    InvoicesQueryVariables
  >(InvoicesDocument, options);
}
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<
  typeof useInvoicesLazyQuery
>;
export type InvoicesSuspenseQueryHookResult = ReturnType<
  typeof useInvoicesSuspenseQuery
>;
export type InvoicesQueryResult = ApolloReactCommon.QueryResult<
  InvoicesQuery,
  InvoicesQueryVariables
>;
export function refetchInvoicesQuery(variables?: InvoicesQueryVariables) {
  return { query: InvoicesDocument, variables: variables };
}
export const InvoiceDocument = gql`
  query invoice($id: Int!) {
    getInvoice(invoiceID: $id) {
      id
      dueDate
      cost
      costExVat
      url
      status
    }
  }
`;

/**
 * __useInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    InvoiceQuery,
    InvoiceQueryVariables
  > &
    ({ variables: InvoiceQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<InvoiceQuery, InvoiceQueryVariables>(
    InvoiceDocument,
    options
  );
}
export function useInvoiceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    InvoiceQuery,
    InvoiceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<InvoiceQuery, InvoiceQueryVariables>(
    InvoiceDocument,
    options
  );
}
// @ts-ignore
export function useInvoiceSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    InvoiceQuery,
    InvoiceQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<InvoiceQuery, InvoiceQueryVariables>;
export function useInvoiceSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        InvoiceQuery,
        InvoiceQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  InvoiceQuery | undefined,
  InvoiceQueryVariables
>;
export function useInvoiceSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        InvoiceQuery,
        InvoiceQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<InvoiceQuery, InvoiceQueryVariables>(
    InvoiceDocument,
    options
  );
}
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>;
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>;
export type InvoiceSuspenseQueryHookResult = ReturnType<
  typeof useInvoiceSuspenseQuery
>;
export type InvoiceQueryResult = ApolloReactCommon.QueryResult<
  InvoiceQuery,
  InvoiceQueryVariables
>;
export function refetchInvoiceQuery(variables: InvoiceQueryVariables) {
  return { query: InvoiceDocument, variables: variables };
}
export const MainDataDocument = gql`
  query mainData {
    getUser {
      ...initialUserData
    }
    getUserExchanges {
      ...allExchangesData
    }
    getMolliePaymentInfo {
      method
      status
      createdAt
      details
    }
  }
  ${InitialUserDataFragmentDoc}
  ${AllExchangesDataFragmentDoc}
`;

/**
 * __useMainDataQuery__
 *
 * To run a query within a React component, call `useMainDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useMainDataQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    MainDataQuery,
    MainDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<MainDataQuery, MainDataQueryVariables>(
    MainDataDocument,
    options
  );
}
export function useMainDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MainDataQuery,
    MainDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<MainDataQuery, MainDataQueryVariables>(
    MainDataDocument,
    options
  );
}
// @ts-ignore
export function useMainDataSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    MainDataQuery,
    MainDataQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  MainDataQuery,
  MainDataQueryVariables
>;
export function useMainDataSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        MainDataQuery,
        MainDataQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  MainDataQuery | undefined,
  MainDataQueryVariables
>;
export function useMainDataSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        MainDataQuery,
        MainDataQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    MainDataQuery,
    MainDataQueryVariables
  >(MainDataDocument, options);
}
export type MainDataQueryHookResult = ReturnType<typeof useMainDataQuery>;
export type MainDataLazyQueryHookResult = ReturnType<
  typeof useMainDataLazyQuery
>;
export type MainDataSuspenseQueryHookResult = ReturnType<
  typeof useMainDataSuspenseQuery
>;
export type MainDataQueryResult = ApolloReactCommon.QueryResult<
  MainDataQuery,
  MainDataQueryVariables
>;
export function refetchMainDataQuery(variables?: MainDataQueryVariables) {
  return { query: MainDataDocument, variables: variables };
}
export const PaymentProviderDataDocument = gql`
  query paymentProviderData {
    getUser {
      id
      isAdmin
      trialEndDate
      mollieStatus
      hasActiveSubscription
      hasUnpaidInvoices
    }
  }
`;

/**
 * __usePaymentProviderDataQuery__
 *
 * To run a query within a React component, call `usePaymentProviderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentProviderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentProviderDataQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentProviderDataQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    PaymentProviderDataQuery,
    PaymentProviderDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    PaymentProviderDataQuery,
    PaymentProviderDataQueryVariables
  >(PaymentProviderDataDocument, options);
}
export function usePaymentProviderDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    PaymentProviderDataQuery,
    PaymentProviderDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    PaymentProviderDataQuery,
    PaymentProviderDataQueryVariables
  >(PaymentProviderDataDocument, options);
}
// @ts-ignore
export function usePaymentProviderDataSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    PaymentProviderDataQuery,
    PaymentProviderDataQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  PaymentProviderDataQuery,
  PaymentProviderDataQueryVariables
>;
export function usePaymentProviderDataSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        PaymentProviderDataQuery,
        PaymentProviderDataQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  PaymentProviderDataQuery | undefined,
  PaymentProviderDataQueryVariables
>;
export function usePaymentProviderDataSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        PaymentProviderDataQuery,
        PaymentProviderDataQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    PaymentProviderDataQuery,
    PaymentProviderDataQueryVariables
  >(PaymentProviderDataDocument, options);
}
export type PaymentProviderDataQueryHookResult = ReturnType<
  typeof usePaymentProviderDataQuery
>;
export type PaymentProviderDataLazyQueryHookResult = ReturnType<
  typeof usePaymentProviderDataLazyQuery
>;
export type PaymentProviderDataSuspenseQueryHookResult = ReturnType<
  typeof usePaymentProviderDataSuspenseQuery
>;
export type PaymentProviderDataQueryResult = ApolloReactCommon.QueryResult<
  PaymentProviderDataQuery,
  PaymentProviderDataQueryVariables
>;
export function refetchPaymentProviderDataQuery(
  variables?: PaymentProviderDataQueryVariables
) {
  return { query: PaymentProviderDataDocument, variables: variables };
}
export const MolliePaymentInfoDocument = gql`
  query molliePaymentInfo {
    getMolliePaymentInfo {
      method
      status
      createdAt
      details
    }
  }
`;

/**
 * __useMolliePaymentInfoQuery__
 *
 * To run a query within a React component, call `useMolliePaymentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMolliePaymentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMolliePaymentInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMolliePaymentInfoQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    MolliePaymentInfoQuery,
    MolliePaymentInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    MolliePaymentInfoQuery,
    MolliePaymentInfoQueryVariables
  >(MolliePaymentInfoDocument, options);
}
export function useMolliePaymentInfoLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MolliePaymentInfoQuery,
    MolliePaymentInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    MolliePaymentInfoQuery,
    MolliePaymentInfoQueryVariables
  >(MolliePaymentInfoDocument, options);
}
// @ts-ignore
export function useMolliePaymentInfoSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    MolliePaymentInfoQuery,
    MolliePaymentInfoQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  MolliePaymentInfoQuery,
  MolliePaymentInfoQueryVariables
>;
export function useMolliePaymentInfoSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        MolliePaymentInfoQuery,
        MolliePaymentInfoQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  MolliePaymentInfoQuery | undefined,
  MolliePaymentInfoQueryVariables
>;
export function useMolliePaymentInfoSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        MolliePaymentInfoQuery,
        MolliePaymentInfoQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    MolliePaymentInfoQuery,
    MolliePaymentInfoQueryVariables
  >(MolliePaymentInfoDocument, options);
}
export type MolliePaymentInfoQueryHookResult = ReturnType<
  typeof useMolliePaymentInfoQuery
>;
export type MolliePaymentInfoLazyQueryHookResult = ReturnType<
  typeof useMolliePaymentInfoLazyQuery
>;
export type MolliePaymentInfoSuspenseQueryHookResult = ReturnType<
  typeof useMolliePaymentInfoSuspenseQuery
>;
export type MolliePaymentInfoQueryResult = ApolloReactCommon.QueryResult<
  MolliePaymentInfoQuery,
  MolliePaymentInfoQueryVariables
>;
export function refetchMolliePaymentInfoQuery(
  variables?: MolliePaymentInfoQueryVariables
) {
  return { query: MolliePaymentInfoDocument, variables: variables };
}
export const GetMollieTransitPaymentLinkDocument = gql`
  query getMollieTransitPaymentLink($token: String!, $locale: String) {
    getMollieTransitPaymentLink(token: $token, locale: $locale) {
      checkoutURL
    }
  }
`;

/**
 * __useGetMollieTransitPaymentLinkQuery__
 *
 * To run a query within a React component, call `useGetMollieTransitPaymentLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMollieTransitPaymentLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMollieTransitPaymentLinkQuery({
 *   variables: {
 *      token: // value for 'token'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetMollieTransitPaymentLinkQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetMollieTransitPaymentLinkQuery,
    GetMollieTransitPaymentLinkQueryVariables
  > &
    (
      | { variables: GetMollieTransitPaymentLinkQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetMollieTransitPaymentLinkQuery,
    GetMollieTransitPaymentLinkQueryVariables
  >(GetMollieTransitPaymentLinkDocument, options);
}
export function useGetMollieTransitPaymentLinkLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMollieTransitPaymentLinkQuery,
    GetMollieTransitPaymentLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetMollieTransitPaymentLinkQuery,
    GetMollieTransitPaymentLinkQueryVariables
  >(GetMollieTransitPaymentLinkDocument, options);
}
// @ts-ignore
export function useGetMollieTransitPaymentLinkSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    GetMollieTransitPaymentLinkQuery,
    GetMollieTransitPaymentLinkQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  GetMollieTransitPaymentLinkQuery,
  GetMollieTransitPaymentLinkQueryVariables
>;
export function useGetMollieTransitPaymentLinkSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetMollieTransitPaymentLinkQuery,
        GetMollieTransitPaymentLinkQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  GetMollieTransitPaymentLinkQuery | undefined,
  GetMollieTransitPaymentLinkQueryVariables
>;
export function useGetMollieTransitPaymentLinkSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetMollieTransitPaymentLinkQuery,
        GetMollieTransitPaymentLinkQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    GetMollieTransitPaymentLinkQuery,
    GetMollieTransitPaymentLinkQueryVariables
  >(GetMollieTransitPaymentLinkDocument, options);
}
export type GetMollieTransitPaymentLinkQueryHookResult = ReturnType<
  typeof useGetMollieTransitPaymentLinkQuery
>;
export type GetMollieTransitPaymentLinkLazyQueryHookResult = ReturnType<
  typeof useGetMollieTransitPaymentLinkLazyQuery
>;
export type GetMollieTransitPaymentLinkSuspenseQueryHookResult = ReturnType<
  typeof useGetMollieTransitPaymentLinkSuspenseQuery
>;
export type GetMollieTransitPaymentLinkQueryResult =
  ApolloReactCommon.QueryResult<
    GetMollieTransitPaymentLinkQuery,
    GetMollieTransitPaymentLinkQueryVariables
  >;
export function refetchGetMollieTransitPaymentLinkQuery(
  variables: GetMollieTransitPaymentLinkQueryVariables
) {
  return { query: GetMollieTransitPaymentLinkDocument, variables: variables };
}
export const CreateNewMollieClientDocument = gql`
  mutation createNewMollieClient($locale: String) {
    newMollieClient(locale: $locale) {
      checkoutURL
    }
  }
`;
export type CreateNewMollieClientMutationFn =
  ApolloReactCommon.MutationFunction<
    CreateNewMollieClientMutation,
    CreateNewMollieClientMutationVariables
  >;

/**
 * __useCreateNewMollieClientMutation__
 *
 * To run a mutation, you first call `useCreateNewMollieClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewMollieClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewMollieClientMutation, { data, loading, error }] = useCreateNewMollieClientMutation({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useCreateNewMollieClientMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateNewMollieClientMutation,
    CreateNewMollieClientMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    CreateNewMollieClientMutation,
    CreateNewMollieClientMutationVariables
  >(CreateNewMollieClientDocument, options);
}
export type CreateNewMollieClientMutationHookResult = ReturnType<
  typeof useCreateNewMollieClientMutation
>;
export type CreateNewMollieClientMutationResult =
  ApolloReactCommon.MutationResult<CreateNewMollieClientMutation>;
export type CreateNewMollieClientMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateNewMollieClientMutation,
    CreateNewMollieClientMutationVariables
  >;
export const DirectMolliePaymentDocument = gql`
  mutation directMolliePayment($id: Int!) {
    directMolliePayment(invoiceId: $id) {
      checkoutURL
    }
  }
`;
export type DirectMolliePaymentMutationFn = ApolloReactCommon.MutationFunction<
  DirectMolliePaymentMutation,
  DirectMolliePaymentMutationVariables
>;

/**
 * __useDirectMolliePaymentMutation__
 *
 * To run a mutation, you first call `useDirectMolliePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDirectMolliePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [directMolliePaymentMutation, { data, loading, error }] = useDirectMolliePaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDirectMolliePaymentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DirectMolliePaymentMutation,
    DirectMolliePaymentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    DirectMolliePaymentMutation,
    DirectMolliePaymentMutationVariables
  >(DirectMolliePaymentDocument, options);
}
export type DirectMolliePaymentMutationHookResult = ReturnType<
  typeof useDirectMolliePaymentMutation
>;
export type DirectMolliePaymentMutationResult =
  ApolloReactCommon.MutationResult<DirectMolliePaymentMutation>;
export type DirectMolliePaymentMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DirectMolliePaymentMutation,
    DirectMolliePaymentMutationVariables
  >;
export const UserIdDocument = gql`
  query userId {
    getUser {
      id
    }
  }
`;

/**
 * __useUserIdQuery__
 *
 * To run a query within a React component, call `useUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserIdQuery,
    UserIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<UserIdQuery, UserIdQueryVariables>(
    UserIdDocument,
    options
  );
}
export function useUserIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserIdQuery,
    UserIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<UserIdQuery, UserIdQueryVariables>(
    UserIdDocument,
    options
  );
}
// @ts-ignore
export function useUserIdSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    UserIdQuery,
    UserIdQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<UserIdQuery, UserIdQueryVariables>;
export function useUserIdSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserIdQuery,
        UserIdQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserIdQuery | undefined,
  UserIdQueryVariables
>;
export function useUserIdSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserIdQuery,
        UserIdQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<UserIdQuery, UserIdQueryVariables>(
    UserIdDocument,
    options
  );
}
export type UserIdQueryHookResult = ReturnType<typeof useUserIdQuery>;
export type UserIdLazyQueryHookResult = ReturnType<typeof useUserIdLazyQuery>;
export type UserIdSuspenseQueryHookResult = ReturnType<
  typeof useUserIdSuspenseQuery
>;
export type UserIdQueryResult = ApolloReactCommon.QueryResult<
  UserIdQuery,
  UserIdQueryVariables
>;
export function refetchUserIdQuery(variables?: UserIdQueryVariables) {
  return { query: UserIdDocument, variables: variables };
}
export const UserCompanyNameDocument = gql`
  query userCompanyName {
    getUser {
      id
      companyName
    }
  }
`;

/**
 * __useUserCompanyNameQuery__
 *
 * To run a query within a React component, call `useUserCompanyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCompanyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCompanyNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserCompanyNameQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserCompanyNameQuery,
    UserCompanyNameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    UserCompanyNameQuery,
    UserCompanyNameQueryVariables
  >(UserCompanyNameDocument, options);
}
export function useUserCompanyNameLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserCompanyNameQuery,
    UserCompanyNameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    UserCompanyNameQuery,
    UserCompanyNameQueryVariables
  >(UserCompanyNameDocument, options);
}
// @ts-ignore
export function useUserCompanyNameSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    UserCompanyNameQuery,
    UserCompanyNameQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserCompanyNameQuery,
  UserCompanyNameQueryVariables
>;
export function useUserCompanyNameSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserCompanyNameQuery,
        UserCompanyNameQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserCompanyNameQuery | undefined,
  UserCompanyNameQueryVariables
>;
export function useUserCompanyNameSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserCompanyNameQuery,
        UserCompanyNameQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    UserCompanyNameQuery,
    UserCompanyNameQueryVariables
  >(UserCompanyNameDocument, options);
}
export type UserCompanyNameQueryHookResult = ReturnType<
  typeof useUserCompanyNameQuery
>;
export type UserCompanyNameLazyQueryHookResult = ReturnType<
  typeof useUserCompanyNameLazyQuery
>;
export type UserCompanyNameSuspenseQueryHookResult = ReturnType<
  typeof useUserCompanyNameSuspenseQuery
>;
export type UserCompanyNameQueryResult = ApolloReactCommon.QueryResult<
  UserCompanyNameQuery,
  UserCompanyNameQueryVariables
>;
export function refetchUserCompanyNameQuery(
  variables?: UserCompanyNameQueryVariables
) {
  return { query: UserCompanyNameDocument, variables: variables };
}
export const UserAuthIdentitiesDocument = gql`
  query userAuthIdentities {
    getUser {
      id
      authIdentities {
        id
        provider
        uid
      }
    }
  }
`;

/**
 * __useUserAuthIdentitiesQuery__
 *
 * To run a query within a React component, call `useUserAuthIdentitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAuthIdentitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAuthIdentitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserAuthIdentitiesQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserAuthIdentitiesQuery,
    UserAuthIdentitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    UserAuthIdentitiesQuery,
    UserAuthIdentitiesQueryVariables
  >(UserAuthIdentitiesDocument, options);
}
export function useUserAuthIdentitiesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserAuthIdentitiesQuery,
    UserAuthIdentitiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    UserAuthIdentitiesQuery,
    UserAuthIdentitiesQueryVariables
  >(UserAuthIdentitiesDocument, options);
}
// @ts-ignore
export function useUserAuthIdentitiesSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    UserAuthIdentitiesQuery,
    UserAuthIdentitiesQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserAuthIdentitiesQuery,
  UserAuthIdentitiesQueryVariables
>;
export function useUserAuthIdentitiesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserAuthIdentitiesQuery,
        UserAuthIdentitiesQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserAuthIdentitiesQuery | undefined,
  UserAuthIdentitiesQueryVariables
>;
export function useUserAuthIdentitiesSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserAuthIdentitiesQuery,
        UserAuthIdentitiesQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    UserAuthIdentitiesQuery,
    UserAuthIdentitiesQueryVariables
  >(UserAuthIdentitiesDocument, options);
}
export type UserAuthIdentitiesQueryHookResult = ReturnType<
  typeof useUserAuthIdentitiesQuery
>;
export type UserAuthIdentitiesLazyQueryHookResult = ReturnType<
  typeof useUserAuthIdentitiesLazyQuery
>;
export type UserAuthIdentitiesSuspenseQueryHookResult = ReturnType<
  typeof useUserAuthIdentitiesSuspenseQuery
>;
export type UserAuthIdentitiesQueryResult = ApolloReactCommon.QueryResult<
  UserAuthIdentitiesQuery,
  UserAuthIdentitiesQueryVariables
>;
export function refetchUserAuthIdentitiesQuery(
  variables?: UserAuthIdentitiesQueryVariables
) {
  return { query: UserAuthIdentitiesDocument, variables: variables };
}
export const UserHasActiveSubscriptionDocument = gql`
  query userHasActiveSubscription {
    getUser {
      id
      hasActiveSubscription
    }
  }
`;

/**
 * __useUserHasActiveSubscriptionQuery__
 *
 * To run a query within a React component, call `useUserHasActiveSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserHasActiveSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserHasActiveSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserHasActiveSubscriptionQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserHasActiveSubscriptionQuery,
    UserHasActiveSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    UserHasActiveSubscriptionQuery,
    UserHasActiveSubscriptionQueryVariables
  >(UserHasActiveSubscriptionDocument, options);
}
export function useUserHasActiveSubscriptionLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserHasActiveSubscriptionQuery,
    UserHasActiveSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    UserHasActiveSubscriptionQuery,
    UserHasActiveSubscriptionQueryVariables
  >(UserHasActiveSubscriptionDocument, options);
}
// @ts-ignore
export function useUserHasActiveSubscriptionSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    UserHasActiveSubscriptionQuery,
    UserHasActiveSubscriptionQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserHasActiveSubscriptionQuery,
  UserHasActiveSubscriptionQueryVariables
>;
export function useUserHasActiveSubscriptionSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserHasActiveSubscriptionQuery,
        UserHasActiveSubscriptionQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserHasActiveSubscriptionQuery | undefined,
  UserHasActiveSubscriptionQueryVariables
>;
export function useUserHasActiveSubscriptionSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserHasActiveSubscriptionQuery,
        UserHasActiveSubscriptionQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    UserHasActiveSubscriptionQuery,
    UserHasActiveSubscriptionQueryVariables
  >(UserHasActiveSubscriptionDocument, options);
}
export type UserHasActiveSubscriptionQueryHookResult = ReturnType<
  typeof useUserHasActiveSubscriptionQuery
>;
export type UserHasActiveSubscriptionLazyQueryHookResult = ReturnType<
  typeof useUserHasActiveSubscriptionLazyQuery
>;
export type UserHasActiveSubscriptionSuspenseQueryHookResult = ReturnType<
  typeof useUserHasActiveSubscriptionSuspenseQuery
>;
export type UserHasActiveSubscriptionQueryResult =
  ApolloReactCommon.QueryResult<
    UserHasActiveSubscriptionQuery,
    UserHasActiveSubscriptionQueryVariables
  >;
export function refetchUserHasActiveSubscriptionQuery(
  variables?: UserHasActiveSubscriptionQueryVariables
) {
  return { query: UserHasActiveSubscriptionDocument, variables: variables };
}
export const GetUserTotpStatusDocument = gql`
  query getUserTOTPStatus {
    getUser {
      id
      totpEnabled
    }
  }
`;

/**
 * __useGetUserTotpStatusQuery__
 *
 * To run a query within a React component, call `useGetUserTotpStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTotpStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTotpStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserTotpStatusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetUserTotpStatusQuery,
    GetUserTotpStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetUserTotpStatusQuery,
    GetUserTotpStatusQueryVariables
  >(GetUserTotpStatusDocument, options);
}
export function useGetUserTotpStatusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetUserTotpStatusQuery,
    GetUserTotpStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetUserTotpStatusQuery,
    GetUserTotpStatusQueryVariables
  >(GetUserTotpStatusDocument, options);
}
// @ts-ignore
export function useGetUserTotpStatusSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    GetUserTotpStatusQuery,
    GetUserTotpStatusQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  GetUserTotpStatusQuery,
  GetUserTotpStatusQueryVariables
>;
export function useGetUserTotpStatusSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetUserTotpStatusQuery,
        GetUserTotpStatusQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  GetUserTotpStatusQuery | undefined,
  GetUserTotpStatusQueryVariables
>;
export function useGetUserTotpStatusSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetUserTotpStatusQuery,
        GetUserTotpStatusQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    GetUserTotpStatusQuery,
    GetUserTotpStatusQueryVariables
  >(GetUserTotpStatusDocument, options);
}
export type GetUserTotpStatusQueryHookResult = ReturnType<
  typeof useGetUserTotpStatusQuery
>;
export type GetUserTotpStatusLazyQueryHookResult = ReturnType<
  typeof useGetUserTotpStatusLazyQuery
>;
export type GetUserTotpStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetUserTotpStatusSuspenseQuery
>;
export type GetUserTotpStatusQueryResult = ApolloReactCommon.QueryResult<
  GetUserTotpStatusQuery,
  GetUserTotpStatusQueryVariables
>;
export function refetchGetUserTotpStatusQuery(
  variables?: GetUserTotpStatusQueryVariables
) {
  return { query: GetUserTotpStatusDocument, variables: variables };
}
export const UserAdminStatusDocument = gql`
  query userAdminStatus {
    getUser {
      ...userAdminStatusData
    }
  }
  ${UserAdminStatusDataFragmentDoc}
`;

/**
 * __useUserAdminStatusQuery__
 *
 * To run a query within a React component, call `useUserAdminStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAdminStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAdminStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserAdminStatusQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserAdminStatusQuery,
    UserAdminStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    UserAdminStatusQuery,
    UserAdminStatusQueryVariables
  >(UserAdminStatusDocument, options);
}
export function useUserAdminStatusLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserAdminStatusQuery,
    UserAdminStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    UserAdminStatusQuery,
    UserAdminStatusQueryVariables
  >(UserAdminStatusDocument, options);
}
// @ts-ignore
export function useUserAdminStatusSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    UserAdminStatusQuery,
    UserAdminStatusQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserAdminStatusQuery,
  UserAdminStatusQueryVariables
>;
export function useUserAdminStatusSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserAdminStatusQuery,
        UserAdminStatusQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserAdminStatusQuery | undefined,
  UserAdminStatusQueryVariables
>;
export function useUserAdminStatusSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserAdminStatusQuery,
        UserAdminStatusQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    UserAdminStatusQuery,
    UserAdminStatusQueryVariables
  >(UserAdminStatusDocument, options);
}
export type UserAdminStatusQueryHookResult = ReturnType<
  typeof useUserAdminStatusQuery
>;
export type UserAdminStatusLazyQueryHookResult = ReturnType<
  typeof useUserAdminStatusLazyQuery
>;
export type UserAdminStatusSuspenseQueryHookResult = ReturnType<
  typeof useUserAdminStatusSuspenseQuery
>;
export type UserAdminStatusQueryResult = ApolloReactCommon.QueryResult<
  UserAdminStatusQuery,
  UserAdminStatusQueryVariables
>;
export function refetchUserAdminStatusQuery(
  variables?: UserAdminStatusQueryVariables
) {
  return { query: UserAdminStatusDocument, variables: variables };
}
export const UserProfileDocument = gql`
  query userProfile {
    getUser {
      id
      firstName
      lastName
      companyName
      vatNumber
      phone
      address
      houseNumber
      zip
      city
      country
      amountToInvest
    }
  }
`;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserProfileQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserProfileQuery,
    UserProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<UserProfileQuery, UserProfileQueryVariables>(
    UserProfileDocument,
    options
  );
}
export function useUserProfileLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserProfileQuery,
    UserProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    UserProfileQuery,
    UserProfileQueryVariables
  >(UserProfileDocument, options);
}
// @ts-ignore
export function useUserProfileSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    UserProfileQuery,
    UserProfileQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserProfileQuery,
  UserProfileQueryVariables
>;
export function useUserProfileSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserProfileQuery,
        UserProfileQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserProfileQuery | undefined,
  UserProfileQueryVariables
>;
export function useUserProfileSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserProfileQuery,
        UserProfileQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    UserProfileQuery,
    UserProfileQueryVariables
  >(UserProfileDocument, options);
}
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<
  typeof useUserProfileLazyQuery
>;
export type UserProfileSuspenseQueryHookResult = ReturnType<
  typeof useUserProfileSuspenseQuery
>;
export type UserProfileQueryResult = ApolloReactCommon.QueryResult<
  UserProfileQuery,
  UserProfileQueryVariables
>;
export function refetchUserProfileQuery(variables?: UserProfileQueryVariables) {
  return { query: UserProfileDocument, variables: variables };
}
export const ControllingUserDocument = gql`
  query controllingUser {
    getUser {
      id
      controlledByUser {
        id
      }
    }
  }
`;

/**
 * __useControllingUserQuery__
 *
 * To run a query within a React component, call `useControllingUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useControllingUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControllingUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useControllingUserQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    ControllingUserQuery,
    ControllingUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    ControllingUserQuery,
    ControllingUserQueryVariables
  >(ControllingUserDocument, options);
}
export function useControllingUserLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ControllingUserQuery,
    ControllingUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    ControllingUserQuery,
    ControllingUserQueryVariables
  >(ControllingUserDocument, options);
}
// @ts-ignore
export function useControllingUserSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    ControllingUserQuery,
    ControllingUserQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  ControllingUserQuery,
  ControllingUserQueryVariables
>;
export function useControllingUserSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        ControllingUserQuery,
        ControllingUserQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  ControllingUserQuery | undefined,
  ControllingUserQueryVariables
>;
export function useControllingUserSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        ControllingUserQuery,
        ControllingUserQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    ControllingUserQuery,
    ControllingUserQueryVariables
  >(ControllingUserDocument, options);
}
export type ControllingUserQueryHookResult = ReturnType<
  typeof useControllingUserQuery
>;
export type ControllingUserLazyQueryHookResult = ReturnType<
  typeof useControllingUserLazyQuery
>;
export type ControllingUserSuspenseQueryHookResult = ReturnType<
  typeof useControllingUserSuspenseQuery
>;
export type ControllingUserQueryResult = ApolloReactCommon.QueryResult<
  ControllingUserQuery,
  ControllingUserQueryVariables
>;
export function refetchControllingUserQuery(
  variables?: ControllingUserQueryVariables
) {
  return { query: ControllingUserDocument, variables: variables };
}
export const UserSubscriptionReferralCodeAndDiscountDocument = gql`
  query userSubscriptionReferralCodeAndDiscount {
    getUser {
      id
      personalReferalCode
      pendingDiscount
    }
  }
`;

/**
 * __useUserSubscriptionReferralCodeAndDiscountQuery__
 *
 * To run a query within a React component, call `useUserSubscriptionReferralCodeAndDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSubscriptionReferralCodeAndDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSubscriptionReferralCodeAndDiscountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSubscriptionReferralCodeAndDiscountQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserSubscriptionReferralCodeAndDiscountQuery,
    UserSubscriptionReferralCodeAndDiscountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    UserSubscriptionReferralCodeAndDiscountQuery,
    UserSubscriptionReferralCodeAndDiscountQueryVariables
  >(UserSubscriptionReferralCodeAndDiscountDocument, options);
}
export function useUserSubscriptionReferralCodeAndDiscountLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserSubscriptionReferralCodeAndDiscountQuery,
    UserSubscriptionReferralCodeAndDiscountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    UserSubscriptionReferralCodeAndDiscountQuery,
    UserSubscriptionReferralCodeAndDiscountQueryVariables
  >(UserSubscriptionReferralCodeAndDiscountDocument, options);
}
// @ts-ignore
export function useUserSubscriptionReferralCodeAndDiscountSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    UserSubscriptionReferralCodeAndDiscountQuery,
    UserSubscriptionReferralCodeAndDiscountQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserSubscriptionReferralCodeAndDiscountQuery,
  UserSubscriptionReferralCodeAndDiscountQueryVariables
>;
export function useUserSubscriptionReferralCodeAndDiscountSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserSubscriptionReferralCodeAndDiscountQuery,
        UserSubscriptionReferralCodeAndDiscountQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserSubscriptionReferralCodeAndDiscountQuery | undefined,
  UserSubscriptionReferralCodeAndDiscountQueryVariables
>;
export function useUserSubscriptionReferralCodeAndDiscountSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserSubscriptionReferralCodeAndDiscountQuery,
        UserSubscriptionReferralCodeAndDiscountQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    UserSubscriptionReferralCodeAndDiscountQuery,
    UserSubscriptionReferralCodeAndDiscountQueryVariables
  >(UserSubscriptionReferralCodeAndDiscountDocument, options);
}
export type UserSubscriptionReferralCodeAndDiscountQueryHookResult = ReturnType<
  typeof useUserSubscriptionReferralCodeAndDiscountQuery
>;
export type UserSubscriptionReferralCodeAndDiscountLazyQueryHookResult =
  ReturnType<typeof useUserSubscriptionReferralCodeAndDiscountLazyQuery>;
export type UserSubscriptionReferralCodeAndDiscountSuspenseQueryHookResult =
  ReturnType<typeof useUserSubscriptionReferralCodeAndDiscountSuspenseQuery>;
export type UserSubscriptionReferralCodeAndDiscountQueryResult =
  ApolloReactCommon.QueryResult<
    UserSubscriptionReferralCodeAndDiscountQuery,
    UserSubscriptionReferralCodeAndDiscountQueryVariables
  >;
export function refetchUserSubscriptionReferralCodeAndDiscountQuery(
  variables?: UserSubscriptionReferralCodeAndDiscountQueryVariables
) {
  return {
    query: UserSubscriptionReferralCodeAndDiscountDocument,
    variables: variables,
  };
}
export const UserTrialEndDateDocument = gql`
  query userTrialEndDate {
    getUser {
      id
      trialEndDate
    }
  }
`;

/**
 * __useUserTrialEndDateQuery__
 *
 * To run a query within a React component, call `useUserTrialEndDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTrialEndDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTrialEndDateQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTrialEndDateQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserTrialEndDateQuery,
    UserTrialEndDateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    UserTrialEndDateQuery,
    UserTrialEndDateQueryVariables
  >(UserTrialEndDateDocument, options);
}
export function useUserTrialEndDateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserTrialEndDateQuery,
    UserTrialEndDateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    UserTrialEndDateQuery,
    UserTrialEndDateQueryVariables
  >(UserTrialEndDateDocument, options);
}
// @ts-ignore
export function useUserTrialEndDateSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    UserTrialEndDateQuery,
    UserTrialEndDateQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserTrialEndDateQuery,
  UserTrialEndDateQueryVariables
>;
export function useUserTrialEndDateSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserTrialEndDateQuery,
        UserTrialEndDateQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserTrialEndDateQuery | undefined,
  UserTrialEndDateQueryVariables
>;
export function useUserTrialEndDateSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserTrialEndDateQuery,
        UserTrialEndDateQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    UserTrialEndDateQuery,
    UserTrialEndDateQueryVariables
  >(UserTrialEndDateDocument, options);
}
export type UserTrialEndDateQueryHookResult = ReturnType<
  typeof useUserTrialEndDateQuery
>;
export type UserTrialEndDateLazyQueryHookResult = ReturnType<
  typeof useUserTrialEndDateLazyQuery
>;
export type UserTrialEndDateSuspenseQueryHookResult = ReturnType<
  typeof useUserTrialEndDateSuspenseQuery
>;
export type UserTrialEndDateQueryResult = ApolloReactCommon.QueryResult<
  UserTrialEndDateQuery,
  UserTrialEndDateQueryVariables
>;
export function refetchUserTrialEndDateQuery(
  variables?: UserTrialEndDateQueryVariables
) {
  return { query: UserTrialEndDateDocument, variables: variables };
}
export const UserValidProfileDocument = gql`
  query userValidProfile {
    getUser {
      id
      profileValid
    }
  }
`;

/**
 * __useUserValidProfileQuery__
 *
 * To run a query within a React component, call `useUserValidProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserValidProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserValidProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserValidProfileQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserValidProfileQuery,
    UserValidProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    UserValidProfileQuery,
    UserValidProfileQueryVariables
  >(UserValidProfileDocument, options);
}
export function useUserValidProfileLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserValidProfileQuery,
    UserValidProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    UserValidProfileQuery,
    UserValidProfileQueryVariables
  >(UserValidProfileDocument, options);
}
// @ts-ignore
export function useUserValidProfileSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    UserValidProfileQuery,
    UserValidProfileQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserValidProfileQuery,
  UserValidProfileQueryVariables
>;
export function useUserValidProfileSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserValidProfileQuery,
        UserValidProfileQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserValidProfileQuery | undefined,
  UserValidProfileQueryVariables
>;
export function useUserValidProfileSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserValidProfileQuery,
        UserValidProfileQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    UserValidProfileQuery,
    UserValidProfileQueryVariables
  >(UserValidProfileDocument, options);
}
export type UserValidProfileQueryHookResult = ReturnType<
  typeof useUserValidProfileQuery
>;
export type UserValidProfileLazyQueryHookResult = ReturnType<
  typeof useUserValidProfileLazyQuery
>;
export type UserValidProfileSuspenseQueryHookResult = ReturnType<
  typeof useUserValidProfileSuspenseQuery
>;
export type UserValidProfileQueryResult = ApolloReactCommon.QueryResult<
  UserValidProfileQuery,
  UserValidProfileQueryVariables
>;
export function refetchUserValidProfileQuery(
  variables?: UserValidProfileQueryVariables
) {
  return { query: UserValidProfileDocument, variables: variables };
}
export const UserChatBoxDataDocument = gql`
  query userChatBoxData {
    getUser {
      id
      authIdentities {
        uid
        provider
      }
      firstName
      lastName
      phone
    }
  }
`;

/**
 * __useUserChatBoxDataQuery__
 *
 * To run a query within a React component, call `useUserChatBoxDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserChatBoxDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserChatBoxDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserChatBoxDataQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserChatBoxDataQuery,
    UserChatBoxDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    UserChatBoxDataQuery,
    UserChatBoxDataQueryVariables
  >(UserChatBoxDataDocument, options);
}
export function useUserChatBoxDataLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserChatBoxDataQuery,
    UserChatBoxDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    UserChatBoxDataQuery,
    UserChatBoxDataQueryVariables
  >(UserChatBoxDataDocument, options);
}
// @ts-ignore
export function useUserChatBoxDataSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    UserChatBoxDataQuery,
    UserChatBoxDataQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserChatBoxDataQuery,
  UserChatBoxDataQueryVariables
>;
export function useUserChatBoxDataSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserChatBoxDataQuery,
        UserChatBoxDataQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserChatBoxDataQuery | undefined,
  UserChatBoxDataQueryVariables
>;
export function useUserChatBoxDataSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserChatBoxDataQuery,
        UserChatBoxDataQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    UserChatBoxDataQuery,
    UserChatBoxDataQueryVariables
  >(UserChatBoxDataDocument, options);
}
export type UserChatBoxDataQueryHookResult = ReturnType<
  typeof useUserChatBoxDataQuery
>;
export type UserChatBoxDataLazyQueryHookResult = ReturnType<
  typeof useUserChatBoxDataLazyQuery
>;
export type UserChatBoxDataSuspenseQueryHookResult = ReturnType<
  typeof useUserChatBoxDataSuspenseQuery
>;
export type UserChatBoxDataQueryResult = ApolloReactCommon.QueryResult<
  UserChatBoxDataQuery,
  UserChatBoxDataQueryVariables
>;
export function refetchUserChatBoxDataQuery(
  variables?: UserChatBoxDataQueryVariables
) {
  return { query: UserChatBoxDataDocument, variables: variables };
}
export const UserNotificationsDocument = gql`
  query userNotifications {
    getUserNotifications {
      id: NotificationId
      type: NotificationType
    }
  }
`;

/**
 * __useUserNotificationsQuery__
 *
 * To run a query within a React component, call `useUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserNotificationsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserNotificationsQuery,
    UserNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    UserNotificationsQuery,
    UserNotificationsQueryVariables
  >(UserNotificationsDocument, options);
}
export function useUserNotificationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserNotificationsQuery,
    UserNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    UserNotificationsQuery,
    UserNotificationsQueryVariables
  >(UserNotificationsDocument, options);
}
// @ts-ignore
export function useUserNotificationsSuspenseQuery(
  baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<
    UserNotificationsQuery,
    UserNotificationsQueryVariables
  >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserNotificationsQuery,
  UserNotificationsQueryVariables
>;
export function useUserNotificationsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserNotificationsQuery,
        UserNotificationsQueryVariables
      >
): ApolloReactHooks.UseSuspenseQueryResult<
  UserNotificationsQuery | undefined,
  UserNotificationsQueryVariables
>;
export function useUserNotificationsSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        UserNotificationsQuery,
        UserNotificationsQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    UserNotificationsQuery,
    UserNotificationsQueryVariables
  >(UserNotificationsDocument, options);
}
export type UserNotificationsQueryHookResult = ReturnType<
  typeof useUserNotificationsQuery
>;
export type UserNotificationsLazyQueryHookResult = ReturnType<
  typeof useUserNotificationsLazyQuery
>;
export type UserNotificationsSuspenseQueryHookResult = ReturnType<
  typeof useUserNotificationsSuspenseQuery
>;
export type UserNotificationsQueryResult = ApolloReactCommon.QueryResult<
  UserNotificationsQuery,
  UserNotificationsQueryVariables
>;
export function refetchUserNotificationsQuery(
  variables?: UserNotificationsQueryVariables
) {
  return { query: UserNotificationsDocument, variables: variables };
}
export const GenerateQrCodeDocument = gql`
  mutation generateQRCode {
    totpGenerate
  }
`;
export type GenerateQrCodeMutationFn = ApolloReactCommon.MutationFunction<
  GenerateQrCodeMutation,
  GenerateQrCodeMutationVariables
>;

/**
 * __useGenerateQrCodeMutation__
 *
 * To run a mutation, you first call `useGenerateQrCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateQrCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateQrCodeMutation, { data, loading, error }] = useGenerateQrCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateQrCodeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    GenerateQrCodeMutation,
    GenerateQrCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    GenerateQrCodeMutation,
    GenerateQrCodeMutationVariables
  >(GenerateQrCodeDocument, options);
}
export type GenerateQrCodeMutationHookResult = ReturnType<
  typeof useGenerateQrCodeMutation
>;
export type GenerateQrCodeMutationResult =
  ApolloReactCommon.MutationResult<GenerateQrCodeMutation>;
export type GenerateQrCodeMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    GenerateQrCodeMutation,
    GenerateQrCodeMutationVariables
  >;
export const TotpVerifyDocument = gql`
  mutation totpVerify($code: String!) {
    totpVerify(code: $code) {
      token
    }
  }
`;
export type TotpVerifyMutationFn = ApolloReactCommon.MutationFunction<
  TotpVerifyMutation,
  TotpVerifyMutationVariables
>;

/**
 * __useTotpVerifyMutation__
 *
 * To run a mutation, you first call `useTotpVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTotpVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [totpVerifyMutation, { data, loading, error }] = useTotpVerifyMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useTotpVerifyMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    TotpVerifyMutation,
    TotpVerifyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    TotpVerifyMutation,
    TotpVerifyMutationVariables
  >(TotpVerifyDocument, options);
}
export type TotpVerifyMutationHookResult = ReturnType<
  typeof useTotpVerifyMutation
>;
export type TotpVerifyMutationResult =
  ApolloReactCommon.MutationResult<TotpVerifyMutation>;
export type TotpVerifyMutationOptions = ApolloReactCommon.BaseMutationOptions<
  TotpVerifyMutation,
  TotpVerifyMutationVariables
>;
export const TotpSetupDocument = gql`
  mutation totpSetup($code: String!) {
    totpSetup(code: $code) {
      backupCodes
    }
  }
`;
export type TotpSetupMutationFn = ApolloReactCommon.MutationFunction<
  TotpSetupMutation,
  TotpSetupMutationVariables
>;

/**
 * __useTotpSetupMutation__
 *
 * To run a mutation, you first call `useTotpSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTotpSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [totpSetupMutation, { data, loading, error }] = useTotpSetupMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useTotpSetupMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    TotpSetupMutation,
    TotpSetupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    TotpSetupMutation,
    TotpSetupMutationVariables
  >(TotpSetupDocument, options);
}
export type TotpSetupMutationHookResult = ReturnType<
  typeof useTotpSetupMutation
>;
export type TotpSetupMutationResult =
  ApolloReactCommon.MutationResult<TotpSetupMutation>;
export type TotpSetupMutationOptions = ApolloReactCommon.BaseMutationOptions<
  TotpSetupMutation,
  TotpSetupMutationVariables
>;
export const TotpDisableDocument = gql`
  mutation totpDisable($code: String!) {
    totpDisable(code: $code) {
      success
    }
  }
`;
export type TotpDisableMutationFn = ApolloReactCommon.MutationFunction<
  TotpDisableMutation,
  TotpDisableMutationVariables
>;

/**
 * __useTotpDisableMutation__
 *
 * To run a mutation, you first call `useTotpDisableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTotpDisableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [totpDisableMutation, { data, loading, error }] = useTotpDisableMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useTotpDisableMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    TotpDisableMutation,
    TotpDisableMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    TotpDisableMutation,
    TotpDisableMutationVariables
  >(TotpDisableDocument, options);
}
export type TotpDisableMutationHookResult = ReturnType<
  typeof useTotpDisableMutation
>;
export type TotpDisableMutationResult =
  ApolloReactCommon.MutationResult<TotpDisableMutation>;
export type TotpDisableMutationOptions = ApolloReactCommon.BaseMutationOptions<
  TotpDisableMutation,
  TotpDisableMutationVariables
>;
export const ResendVerificationEmailDocument = gql`
  mutation resendVerificationEmail($id: Int) {
    resendVerificationEmail(authIdentityId: $id)
  }
`;
export type ResendVerificationEmailMutationFn =
  ApolloReactCommon.MutationFunction<
    ResendVerificationEmailMutation,
    ResendVerificationEmailMutationVariables
  >;

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendVerificationEmailMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ResendVerificationEmailMutation,
    ResendVerificationEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    ResendVerificationEmailMutation,
    ResendVerificationEmailMutationVariables
  >(ResendVerificationEmailDocument, options);
}
export type ResendVerificationEmailMutationHookResult = ReturnType<
  typeof useResendVerificationEmailMutation
>;
export type ResendVerificationEmailMutationResult =
  ApolloReactCommon.MutationResult<ResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ResendVerificationEmailMutation,
    ResendVerificationEmailMutationVariables
  >;
export const EditUserProfileDocument = gql`
  mutation editUserProfile(
    $firstName: String
    $lastName: String
    $companyName: String
    $vatNumber: String
    $address: String
    $city: String
    $phone: String
    $houseNumber: String
    $zip: String
    $country: String
    $amountToInvest: Int
    $referralCode: String
    $olderThan18AndTermsAccepted: Boolean
    $sendMeNews: Boolean
    $notUsPerson: Boolean
  ) {
    editProfile(
      firstName: $firstName
      lastName: $lastName
      companyName: $companyName
      vatNumber: $vatNumber
      address: $address
      city: $city
      phone: $phone
      houseNumber: $houseNumber
      zip: $zip
      country: $country
      amountToInvest: $amountToInvest
      sharedReferralCode: $referralCode
      olderThan18AndTermsAccepted: $olderThan18AndTermsAccepted
      sendMeNews: $sendMeNews
      notUsPerson: $notUsPerson
    ) {
      id
      firstName
      lastName
      companyName
      vatNumber
      address
      city
      phone
      houseNumber
      zip
      country
      amountToInvest
      profileValid
    }
  }
`;
export type EditUserProfileMutationFn = ApolloReactCommon.MutationFunction<
  EditUserProfileMutation,
  EditUserProfileMutationVariables
>;

/**
 * __useEditUserProfileMutation__
 *
 * To run a mutation, you first call `useEditUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserProfileMutation, { data, loading, error }] = useEditUserProfileMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      companyName: // value for 'companyName'
 *      vatNumber: // value for 'vatNumber'
 *      address: // value for 'address'
 *      city: // value for 'city'
 *      phone: // value for 'phone'
 *      houseNumber: // value for 'houseNumber'
 *      zip: // value for 'zip'
 *      country: // value for 'country'
 *      amountToInvest: // value for 'amountToInvest'
 *      referralCode: // value for 'referralCode'
 *      olderThan18AndTermsAccepted: // value for 'olderThan18AndTermsAccepted'
 *      sendMeNews: // value for 'sendMeNews'
 *      notUsPerson: // value for 'notUsPerson'
 *   },
 * });
 */
export function useEditUserProfileMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EditUserProfileMutation,
    EditUserProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    EditUserProfileMutation,
    EditUserProfileMutationVariables
  >(EditUserProfileDocument, options);
}
export type EditUserProfileMutationHookResult = ReturnType<
  typeof useEditUserProfileMutation
>;
export type EditUserProfileMutationResult =
  ApolloReactCommon.MutationResult<EditUserProfileMutation>;
export type EditUserProfileMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    EditUserProfileMutation,
    EditUserProfileMutationVariables
  >;
export const ChangeUserEmailDocument = gql`
  mutation changeUserEmail($email: String, $currentPassword: String!) {
    changeCredentials(email: $email, currentPassword: $currentPassword) {
      id
    }
  }
`;
export type ChangeUserEmailMutationFn = ApolloReactCommon.MutationFunction<
  ChangeUserEmailMutation,
  ChangeUserEmailMutationVariables
>;

/**
 * __useChangeUserEmailMutation__
 *
 * To run a mutation, you first call `useChangeUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserEmailMutation, { data, loading, error }] = useChangeUserEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      currentPassword: // value for 'currentPassword'
 *   },
 * });
 */
export function useChangeUserEmailMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ChangeUserEmailMutation,
    ChangeUserEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    ChangeUserEmailMutation,
    ChangeUserEmailMutationVariables
  >(ChangeUserEmailDocument, options);
}
export type ChangeUserEmailMutationHookResult = ReturnType<
  typeof useChangeUserEmailMutation
>;
export type ChangeUserEmailMutationResult =
  ApolloReactCommon.MutationResult<ChangeUserEmailMutation>;
export type ChangeUserEmailMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ChangeUserEmailMutation,
    ChangeUserEmailMutationVariables
  >;
export const ChangeUserPasswordDocument = gql`
  mutation changeUserPassword($currentPassword: String!, $password: String) {
    changeCredentials(currentPassword: $currentPassword, password: $password) {
      id
    }
  }
`;
export type ChangeUserPasswordMutationFn = ApolloReactCommon.MutationFunction<
  ChangeUserPasswordMutation,
  ChangeUserPasswordMutationVariables
>;

/**
 * __useChangeUserPasswordMutation__
 *
 * To run a mutation, you first call `useChangeUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserPasswordMutation, { data, loading, error }] = useChangeUserPasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangeUserPasswordMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ChangeUserPasswordMutation,
    ChangeUserPasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    ChangeUserPasswordMutation,
    ChangeUserPasswordMutationVariables
  >(ChangeUserPasswordDocument, options);
}
export type ChangeUserPasswordMutationHookResult = ReturnType<
  typeof useChangeUserPasswordMutation
>;
export type ChangeUserPasswordMutationResult =
  ApolloReactCommon.MutationResult<ChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ChangeUserPasswordMutation,
    ChangeUserPasswordMutationVariables
  >;
export const ResetPasswordDocument = gql`
  mutation resetPassword($password: String!) {
    resetPassword(password: $password) {
      success
    }
  }
`;
export type ResetPasswordMutationFn = ApolloReactCommon.MutationFunction<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >(ResetPasswordDocument, options);
}
export type ResetPasswordMutationHookResult = ReturnType<
  typeof useResetPasswordMutation
>;
export type ResetPasswordMutationResult =
  ApolloReactCommon.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >;
export const SendRestPasswordEmailDocument = gql`
  mutation sendRestPasswordEmail(
    $email: String!
    $captchaToken: String
    $captchaV2Token: String
  ) {
    sendResetPasswordEmail(
      email: $email
      captchaToken: $captchaToken
      captchaV2Token: $captchaV2Token
    ) {
      success
    }
  }
`;
export type SendRestPasswordEmailMutationFn =
  ApolloReactCommon.MutationFunction<
    SendRestPasswordEmailMutation,
    SendRestPasswordEmailMutationVariables
  >;

/**
 * __useSendRestPasswordEmailMutation__
 *
 * To run a mutation, you first call `useSendRestPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRestPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRestPasswordEmailMutation, { data, loading, error }] = useSendRestPasswordEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      captchaToken: // value for 'captchaToken'
 *      captchaV2Token: // value for 'captchaV2Token'
 *   },
 * });
 */
export function useSendRestPasswordEmailMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SendRestPasswordEmailMutation,
    SendRestPasswordEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    SendRestPasswordEmailMutation,
    SendRestPasswordEmailMutationVariables
  >(SendRestPasswordEmailDocument, options);
}
export type SendRestPasswordEmailMutationHookResult = ReturnType<
  typeof useSendRestPasswordEmailMutation
>;
export type SendRestPasswordEmailMutationResult =
  ApolloReactCommon.MutationResult<SendRestPasswordEmailMutation>;
export type SendRestPasswordEmailMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SendRestPasswordEmailMutation,
    SendRestPasswordEmailMutationVariables
  >;
export const RemoveAccountDocument = gql`
  mutation removeAccount($currentPassword: String) {
    removeUser(password: $currentPassword) {
      success
    }
  }
`;
export type RemoveAccountMutationFn = ApolloReactCommon.MutationFunction<
  RemoveAccountMutation,
  RemoveAccountMutationVariables
>;

/**
 * __useRemoveAccountMutation__
 *
 * To run a mutation, you first call `useRemoveAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAccountMutation, { data, loading, error }] = useRemoveAccountMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *   },
 * });
 */
export function useRemoveAccountMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RemoveAccountMutation,
    RemoveAccountMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    RemoveAccountMutation,
    RemoveAccountMutationVariables
  >(RemoveAccountDocument, options);
}
export type RemoveAccountMutationHookResult = ReturnType<
  typeof useRemoveAccountMutation
>;
export type RemoveAccountMutationResult =
  ApolloReactCommon.MutationResult<RemoveAccountMutation>;
export type RemoveAccountMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RemoveAccountMutation,
    RemoveAccountMutationVariables
  >;
export type AdminPerformanceResponseKeySpecifier = (
  | 'rate24'
  | 'start'
  | 'year'
  | 'ytd'
  | AdminPerformanceResponseKeySpecifier
)[];
export type AdminPerformanceResponseFieldPolicy = {
  rate24?: FieldPolicy<any> | FieldReadFunction<any>;
  start?: FieldPolicy<any> | FieldReadFunction<any>;
  year?: FieldPolicy<any> | FieldReadFunction<any>;
  ytd?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AdminSignInAsResponseKeySpecifier = (
  | 'authIdentityID'
  | 'token'
  | 'totpEnabled'
  | AdminSignInAsResponseKeySpecifier
)[];
export type AdminSignInAsResponseFieldPolicy = {
  authIdentityID?: FieldPolicy<any> | FieldReadFunction<any>;
  token?: FieldPolicy<any> | FieldReadFunction<any>;
  totpEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AdminUserResponseKeySpecifier = (
  | 'address'
  | 'amountToInvest'
  | 'authIdentities'
  | 'authProvider'
  | 'city'
  | 'companyName'
  | 'controlledByUser'
  | 'country'
  | 'currenciesLocked'
  | 'customStatuses'
  | 'dateOfBirth'
  | 'dateOfSignup'
  | 'deletedAt'
  | 'exchanges'
  | 'firstName'
  | 'gender'
  | 'hadCreditCard'
  | 'hasActiveSubscription'
  | 'hasUnpaidInvoices'
  | 'houseNumber'
  | 'id'
  | 'isAdmin'
  | 'lastName'
  | 'mollieStatus'
  | 'moneyPaid'
  | 'nextRebalancingOn'
  | 'paymentSources'
  | 'pendingDiscount'
  | 'personalReferalCode'
  | 'phone'
  | 'profileValid'
  | 'referralCode'
  | 'state'
  | 'status'
  | 'stripeStatus'
  | 'totpEnabled'
  | 'trialEndDate'
  | 'vatNumber'
  | 'zip'
  | AdminUserResponseKeySpecifier
)[];
export type AdminUserResponseFieldPolicy = {
  address?: FieldPolicy<any> | FieldReadFunction<any>;
  amountToInvest?: FieldPolicy<any> | FieldReadFunction<any>;
  authIdentities?: FieldPolicy<any> | FieldReadFunction<any>;
  authProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  controlledByUser?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  currenciesLocked?: FieldPolicy<any> | FieldReadFunction<any>;
  customStatuses?: FieldPolicy<any> | FieldReadFunction<any>;
  dateOfBirth?: FieldPolicy<any> | FieldReadFunction<any>;
  dateOfSignup?: FieldPolicy<any> | FieldReadFunction<any>;
  deletedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  exchanges?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  gender?: FieldPolicy<any> | FieldReadFunction<any>;
  hadCreditCard?: FieldPolicy<any> | FieldReadFunction<any>;
  hasActiveSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  hasUnpaidInvoices?: FieldPolicy<any> | FieldReadFunction<any>;
  houseNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isAdmin?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  mollieStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  moneyPaid?: FieldPolicy<any> | FieldReadFunction<any>;
  nextRebalancingOn?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentSources?: FieldPolicy<any> | FieldReadFunction<any>;
  pendingDiscount?: FieldPolicy<any> | FieldReadFunction<any>;
  personalReferalCode?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  profileValid?: FieldPolicy<any> | FieldReadFunction<any>;
  referralCode?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  stripeStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  totpEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  trialEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  vatNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  zip?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AdminUsersResponseKeySpecifier = (
  | 'limit'
  | 'offset'
  | 'total'
  | 'totalAum'
  | 'totalPaid'
  | 'users'
  | AdminUsersResponseKeySpecifier
)[];
export type AdminUsersResponseFieldPolicy = {
  limit?: FieldPolicy<any> | FieldReadFunction<any>;
  offset?: FieldPolicy<any> | FieldReadFunction<any>;
  total?: FieldPolicy<any> | FieldReadFunction<any>;
  totalAum?: FieldPolicy<any> | FieldReadFunction<any>;
  totalPaid?: FieldPolicy<any> | FieldReadFunction<any>;
  users?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AggregatedDataRowKeySpecifier = (
  | 'date'
  | 'value'
  | AggregatedDataRowKeySpecifier
)[];
export type AggregatedDataRowFieldPolicy = {
  date?: FieldPolicy<any> | FieldReadFunction<any>;
  value?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type AuthIdentityResponseKeySpecifier = (
  | 'confirmedAt'
  | 'createdAt'
  | 'deletedAt'
  | 'id'
  | 'provider'
  | 'uid'
  | 'updatedAt'
  | AuthIdentityResponseKeySpecifier
)[];
export type AuthIdentityResponseFieldPolicy = {
  confirmedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  deletedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  provider?: FieldPolicy<any> | FieldReadFunction<any>;
  uid?: FieldPolicy<any> | FieldReadFunction<any>;
  updatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CurrencyKeySpecifier = (
  | 'btc24RateValue'
  | 'btcValue'
  | 'eur24RateValue'
  | 'eurValue'
  | 'icon'
  | 'id'
  | 'isFiat'
  | 'messari'
  | 'piechartColor'
  | 'symbol'
  | 'targetForSale'
  | 'title'
  | 'usd24RateValue'
  | 'usdValue'
  | CurrencyKeySpecifier
)[];
export type CurrencyFieldPolicy = {
  btc24RateValue?: FieldPolicy<any> | FieldReadFunction<any>;
  btcValue?: FieldPolicy<any> | FieldReadFunction<any>;
  eur24RateValue?: FieldPolicy<any> | FieldReadFunction<any>;
  eurValue?: FieldPolicy<any> | FieldReadFunction<any>;
  icon?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isFiat?: FieldPolicy<any> | FieldReadFunction<any>;
  messari?: FieldPolicy<any> | FieldReadFunction<any>;
  piechartColor?: FieldPolicy<any> | FieldReadFunction<any>;
  symbol?: FieldPolicy<any> | FieldReadFunction<any>;
  targetForSale?: FieldPolicy<any> | FieldReadFunction<any>;
  title?: FieldPolicy<any> | FieldReadFunction<any>;
  usd24RateValue?: FieldPolicy<any> | FieldReadFunction<any>;
  usdValue?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type CurrencyPortfolioPercentageCostResponseKeySpecifier = (
  | 'amount'
  | 'partitionAction'
  | CurrencyPortfolioPercentageCostResponseKeySpecifier
)[];
export type CurrencyPortfolioPercentageCostResponseFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  partitionAction?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type DirectInvoicePaymentResponseKeySpecifier = (
  | 'checkoutURL'
  | DirectInvoicePaymentResponseKeySpecifier
)[];
export type DirectInvoicePaymentResponseFieldPolicy = {
  checkoutURL?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ExchangeResponseKeySpecifier = (
  | 'exchangeCode'
  | 'exchangeName'
  | 'id'
  | ExchangeResponseKeySpecifier
)[];
export type ExchangeResponseFieldPolicy = {
  exchangeCode?: FieldPolicy<any> | FieldReadFunction<any>;
  exchangeName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ExpectedPortfolioRowResponseKeySpecifier = (
  | 'amountCoins'
  | 'change24'
  | 'change24Amount'
  | 'change24Percentage'
  | 'cost'
  | 'currency'
  | 'currentCost'
  | 'effectiveDate'
  | 'percentage'
  | 'status'
  | 'usdChange24Amount'
  | 'usdChange24Percentage'
  | 'usdCost'
  | ExpectedPortfolioRowResponseKeySpecifier
)[];
export type ExpectedPortfolioRowResponseFieldPolicy = {
  amountCoins?: FieldPolicy<any> | FieldReadFunction<any>;
  change24?: FieldPolicy<any> | FieldReadFunction<any>;
  change24Amount?: FieldPolicy<any> | FieldReadFunction<any>;
  change24Percentage?: FieldPolicy<any> | FieldReadFunction<any>;
  cost?: FieldPolicy<any> | FieldReadFunction<any>;
  currency?: FieldPolicy<any> | FieldReadFunction<any>;
  currentCost?: FieldPolicy<any> | FieldReadFunction<any>;
  effectiveDate?: FieldPolicy<any> | FieldReadFunction<any>;
  percentage?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  usdChange24Amount?: FieldPolicy<any> | FieldReadFunction<any>;
  usdChange24Percentage?: FieldPolicy<any> | FieldReadFunction<any>;
  usdCost?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type GoogleSignInResponseKeySpecifier = (
  | 'authIdentityID'
  | 'profileValid'
  | 'token'
  | 'totpEnabled'
  | GoogleSignInResponseKeySpecifier
)[];
export type GoogleSignInResponseFieldPolicy = {
  authIdentityID?: FieldPolicy<any> | FieldReadFunction<any>;
  profileValid?: FieldPolicy<any> | FieldReadFunction<any>;
  token?: FieldPolicy<any> | FieldReadFunction<any>;
  totpEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type GoogleSignUpResponseKeySpecifier = (
  | 'authIdentityID'
  | 'profileValid'
  | 'token'
  | 'totpEnabled'
  | GoogleSignUpResponseKeySpecifier
)[];
export type GoogleSignUpResponseFieldPolicy = {
  authIdentityID?: FieldPolicy<any> | FieldReadFunction<any>;
  profileValid?: FieldPolicy<any> | FieldReadFunction<any>;
  token?: FieldPolicy<any> | FieldReadFunction<any>;
  totpEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvoiceListResponseKeySpecifier = (
  | 'activeTotal'
  | 'invoices'
  | InvoiceListResponseKeySpecifier
)[];
export type InvoiceListResponseFieldPolicy = {
  activeTotal?: FieldPolicy<any> | FieldReadFunction<any>;
  invoices?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvoiceResponseKeySpecifier = (
  | 'amount'
  | 'cost'
  | 'costExVat'
  | 'dueDate'
  | 'fileName'
  | 'id'
  | 'price'
  | 'status'
  | 'strategy'
  | 'total'
  | 'url'
  | 'user'
  | 'vat'
  | 'vatAmount'
  | InvoiceResponseKeySpecifier
)[];
export type InvoiceResponseFieldPolicy = {
  amount?: FieldPolicy<any> | FieldReadFunction<any>;
  cost?: FieldPolicy<any> | FieldReadFunction<any>;
  costExVat?: FieldPolicy<any> | FieldReadFunction<any>;
  dueDate?: FieldPolicy<any> | FieldReadFunction<any>;
  fileName?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  price?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  strategy?: FieldPolicy<any> | FieldReadFunction<any>;
  total?: FieldPolicy<any> | FieldReadFunction<any>;
  url?: FieldPolicy<any> | FieldReadFunction<any>;
  user?: FieldPolicy<any> | FieldReadFunction<any>;
  vat?: FieldPolicy<any> | FieldReadFunction<any>;
  vatAmount?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MolliePaymentResponseKeySpecifier = (
  | 'createdAt'
  | 'details'
  | 'method'
  | 'status'
  | MolliePaymentResponseKeySpecifier
)[];
export type MolliePaymentResponseFieldPolicy = {
  createdAt?: FieldPolicy<any> | FieldReadFunction<any>;
  details?: FieldPolicy<any> | FieldReadFunction<any>;
  method?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MollieTransitPaymentLinkResponseKeySpecifier = (
  | 'checkoutURL'
  | MollieTransitPaymentLinkResponseKeySpecifier
)[];
export type MollieTransitPaymentLinkResponseFieldPolicy = {
  checkoutURL?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MutationKeySpecifier = (
  | 'AdminCancelUserSubscription'
  | 'addKeys'
  | 'adminManageUsersTotp'
  | 'adminRebalanceUser'
  | 'adminRemoveKeys'
  | 'adminSendEmail'
  | 'adminSignInAs'
  | 'adminSignOutAs'
  | 'cancelSubscription'
  | 'changeCredentials'
  | 'depositAmount'
  | 'directMolliePayment'
  | 'editProfile'
  | 'googleSignIn'
  | 'googleSignUp'
  | 'newMollieClient'
  | 'portfolioLiquidation'
  | 'portfolioRebalance'
  | 'removeUser'
  | 'resendVerificationEmail'
  | 'resetPassword'
  | 'sendResetPasswordEmail'
  | 'signIn'
  | 'signOut'
  | 'signUp'
  | 'startSubscription'
  | 'totpDisable'
  | 'totpGenerate'
  | 'totpSetup'
  | 'totpVerify'
  | MutationKeySpecifier
)[];
export type MutationFieldPolicy = {
  AdminCancelUserSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  addKeys?: FieldPolicy<any> | FieldReadFunction<any>;
  adminManageUsersTotp?: FieldPolicy<any> | FieldReadFunction<any>;
  adminRebalanceUser?: FieldPolicy<any> | FieldReadFunction<any>;
  adminRemoveKeys?: FieldPolicy<any> | FieldReadFunction<any>;
  adminSendEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  adminSignInAs?: FieldPolicy<any> | FieldReadFunction<any>;
  adminSignOutAs?: FieldPolicy<any> | FieldReadFunction<any>;
  cancelSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  changeCredentials?: FieldPolicy<any> | FieldReadFunction<any>;
  depositAmount?: FieldPolicy<any> | FieldReadFunction<any>;
  directMolliePayment?: FieldPolicy<any> | FieldReadFunction<any>;
  editProfile?: FieldPolicy<any> | FieldReadFunction<any>;
  googleSignIn?: FieldPolicy<any> | FieldReadFunction<any>;
  googleSignUp?: FieldPolicy<any> | FieldReadFunction<any>;
  newMollieClient?: FieldPolicy<any> | FieldReadFunction<any>;
  portfolioLiquidation?: FieldPolicy<any> | FieldReadFunction<any>;
  portfolioRebalance?: FieldPolicy<any> | FieldReadFunction<any>;
  removeUser?: FieldPolicy<any> | FieldReadFunction<any>;
  resendVerificationEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  resetPassword?: FieldPolicy<any> | FieldReadFunction<any>;
  sendResetPasswordEmail?: FieldPolicy<any> | FieldReadFunction<any>;
  signIn?: FieldPolicy<any> | FieldReadFunction<any>;
  signOut?: FieldPolicy<any> | FieldReadFunction<any>;
  signUp?: FieldPolicy<any> | FieldReadFunction<any>;
  startSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  totpDisable?: FieldPolicy<any> | FieldReadFunction<any>;
  totpGenerate?: FieldPolicy<any> | FieldReadFunction<any>;
  totpSetup?: FieldPolicy<any> | FieldReadFunction<any>;
  totpVerify?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NewMollieClientResponseKeySpecifier = (
  | 'checkoutURL'
  | NewMollieClientResponseKeySpecifier
)[];
export type NewMollieClientResponseFieldPolicy = {
  checkoutURL?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NotificationResponseKeySpecifier = (
  | 'CreatedAt'
  | 'NotificationId'
  | 'NotificationSource'
  | 'NotificationType'
  | NotificationResponseKeySpecifier
)[];
export type NotificationResponseFieldPolicy = {
  CreatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  NotificationId?: FieldPolicy<any> | FieldReadFunction<any>;
  NotificationSource?: FieldPolicy<any> | FieldReadFunction<any>;
  NotificationType?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PaymentSourceKeySpecifier = (
  | 'brand'
  | 'expMonth'
  | 'expYear'
  | 'id'
  | 'lastFour'
  | PaymentSourceKeySpecifier
)[];
export type PaymentSourceFieldPolicy = {
  brand?: FieldPolicy<any> | FieldReadFunction<any>;
  expMonth?: FieldPolicy<any> | FieldReadFunction<any>;
  expYear?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  lastFour?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PortfolioRowResponseKeySpecifier = (
  | 'amountCoins'
  | 'change24'
  | 'change24Amount'
  | 'change24Percentage'
  | 'cost'
  | 'currency'
  | 'effectiveDate'
  | 'enoughToStartSubscription'
  | 'percentage'
  | 'usdChange24Amount'
  | 'usdChange24Percentage'
  | 'usdCost'
  | PortfolioRowResponseKeySpecifier
)[];
export type PortfolioRowResponseFieldPolicy = {
  amountCoins?: FieldPolicy<any> | FieldReadFunction<any>;
  change24?: FieldPolicy<any> | FieldReadFunction<any>;
  change24Amount?: FieldPolicy<any> | FieldReadFunction<any>;
  change24Percentage?: FieldPolicy<any> | FieldReadFunction<any>;
  cost?: FieldPolicy<any> | FieldReadFunction<any>;
  currency?: FieldPolicy<any> | FieldReadFunction<any>;
  effectiveDate?: FieldPolicy<any> | FieldReadFunction<any>;
  enoughToStartSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  percentage?: FieldPolicy<any> | FieldReadFunction<any>;
  usdChange24Amount?: FieldPolicy<any> | FieldReadFunction<any>;
  usdChange24Percentage?: FieldPolicy<any> | FieldReadFunction<any>;
  usdCost?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PortfolioTotalsResponseKeySpecifier = (
  | 'eurCostChange24Percentage'
  | 'eurCostChange24Total'
  | 'eurCostTotal'
  | 'nextRebalancingOn'
  | 'usdCostChange24Percentage'
  | 'usdCostChange24total'
  | 'usdCostTotal'
  | PortfolioTotalsResponseKeySpecifier
)[];
export type PortfolioTotalsResponseFieldPolicy = {
  eurCostChange24Percentage?: FieldPolicy<any> | FieldReadFunction<any>;
  eurCostChange24Total?: FieldPolicy<any> | FieldReadFunction<any>;
  eurCostTotal?: FieldPolicy<any> | FieldReadFunction<any>;
  nextRebalancingOn?: FieldPolicy<any> | FieldReadFunction<any>;
  usdCostChange24Percentage?: FieldPolicy<any> | FieldReadFunction<any>;
  usdCostChange24total?: FieldPolicy<any> | FieldReadFunction<any>;
  usdCostTotal?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PrivatePortfolioRowResponseKeySpecifier = (
  | 'amountCoins'
  | 'change24'
  | 'change24Amount'
  | 'change24Percentage'
  | 'cost'
  | 'currency'
  | 'effectiveDate'
  | 'enoughToStartSubscription'
  | 'percentage'
  | 'usdChange24Amount'
  | 'usdChange24Percentage'
  | 'usdCost'
  | PrivatePortfolioRowResponseKeySpecifier
)[];
export type PrivatePortfolioRowResponseFieldPolicy = {
  amountCoins?: FieldPolicy<any> | FieldReadFunction<any>;
  change24?: FieldPolicy<any> | FieldReadFunction<any>;
  change24Amount?: FieldPolicy<any> | FieldReadFunction<any>;
  change24Percentage?: FieldPolicy<any> | FieldReadFunction<any>;
  cost?: FieldPolicy<any> | FieldReadFunction<any>;
  currency?: FieldPolicy<any> | FieldReadFunction<any>;
  effectiveDate?: FieldPolicy<any> | FieldReadFunction<any>;
  enoughToStartSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  percentage?: FieldPolicy<any> | FieldReadFunction<any>;
  usdChange24Amount?: FieldPolicy<any> | FieldReadFunction<any>;
  usdChange24Percentage?: FieldPolicy<any> | FieldReadFunction<any>;
  usdCost?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QueryKeySpecifier = (
  | 'adminGetInvoices'
  | 'adminGetPerformance'
  | 'adminGetUser'
  | 'adminGetUsers'
  | 'getDemoPortfolio'
  | 'getDemoPortfolioGraphData'
  | 'getDepositCurrenciesOptions'
  | 'getExchanges'
  | 'getExpectedPortfolio'
  | 'getIndexPortfolio'
  | 'getIndexPortfolioSortedForSale'
  | 'getInvoice'
  | 'getInvoices'
  | 'getMolliePaymentInfo'
  | 'getMollieTransitPaymentLink'
  | 'getPortfolioCurrencyPercentageCost'
  | 'getPortfolioGraphData'
  | 'getPortfolioTotals'
  | 'getPrivatePortfolio'
  | 'getUser'
  | 'getUserExchanges'
  | 'getUserNotifications'
  | 'portfolioCurrency'
  | 'selectedExchange'
  | 'updatePortfolioPopupWasShown'
  | QueryKeySpecifier
)[];
export type QueryFieldPolicy = {
  adminGetInvoices?: FieldPolicy<any> | FieldReadFunction<any>;
  adminGetPerformance?: FieldPolicy<any> | FieldReadFunction<any>;
  adminGetUser?: FieldPolicy<any> | FieldReadFunction<any>;
  adminGetUsers?: FieldPolicy<any> | FieldReadFunction<any>;
  getDemoPortfolio?: FieldPolicy<any> | FieldReadFunction<any>;
  getDemoPortfolioGraphData?: FieldPolicy<any> | FieldReadFunction<any>;
  getDepositCurrenciesOptions?: FieldPolicy<any> | FieldReadFunction<any>;
  getExchanges?: FieldPolicy<any> | FieldReadFunction<any>;
  getExpectedPortfolio?: FieldPolicy<any> | FieldReadFunction<any>;
  getIndexPortfolio?: FieldPolicy<any> | FieldReadFunction<any>;
  getIndexPortfolioSortedForSale?: FieldPolicy<any> | FieldReadFunction<any>;
  getInvoice?: FieldPolicy<any> | FieldReadFunction<any>;
  getInvoices?: FieldPolicy<any> | FieldReadFunction<any>;
  getMolliePaymentInfo?: FieldPolicy<any> | FieldReadFunction<any>;
  getMollieTransitPaymentLink?: FieldPolicy<any> | FieldReadFunction<any>;
  getPortfolioCurrencyPercentageCost?:
    | FieldPolicy<any>
    | FieldReadFunction<any>;
  getPortfolioGraphData?: FieldPolicy<any> | FieldReadFunction<any>;
  getPortfolioTotals?: FieldPolicy<any> | FieldReadFunction<any>;
  getPrivatePortfolio?: FieldPolicy<any> | FieldReadFunction<any>;
  getUser?: FieldPolicy<any> | FieldReadFunction<any>;
  getUserExchanges?: FieldPolicy<any> | FieldReadFunction<any>;
  getUserNotifications?: FieldPolicy<any> | FieldReadFunction<any>;
  portfolioCurrency?: FieldPolicy<any> | FieldReadFunction<any>;
  selectedExchange?: FieldPolicy<any> | FieldReadFunction<any>;
  updatePortfolioPopupWasShown?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RemoveUserResponseKeySpecifier = (
  | 'invoiceToPayId'
  | 'success'
  | RemoveUserResponseKeySpecifier
)[];
export type RemoveUserResponseFieldPolicy = {
  invoiceToPayId?: FieldPolicy<any> | FieldReadFunction<any>;
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ResetPasswordResponseKeySpecifier = (
  | 'success'
  | ResetPasswordResponseKeySpecifier
)[];
export type ResetPasswordResponseFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SendResetPasswordEmailResponseKeySpecifier = (
  | 'success'
  | SendResetPasswordEmailResponseKeySpecifier
)[];
export type SendResetPasswordEmailResponseFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SignInResponseKeySpecifier = (
  | 'authIdentityID'
  | 'token'
  | 'totpEnabled'
  | SignInResponseKeySpecifier
)[];
export type SignInResponseFieldPolicy = {
  authIdentityID?: FieldPolicy<any> | FieldReadFunction<any>;
  token?: FieldPolicy<any> | FieldReadFunction<any>;
  totpEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SignOutResponseKeySpecifier = (
  | 'success'
  | SignOutResponseKeySpecifier
)[];
export type SignOutResponseFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type SignUpResponseKeySpecifier = (
  | 'authIdentityId'
  | 'token'
  | SignUpResponseKeySpecifier
)[];
export type SignUpResponseFieldPolicy = {
  authIdentityId?: FieldPolicy<any> | FieldReadFunction<any>;
  token?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TotpDisableResponseKeySpecifier = (
  | 'success'
  | TotpDisableResponseKeySpecifier
)[];
export type TotpDisableResponseFieldPolicy = {
  success?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TotpValidateResponseKeySpecifier = (
  | 'backupCodes'
  | 'token'
  | TotpValidateResponseKeySpecifier
)[];
export type TotpValidateResponseFieldPolicy = {
  backupCodes?: FieldPolicy<any> | FieldReadFunction<any>;
  token?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type TotpVerifyResponseKeySpecifier = (
  | 'token'
  | TotpVerifyResponseKeySpecifier
)[];
export type TotpVerifyResponseFieldPolicy = {
  token?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserExchangeResponseKeySpecifier = (
  | 'aumBelowMinimum'
  | 'exchangeCode'
  | 'exchangeID'
  | 'fiatCurrencies'
  | 'keysCreatedAt'
  | 'keysStatus'
  | 'lastRebalanceReason'
  | 'lastRebalanceReasonRequest'
  | 'lastRebalanceReasonResponse'
  | 'moneyUnderManagement'
  | 'nextRebalanceDate'
  | 'onlyFiatInPortfolio'
  | 'portfolioOutdated'
  | 'rebalancingDate'
  | 'sentToRebalancing'
  | 'subscriptionInitiatedDate'
  | 'subscriptionStartDate'
  | 'targetForSaleCurrencies'
  | 'wizardStatus'
  | UserExchangeResponseKeySpecifier
)[];
export type UserExchangeResponseFieldPolicy = {
  aumBelowMinimum?: FieldPolicy<any> | FieldReadFunction<any>;
  exchangeCode?: FieldPolicy<any> | FieldReadFunction<any>;
  exchangeID?: FieldPolicy<any> | FieldReadFunction<any>;
  fiatCurrencies?: FieldPolicy<any> | FieldReadFunction<any>;
  keysCreatedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  keysStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  lastRebalanceReason?: FieldPolicy<any> | FieldReadFunction<any>;
  lastRebalanceReasonRequest?: FieldPolicy<any> | FieldReadFunction<any>;
  lastRebalanceReasonResponse?: FieldPolicy<any> | FieldReadFunction<any>;
  moneyUnderManagement?: FieldPolicy<any> | FieldReadFunction<any>;
  nextRebalanceDate?: FieldPolicy<any> | FieldReadFunction<any>;
  onlyFiatInPortfolio?: FieldPolicy<any> | FieldReadFunction<any>;
  portfolioOutdated?: FieldPolicy<any> | FieldReadFunction<any>;
  rebalancingDate?: FieldPolicy<any> | FieldReadFunction<any>;
  sentToRebalancing?: FieldPolicy<any> | FieldReadFunction<any>;
  subscriptionInitiatedDate?: FieldPolicy<any> | FieldReadFunction<any>;
  subscriptionStartDate?: FieldPolicy<any> | FieldReadFunction<any>;
  targetForSaleCurrencies?: FieldPolicy<any> | FieldReadFunction<any>;
  wizardStatus?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type UserResponseKeySpecifier = (
  | 'address'
  | 'amountToInvest'
  | 'authIdentities'
  | 'authProvider'
  | 'city'
  | 'companyName'
  | 'controlledByUser'
  | 'country'
  | 'currenciesLocked'
  | 'dateOfBirth'
  | 'dateOfSignup'
  | 'deletedAt'
  | 'exchanges'
  | 'firstName'
  | 'gender'
  | 'hadCreditCard'
  | 'hasActiveSubscription'
  | 'hasUnpaidInvoices'
  | 'houseNumber'
  | 'id'
  | 'isAdmin'
  | 'lastName'
  | 'mollieStatus'
  | 'moneyPaid'
  | 'nextRebalancingOn'
  | 'paymentSources'
  | 'pendingDiscount'
  | 'personalReferalCode'
  | 'phone'
  | 'profileValid'
  | 'referralCode'
  | 'state'
  | 'status'
  | 'stripeStatus'
  | 'totpEnabled'
  | 'trialEndDate'
  | 'vatNumber'
  | 'zip'
  | UserResponseKeySpecifier
)[];
export type UserResponseFieldPolicy = {
  address?: FieldPolicy<any> | FieldReadFunction<any>;
  amountToInvest?: FieldPolicy<any> | FieldReadFunction<any>;
  authIdentities?: FieldPolicy<any> | FieldReadFunction<any>;
  authProvider?: FieldPolicy<any> | FieldReadFunction<any>;
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  companyName?: FieldPolicy<any> | FieldReadFunction<any>;
  controlledByUser?: FieldPolicy<any> | FieldReadFunction<any>;
  country?: FieldPolicy<any> | FieldReadFunction<any>;
  currenciesLocked?: FieldPolicy<any> | FieldReadFunction<any>;
  dateOfBirth?: FieldPolicy<any> | FieldReadFunction<any>;
  dateOfSignup?: FieldPolicy<any> | FieldReadFunction<any>;
  deletedAt?: FieldPolicy<any> | FieldReadFunction<any>;
  exchanges?: FieldPolicy<any> | FieldReadFunction<any>;
  firstName?: FieldPolicy<any> | FieldReadFunction<any>;
  gender?: FieldPolicy<any> | FieldReadFunction<any>;
  hadCreditCard?: FieldPolicy<any> | FieldReadFunction<any>;
  hasActiveSubscription?: FieldPolicy<any> | FieldReadFunction<any>;
  hasUnpaidInvoices?: FieldPolicy<any> | FieldReadFunction<any>;
  houseNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  isAdmin?: FieldPolicy<any> | FieldReadFunction<any>;
  lastName?: FieldPolicy<any> | FieldReadFunction<any>;
  mollieStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  moneyPaid?: FieldPolicy<any> | FieldReadFunction<any>;
  nextRebalancingOn?: FieldPolicy<any> | FieldReadFunction<any>;
  paymentSources?: FieldPolicy<any> | FieldReadFunction<any>;
  pendingDiscount?: FieldPolicy<any> | FieldReadFunction<any>;
  personalReferalCode?: FieldPolicy<any> | FieldReadFunction<any>;
  phone?: FieldPolicy<any> | FieldReadFunction<any>;
  profileValid?: FieldPolicy<any> | FieldReadFunction<any>;
  referralCode?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  stripeStatus?: FieldPolicy<any> | FieldReadFunction<any>;
  totpEnabled?: FieldPolicy<any> | FieldReadFunction<any>;
  trialEndDate?: FieldPolicy<any> | FieldReadFunction<any>;
  vatNumber?: FieldPolicy<any> | FieldReadFunction<any>;
  zip?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StrictTypedTypePolicies = {
  AdminPerformanceResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AdminPerformanceResponseKeySpecifier
      | (() => undefined | AdminPerformanceResponseKeySpecifier);
    fields?: AdminPerformanceResponseFieldPolicy;
  };
  AdminSignInAsResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AdminSignInAsResponseKeySpecifier
      | (() => undefined | AdminSignInAsResponseKeySpecifier);
    fields?: AdminSignInAsResponseFieldPolicy;
  };
  AdminUserResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AdminUserResponseKeySpecifier
      | (() => undefined | AdminUserResponseKeySpecifier);
    fields?: AdminUserResponseFieldPolicy;
  };
  AdminUsersResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AdminUsersResponseKeySpecifier
      | (() => undefined | AdminUsersResponseKeySpecifier);
    fields?: AdminUsersResponseFieldPolicy;
  };
  AggregatedDataRow?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AggregatedDataRowKeySpecifier
      | (() => undefined | AggregatedDataRowKeySpecifier);
    fields?: AggregatedDataRowFieldPolicy;
  };
  AuthIdentityResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AuthIdentityResponseKeySpecifier
      | (() => undefined | AuthIdentityResponseKeySpecifier);
    fields?: AuthIdentityResponseFieldPolicy;
  };
  Currency?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | CurrencyKeySpecifier
      | (() => undefined | CurrencyKeySpecifier);
    fields?: CurrencyFieldPolicy;
  };
  CurrencyPortfolioPercentageCostResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | CurrencyPortfolioPercentageCostResponseKeySpecifier
      | (() => undefined | CurrencyPortfolioPercentageCostResponseKeySpecifier);
    fields?: CurrencyPortfolioPercentageCostResponseFieldPolicy;
  };
  DirectInvoicePaymentResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | DirectInvoicePaymentResponseKeySpecifier
      | (() => undefined | DirectInvoicePaymentResponseKeySpecifier);
    fields?: DirectInvoicePaymentResponseFieldPolicy;
  };
  ExchangeResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ExchangeResponseKeySpecifier
      | (() => undefined | ExchangeResponseKeySpecifier);
    fields?: ExchangeResponseFieldPolicy;
  };
  ExpectedPortfolioRowResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ExpectedPortfolioRowResponseKeySpecifier
      | (() => undefined | ExpectedPortfolioRowResponseKeySpecifier);
    fields?: ExpectedPortfolioRowResponseFieldPolicy;
  };
  GoogleSignInResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | GoogleSignInResponseKeySpecifier
      | (() => undefined | GoogleSignInResponseKeySpecifier);
    fields?: GoogleSignInResponseFieldPolicy;
  };
  GoogleSignUpResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | GoogleSignUpResponseKeySpecifier
      | (() => undefined | GoogleSignUpResponseKeySpecifier);
    fields?: GoogleSignUpResponseFieldPolicy;
  };
  InvoiceListResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InvoiceListResponseKeySpecifier
      | (() => undefined | InvoiceListResponseKeySpecifier);
    fields?: InvoiceListResponseFieldPolicy;
  };
  InvoiceResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InvoiceResponseKeySpecifier
      | (() => undefined | InvoiceResponseKeySpecifier);
    fields?: InvoiceResponseFieldPolicy;
  };
  MolliePaymentResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MolliePaymentResponseKeySpecifier
      | (() => undefined | MolliePaymentResponseKeySpecifier);
    fields?: MolliePaymentResponseFieldPolicy;
  };
  MollieTransitPaymentLinkResponse?: Omit<
    TypePolicy,
    'fields' | 'keyFields'
  > & {
    keyFields?:
      | false
      | MollieTransitPaymentLinkResponseKeySpecifier
      | (() => undefined | MollieTransitPaymentLinkResponseKeySpecifier);
    fields?: MollieTransitPaymentLinkResponseFieldPolicy;
  };
  Mutation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MutationKeySpecifier
      | (() => undefined | MutationKeySpecifier);
    fields?: MutationFieldPolicy;
  };
  NewMollieClientResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NewMollieClientResponseKeySpecifier
      | (() => undefined | NewMollieClientResponseKeySpecifier);
    fields?: NewMollieClientResponseFieldPolicy;
  };
  NotificationResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | NotificationResponseKeySpecifier
      | (() => undefined | NotificationResponseKeySpecifier);
    fields?: NotificationResponseFieldPolicy;
  };
  PaymentSource?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PaymentSourceKeySpecifier
      | (() => undefined | PaymentSourceKeySpecifier);
    fields?: PaymentSourceFieldPolicy;
  };
  PortfolioRowResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PortfolioRowResponseKeySpecifier
      | (() => undefined | PortfolioRowResponseKeySpecifier);
    fields?: PortfolioRowResponseFieldPolicy;
  };
  PortfolioTotalsResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PortfolioTotalsResponseKeySpecifier
      | (() => undefined | PortfolioTotalsResponseKeySpecifier);
    fields?: PortfolioTotalsResponseFieldPolicy;
  };
  PrivatePortfolioRowResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PrivatePortfolioRowResponseKeySpecifier
      | (() => undefined | PrivatePortfolioRowResponseKeySpecifier);
    fields?: PrivatePortfolioRowResponseFieldPolicy;
  };
  Query?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QueryKeySpecifier
      | (() => undefined | QueryKeySpecifier);
    fields?: QueryFieldPolicy;
  };
  RemoveUserResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RemoveUserResponseKeySpecifier
      | (() => undefined | RemoveUserResponseKeySpecifier);
    fields?: RemoveUserResponseFieldPolicy;
  };
  ResetPasswordResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ResetPasswordResponseKeySpecifier
      | (() => undefined | ResetPasswordResponseKeySpecifier);
    fields?: ResetPasswordResponseFieldPolicy;
  };
  SendResetPasswordEmailResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SendResetPasswordEmailResponseKeySpecifier
      | (() => undefined | SendResetPasswordEmailResponseKeySpecifier);
    fields?: SendResetPasswordEmailResponseFieldPolicy;
  };
  SignInResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SignInResponseKeySpecifier
      | (() => undefined | SignInResponseKeySpecifier);
    fields?: SignInResponseFieldPolicy;
  };
  SignOutResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SignOutResponseKeySpecifier
      | (() => undefined | SignOutResponseKeySpecifier);
    fields?: SignOutResponseFieldPolicy;
  };
  SignUpResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | SignUpResponseKeySpecifier
      | (() => undefined | SignUpResponseKeySpecifier);
    fields?: SignUpResponseFieldPolicy;
  };
  TotpDisableResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TotpDisableResponseKeySpecifier
      | (() => undefined | TotpDisableResponseKeySpecifier);
    fields?: TotpDisableResponseFieldPolicy;
  };
  TotpValidateResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TotpValidateResponseKeySpecifier
      | (() => undefined | TotpValidateResponseKeySpecifier);
    fields?: TotpValidateResponseFieldPolicy;
  };
  TotpVerifyResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | TotpVerifyResponseKeySpecifier
      | (() => undefined | TotpVerifyResponseKeySpecifier);
    fields?: TotpVerifyResponseFieldPolicy;
  };
  UserExchangeResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserExchangeResponseKeySpecifier
      | (() => undefined | UserExchangeResponseKeySpecifier);
    fields?: UserExchangeResponseFieldPolicy;
  };
  UserResponse?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | UserResponseKeySpecifier
      | (() => undefined | UserResponseKeySpecifier);
    fields?: UserResponseFieldPolicy;
  };
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<
  TResult,
  TParent = Record<PropertyKey, never>,
  TContext = Record<PropertyKey, never>,
  TArgs = Record<PropertyKey, never>,
> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> {
  subscribe: SubscriptionSubscribeFn<
    { [key in TKey]: TResult },
    TParent,
    TContext,
    TArgs
  >;
  resolve?: SubscriptionResolveFn<
    TResult,
    { [key in TKey]: TResult },
    TContext,
    TArgs
  >;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = Record<PropertyKey, never>,
  TContext = Record<PropertyKey, never>,
  TArgs = Record<PropertyKey, never>,
> =
  | ((
      ...args: any[]
    ) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<
  TTypes,
  TParent = Record<PropertyKey, never>,
  TContext = Record<PropertyKey, never>,
> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<
  T = Record<PropertyKey, never>,
  TContext = Record<PropertyKey, never>,
> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo
) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<
  TResult = Record<PropertyKey, never>,
  TParent = Record<PropertyKey, never>,
  TContext = Record<PropertyKey, never>,
  TArgs = Record<PropertyKey, never>,
> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AdminPerformanceResponse: ResolverTypeWrapper<AdminPerformanceResponse>;
  AdminSignInAsResponse: ResolverTypeWrapper<AdminSignInAsResponse>;
  AdminUserResponse: ResolverTypeWrapper<AdminUserResponse>;
  AdminUsersResponse: ResolverTypeWrapper<AdminUsersResponse>;
  AggregatedDataRow: ResolverTypeWrapper<AggregatedDataRow>;
  AuthIdentityProvider: AuthIdentityProvider;
  AuthIdentityResponse: ResolverTypeWrapper<AuthIdentityResponse>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Currency: ResolverTypeWrapper<Currency>;
  CurrencyInput: CurrencyInput;
  CurrencyPortfolioPercentageCostResponse: ResolverTypeWrapper<CurrencyPortfolioPercentageCostResponse>;
  CustomUserStatus: CustomUserStatus;
  DirectInvoicePaymentResponse: ResolverTypeWrapper<DirectInvoicePaymentResponse>;
  ExchangeCode: ExchangeCode;
  ExchangeResponse: ResolverTypeWrapper<ExchangeResponse>;
  ExpectedPortfolioRowResponse: ResolverTypeWrapper<ExpectedPortfolioRowResponse>;
  ExpectedPortfolioTokenStatus: ExpectedPortfolioTokenStatus;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  GoogleSignInResponse: ResolverTypeWrapper<GoogleSignInResponse>;
  GoogleSignUpResponse: ResolverTypeWrapper<GoogleSignUpResponse>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  InvoiceActiveFilter: InvoiceActiveFilter;
  InvoiceListResponse: ResolverTypeWrapper<InvoiceListResponse>;
  InvoicePaymentStatus: InvoicePaymentStatus;
  InvoiceResponse: ResolverTypeWrapper<InvoiceResponse>;
  InvoicesFilterByStatus: InvoicesFilterByStatus;
  InvoicesOrderBy: InvoicesOrderBy;
  InvoicesOrderByField: InvoicesOrderByField;
  KeyInput: KeyInput;
  KeysStatus: KeysStatus;
  LastRebalanceReasonType: LastRebalanceReasonType;
  MolliePaymentResponse: ResolverTypeWrapper<MolliePaymentResponse>;
  MollieStatus: MollieStatus;
  MollieTransitPaymentLinkResponse: ResolverTypeWrapper<MollieTransitPaymentLinkResponse>;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  NewMollieClientResponse: ResolverTypeWrapper<NewMollieClientResponse>;
  NotificationResponse: ResolverTypeWrapper<NotificationResponse>;
  NotificationType: NotificationType;
  OrderByClause: OrderByClause;
  OrderByDirection: OrderByDirection;
  OrderByRelationAggregateFunction: OrderByRelationAggregateFunction;
  OrderByRelationWithColumnAggregateFunction: OrderByRelationWithColumnAggregateFunction;
  PaymentSource: ResolverTypeWrapper<PaymentSource>;
  PortfolioCurrency: PortfolioCurrency;
  PortfolioPartitionAction: PortfolioPartitionAction;
  PortfolioRowResponse: ResolverTypeWrapper<PortfolioRowResponse>;
  PortfolioTotalsResponse: ResolverTypeWrapper<PortfolioTotalsResponse>;
  PrivatePortfolioRowResponse: ResolverTypeWrapper<PrivatePortfolioRowResponse>;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  RemoveUserResponse: ResolverTypeWrapper<RemoveUserResponse>;
  ResetPasswordResponse: ResolverTypeWrapper<ResetPasswordResponse>;
  SendResetPasswordEmailResponse: ResolverTypeWrapper<SendResetPasswordEmailResponse>;
  SignInResponse: ResolverTypeWrapper<SignInResponse>;
  SignOutResponse: ResolverTypeWrapper<SignOutResponse>;
  SignUpResponse: ResolverTypeWrapper<SignUpResponse>;
  SortOrder: SortOrder;
  StartTrialStatus: StartTrialStatus;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  StripeStatus: StripeStatus;
  Time: ResolverTypeWrapper<Scalars['Time']['output']>;
  TotpDisableResponse: ResolverTypeWrapper<TotpDisableResponse>;
  TotpValidateResponse: ResolverTypeWrapper<TotpValidateResponse>;
  TotpVerifyResponse: ResolverTypeWrapper<TotpVerifyResponse>;
  Trashed: Trashed;
  UserExchangeResponse: ResolverTypeWrapper<UserExchangeResponse>;
  UserResponse: ResolverTypeWrapper<UserResponse>;
  UserStatus: UserStatus;
  UsersOrderBy: UsersOrderBy;
  UsersOrderByField: UsersOrderByField;
  WizardStatusType: WizardStatusType;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AdminPerformanceResponse: AdminPerformanceResponse;
  AdminSignInAsResponse: AdminSignInAsResponse;
  AdminUserResponse: AdminUserResponse;
  AdminUsersResponse: AdminUsersResponse;
  AggregatedDataRow: AggregatedDataRow;
  AuthIdentityResponse: AuthIdentityResponse;
  Boolean: Scalars['Boolean']['output'];
  Currency: Currency;
  CurrencyInput: CurrencyInput;
  CurrencyPortfolioPercentageCostResponse: CurrencyPortfolioPercentageCostResponse;
  DirectInvoicePaymentResponse: DirectInvoicePaymentResponse;
  ExchangeResponse: ExchangeResponse;
  ExpectedPortfolioRowResponse: ExpectedPortfolioRowResponse;
  Float: Scalars['Float']['output'];
  GoogleSignInResponse: GoogleSignInResponse;
  GoogleSignUpResponse: GoogleSignUpResponse;
  ID: Scalars['ID']['output'];
  Int: Scalars['Int']['output'];
  InvoiceListResponse: InvoiceListResponse;
  InvoiceResponse: InvoiceResponse;
  InvoicesOrderBy: InvoicesOrderBy;
  KeyInput: KeyInput;
  MolliePaymentResponse: MolliePaymentResponse;
  MollieTransitPaymentLinkResponse: MollieTransitPaymentLinkResponse;
  Mutation: Record<PropertyKey, never>;
  NewMollieClientResponse: NewMollieClientResponse;
  NotificationResponse: NotificationResponse;
  OrderByClause: OrderByClause;
  PaymentSource: PaymentSource;
  PortfolioRowResponse: PortfolioRowResponse;
  PortfolioTotalsResponse: PortfolioTotalsResponse;
  PrivatePortfolioRowResponse: PrivatePortfolioRowResponse;
  Query: Record<PropertyKey, never>;
  RemoveUserResponse: RemoveUserResponse;
  ResetPasswordResponse: ResetPasswordResponse;
  SendResetPasswordEmailResponse: SendResetPasswordEmailResponse;
  SignInResponse: SignInResponse;
  SignOutResponse: SignOutResponse;
  SignUpResponse: SignUpResponse;
  String: Scalars['String']['output'];
  Time: Scalars['Time']['output'];
  TotpDisableResponse: TotpDisableResponse;
  TotpValidateResponse: TotpValidateResponse;
  TotpVerifyResponse: TotpVerifyResponse;
  UserExchangeResponse: UserExchangeResponse;
  UserResponse: UserResponse;
  UsersOrderBy: UsersOrderBy;
};

export type AuthDirectiveArgs = {
  guard?: Maybe<Scalars['String']['input']>;
  resolver?: Maybe<Scalars['String']['input']>;
};

export type AuthDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = AuthDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ClientDirectiveArgs = {
  always?: Maybe<Scalars['Boolean']['input']>;
};

export type ClientDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = ClientDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ExportDirectiveArgs = {
  as: Scalars['String']['input'];
};

export type ExportDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = ExportDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type FieldDirectiveArgs = {
  resolver?: Maybe<Scalars['String']['input']>;
};

export type FieldDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = FieldDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ModelDirectiveArgs = {
  class?: Maybe<Scalars['String']['input']>;
};

export type ModelDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = ModelDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ValidatorDirectiveArgs = {
  class: Scalars['String']['input'];
};

export type ValidatorDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = ValidatorDirectiveArgs,
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AdminPerformanceResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AdminPerformanceResponse'] =
    ResolversParentTypes['AdminPerformanceResponse'],
> = {
  rate24?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  start?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  ytd?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type AdminSignInAsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AdminSignInAsResponse'] =
    ResolversParentTypes['AdminSignInAsResponse'],
> = {
  authIdentityID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totpEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type AdminUserResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AdminUserResponse'] =
    ResolversParentTypes['AdminUserResponse'],
> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amountToInvest?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  authIdentities?: Resolver<
    Array<ResolversTypes['AuthIdentityResponse']>,
    ParentType,
    ContextType,
    Partial<AdminUserResponseAuthIdentitiesArgs>
  >;
  authProvider?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  controlledByUser?: Resolver<
    Maybe<ResolversTypes['UserResponse']>,
    ParentType,
    ContextType
  >;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currenciesLocked?: Resolver<
    Array<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  customStatuses?: Resolver<
    Array<ResolversTypes['CustomUserStatus']>,
    ParentType,
    ContextType
  >;
  dateOfBirth?: Resolver<
    Maybe<ResolversTypes['Time']>,
    ParentType,
    ContextType
  >;
  dateOfSignup?: Resolver<ResolversTypes['Time'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Time']>, ParentType, ContextType>;
  exchanges?: Resolver<
    Array<ResolversTypes['UserExchangeResponse']>,
    ParentType,
    ContextType
  >;
  firstName?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  gender?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hadCreditCard?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasActiveSubscription?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  hasUnpaidInvoices?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  houseNumber?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mollieStatus?: Resolver<
    ResolversTypes['MollieStatus'],
    ParentType,
    ContextType
  >;
  moneyPaid?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  nextRebalancingOn?: Resolver<
    Maybe<ResolversTypes['Time']>,
    ParentType,
    ContextType
  >;
  paymentSources?: Resolver<
    Array<ResolversTypes['PaymentSource']>,
    ParentType,
    ContextType
  >;
  pendingDiscount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  personalReferalCode?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profileValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  referralCode?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UserStatus'], ParentType, ContextType>;
  stripeStatus?: Resolver<
    ResolversTypes['StripeStatus'],
    ParentType,
    ContextType
  >;
  totpEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  trialEndDate?: Resolver<
    Maybe<ResolversTypes['Time']>,
    ParentType,
    ContextType
  >;
  vatNumber?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type AdminUsersResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AdminUsersResponse'] =
    ResolversParentTypes['AdminUsersResponse'],
> = {
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  offset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAum?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalPaid?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  users?: Resolver<
    Array<ResolversTypes['AdminUserResponse']>,
    ParentType,
    ContextType
  >;
};

export type AggregatedDataRowResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AggregatedDataRow'] =
    ResolversParentTypes['AggregatedDataRow'],
> = {
  date?: Resolver<ResolversTypes['Time'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type AuthIdentityResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AuthIdentityResponse'] =
    ResolversParentTypes['AuthIdentityResponse'],
> = {
  confirmedAt?: Resolver<
    Maybe<ResolversTypes['Time']>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<ResolversTypes['Time'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Time']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  provider?: Resolver<
    ResolversTypes['AuthIdentityProvider'],
    ParentType,
    ContextType
  >;
  uid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Time'], ParentType, ContextType>;
};

export type CurrencyResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Currency'] =
    ResolversParentTypes['Currency'],
> = {
  btc24RateValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  btcValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  eur24RateValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  eurValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isFiat?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  messari?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  piechartColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetForSale?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usd24RateValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  usdValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type CurrencyPortfolioPercentageCostResponseResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CurrencyPortfolioPercentageCostResponse'] =
    ResolversParentTypes['CurrencyPortfolioPercentageCostResponse'],
> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  partitionAction?: Resolver<
    ResolversTypes['PortfolioPartitionAction'],
    ParentType,
    ContextType
  >;
};

export type DirectInvoicePaymentResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DirectInvoicePaymentResponse'] =
    ResolversParentTypes['DirectInvoicePaymentResponse'],
> = {
  checkoutURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ExchangeResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExchangeResponse'] =
    ResolversParentTypes['ExchangeResponse'],
> = {
  exchangeCode?: Resolver<
    ResolversTypes['ExchangeCode'],
    ParentType,
    ContextType
  >;
  exchangeName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ExpectedPortfolioRowResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ExpectedPortfolioRowResponse'] =
    ResolversParentTypes['ExpectedPortfolioRowResponse'],
> = {
  amountCoins?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  change24?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  change24Amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  change24Percentage?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType
  >;
  cost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  currentCost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  effectiveDate?: Resolver<ResolversTypes['Time'], ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<
    ResolversTypes['ExpectedPortfolioTokenStatus'],
    ParentType,
    ContextType
  >;
  usdChange24Amount?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType
  >;
  usdChange24Percentage?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType
  >;
  usdCost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type GoogleSignInResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GoogleSignInResponse'] =
    ResolversParentTypes['GoogleSignInResponse'],
> = {
  authIdentityID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  profileValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totpEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type GoogleSignUpResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GoogleSignUpResponse'] =
    ResolversParentTypes['GoogleSignUpResponse'],
> = {
  authIdentityID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  profileValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totpEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type InvoiceListResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvoiceListResponse'] =
    ResolversParentTypes['InvoiceListResponse'],
> = {
  activeTotal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  invoices?: Resolver<
    Array<ResolversTypes['InvoiceResponse']>,
    ParentType,
    ContextType
  >;
};

export type InvoiceResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InvoiceResponse'] =
    ResolversParentTypes['InvoiceResponse'],
> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  costExVat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dueDate?: Resolver<ResolversTypes['Time'], ParentType, ContextType>;
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<
    ResolversTypes['InvoicePaymentStatus'],
    ParentType,
    ContextType
  >;
  strategy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['UserResponse'], ParentType, ContextType>;
  vat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  vatAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type MolliePaymentResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MolliePaymentResponse'] =
    ResolversParentTypes['MolliePaymentResponse'],
> = {
  createdAt?: Resolver<ResolversTypes['Time'], ParentType, ContextType>;
  details?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type MollieTransitPaymentLinkResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MollieTransitPaymentLinkResponse'] =
    ResolversParentTypes['MollieTransitPaymentLinkResponse'],
> = {
  checkoutURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type MutationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Mutation'] =
    ResolversParentTypes['Mutation'],
> = {
  AdminCancelUserSubscription?: Resolver<
    ResolversTypes['UserResponse'],
    ParentType,
    ContextType,
    RequireFields<
      MutationAdminCancelUserSubscriptionArgs,
      'exchangeId' | 'userID'
    >
  >;
  addKeys?: Resolver<
    ResolversTypes['UserExchangeResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationAddKeysArgs, 'exchangeId' | 'keys'>
  >;
  adminManageUsersTotp?: Resolver<
    Array<ResolversTypes['UserResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationAdminManageUsersTotpArgs, 'enable' | 'usersIDs'>
  >;
  adminRebalanceUser?: Resolver<
    ResolversTypes['UserResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationAdminRebalanceUserArgs, 'exchangeId' | 'userID'>
  >;
  adminRemoveKeys?: Resolver<
    ResolversTypes['UserResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationAdminRemoveKeysArgs, 'exchangeId' | 'userID'>
  >;
  adminSendEmail?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    RequireFields<MutationAdminSendEmailArgs, 'templateId'>
  >;
  adminSignInAs?: Resolver<
    ResolversTypes['AdminSignInAsResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationAdminSignInAsArgs, 'userID'>
  >;
  adminSignOutAs?: Resolver<
    ResolversTypes['SignInResponse'],
    ParentType,
    ContextType
  >;
  cancelSubscription?: Resolver<
    ResolversTypes['UserExchangeResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationCancelSubscriptionArgs, 'exchangeId'>
  >;
  changeCredentials?: Resolver<
    ResolversTypes['UserResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationChangeCredentialsArgs, 'currentPassword'>
  >;
  depositAmount?: Resolver<
    ResolversTypes['UserResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationDepositAmountArgs, 'currencies' | 'exchangeId'>
  >;
  directMolliePayment?: Resolver<
    ResolversTypes['DirectInvoicePaymentResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationDirectMolliePaymentArgs, 'invoiceId'>
  >;
  editProfile?: Resolver<
    ResolversTypes['UserResponse'],
    ParentType,
    ContextType,
    Partial<MutationEditProfileArgs>
  >;
  googleSignIn?: Resolver<
    ResolversTypes['GoogleSignInResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationGoogleSignInArgs, 'token'>
  >;
  googleSignUp?: Resolver<
    ResolversTypes['GoogleSignUpResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationGoogleSignUpArgs, 'token'>
  >;
  newMollieClient?: Resolver<
    ResolversTypes['NewMollieClientResponse'],
    ParentType,
    ContextType,
    Partial<MutationNewMollieClientArgs>
  >;
  portfolioLiquidation?: Resolver<
    ResolversTypes['UserResponse'],
    ParentType,
    ContextType,
    RequireFields<
      MutationPortfolioLiquidationArgs,
      'currencyId' | 'exchangeId' | 'percents'
    >
  >;
  portfolioRebalance?: Resolver<
    ResolversTypes['UserResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationPortfolioRebalanceArgs, 'exchangeId'>
  >;
  removeUser?: Resolver<
    ResolversTypes['RemoveUserResponse'],
    ParentType,
    ContextType,
    Partial<MutationRemoveUserArgs>
  >;
  resendVerificationEmail?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    Partial<MutationResendVerificationEmailArgs>
  >;
  resetPassword?: Resolver<
    ResolversTypes['ResetPasswordResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationResetPasswordArgs, 'password'>
  >;
  sendResetPasswordEmail?: Resolver<
    ResolversTypes['SendResetPasswordEmailResponse'],
    ParentType,
    ContextType,
    Partial<MutationSendResetPasswordEmailArgs>
  >;
  signIn?: Resolver<
    ResolversTypes['SignInResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationSignInArgs, 'email' | 'password' | 'remember'>
  >;
  signOut?: Resolver<
    ResolversTypes['SignOutResponse'],
    ParentType,
    ContextType
  >;
  signUp?: Resolver<
    ResolversTypes['SignUpResponse'],
    ParentType,
    ContextType,
    RequireFields<
      MutationSignUpArgs,
      'email' | 'firstName' | 'lastName' | 'password' | 'passwordRepeat'
    >
  >;
  startSubscription?: Resolver<
    ResolversTypes['StartTrialStatus'],
    ParentType,
    ContextType,
    RequireFields<MutationStartSubscriptionArgs, 'currencies' | 'exchangeId'>
  >;
  totpDisable?: Resolver<
    ResolversTypes['TotpDisableResponse'],
    ParentType,
    ContextType,
    RequireFields<MutationTotpDisableArgs, 'code'>
  >;
  totpGenerate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totpSetup?: Resolver<
    Maybe<ResolversTypes['TotpValidateResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationTotpSetupArgs, 'code'>
  >;
  totpVerify?: Resolver<
    Maybe<ResolversTypes['TotpVerifyResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationTotpVerifyArgs, 'code'>
  >;
};

export type NewMollieClientResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NewMollieClientResponse'] =
    ResolversParentTypes['NewMollieClientResponse'],
> = {
  checkoutURL?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type NotificationResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['NotificationResponse'] =
    ResolversParentTypes['NotificationResponse'],
> = {
  CreatedAt?: Resolver<Maybe<ResolversTypes['Time']>, ParentType, ContextType>;
  NotificationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  NotificationSource?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  NotificationType?: Resolver<
    ResolversTypes['NotificationType'],
    ParentType,
    ContextType
  >;
};

export type PaymentSourceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PaymentSource'] =
    ResolversParentTypes['PaymentSource'],
> = {
  brand?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  expYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastFour?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PortfolioRowResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PortfolioRowResponse'] =
    ResolversParentTypes['PortfolioRowResponse'],
> = {
  amountCoins?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  change24?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  change24Amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  change24Percentage?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType
  >;
  cost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  effectiveDate?: Resolver<ResolversTypes['Time'], ParentType, ContextType>;
  enoughToStartSubscription?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  usdChange24Amount?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType
  >;
  usdChange24Percentage?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType
  >;
  usdCost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type PortfolioTotalsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PortfolioTotalsResponse'] =
    ResolversParentTypes['PortfolioTotalsResponse'],
> = {
  eurCostChange24Percentage?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType
  >;
  eurCostChange24Total?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType
  >;
  eurCostTotal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  nextRebalancingOn?: Resolver<ResolversTypes['Time'], ParentType, ContextType>;
  usdCostChange24Percentage?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType
  >;
  usdCostChange24total?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType
  >;
  usdCostTotal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type PrivatePortfolioRowResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PrivatePortfolioRowResponse'] =
    ResolversParentTypes['PrivatePortfolioRowResponse'],
> = {
  amountCoins?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  change24?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  change24Amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  change24Percentage?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType
  >;
  cost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['Currency'], ParentType, ContextType>;
  effectiveDate?: Resolver<ResolversTypes['Time'], ParentType, ContextType>;
  enoughToStartSubscription?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  usdChange24Amount?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType
  >;
  usdChange24Percentage?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType
  >;
  usdCost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type QueryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Query'] =
    ResolversParentTypes['Query'],
> = {
  adminGetInvoices?: Resolver<
    ResolversTypes['InvoiceListResponse'],
    ParentType,
    ContextType,
    Partial<QueryAdminGetInvoicesArgs>
  >;
  adminGetPerformance?: Resolver<
    ResolversTypes['AdminPerformanceResponse'],
    ParentType,
    ContextType
  >;
  adminGetUser?: Resolver<
    Maybe<ResolversTypes['UserResponse']>,
    ParentType,
    ContextType,
    RequireFields<QueryAdminGetUserArgs, 'userId'>
  >;
  adminGetUsers?: Resolver<
    ResolversTypes['AdminUsersResponse'],
    ParentType,
    ContextType,
    Partial<QueryAdminGetUsersArgs>
  >;
  getDemoPortfolio?: Resolver<
    Array<ResolversTypes['PortfolioRowResponse']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetDemoPortfolioArgs, 'exchangeId'>
  >;
  getDemoPortfolioGraphData?: Resolver<
    Array<Maybe<ResolversTypes['AggregatedDataRow']>>,
    ParentType,
    ContextType,
    RequireFields<QueryGetDemoPortfolioGraphDataArgs, 'exchangeId'>
  >;
  getDepositCurrenciesOptions?: Resolver<
    Array<ResolversTypes['PrivatePortfolioRowResponse']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetDepositCurrenciesOptionsArgs, 'exchangeId'>
  >;
  getExchanges?: Resolver<
    Array<ResolversTypes['ExchangeResponse']>,
    ParentType,
    ContextType
  >;
  getExpectedPortfolio?: Resolver<
    Array<ResolversTypes['ExpectedPortfolioRowResponse']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetExpectedPortfolioArgs, 'exchangeId'>
  >;
  getIndexPortfolio?: Resolver<
    Array<ResolversTypes['PortfolioRowResponse']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetIndexPortfolioArgs, 'exchangeId'>
  >;
  getIndexPortfolioSortedForSale?: Resolver<
    Array<ResolversTypes['PortfolioRowResponse']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetIndexPortfolioSortedForSaleArgs, 'exchangeId'>
  >;
  getInvoice?: Resolver<
    ResolversTypes['InvoiceResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryGetInvoiceArgs, 'invoiceID'>
  >;
  getInvoices?: Resolver<
    Array<ResolversTypes['InvoiceResponse']>,
    ParentType,
    ContextType
  >;
  getMolliePaymentInfo?: Resolver<
    ResolversTypes['MolliePaymentResponse'],
    ParentType,
    ContextType
  >;
  getMollieTransitPaymentLink?: Resolver<
    ResolversTypes['MollieTransitPaymentLinkResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryGetMollieTransitPaymentLinkArgs, 'token'>
  >;
  getPortfolioCurrencyPercentageCost?: Resolver<
    ResolversTypes['CurrencyPortfolioPercentageCostResponse'],
    ParentType,
    ContextType,
    RequireFields<
      QueryGetPortfolioCurrencyPercentageCostArgs,
      'currencies' | 'exchangeId' | 'partitionAction'
    >
  >;
  getPortfolioGraphData?: Resolver<
    Array<ResolversTypes['AggregatedDataRow']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetPortfolioGraphDataArgs, 'exchangeId'>
  >;
  getPortfolioTotals?: Resolver<
    ResolversTypes['PortfolioTotalsResponse'],
    ParentType,
    ContextType,
    RequireFields<QueryGetPortfolioTotalsArgs, 'exchangeId'>
  >;
  getPrivatePortfolio?: Resolver<
    Array<ResolversTypes['PrivatePortfolioRowResponse']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetPrivatePortfolioArgs, 'exchangeId'>
  >;
  getUser?: Resolver<ResolversTypes['UserResponse'], ParentType, ContextType>;
  getUserExchanges?: Resolver<
    Array<ResolversTypes['UserExchangeResponse']>,
    ParentType,
    ContextType
  >;
  getUserNotifications?: Resolver<
    Array<ResolversTypes['NotificationResponse']>,
    ParentType,
    ContextType
  >;
  portfolioCurrency?: Resolver<
    Maybe<ResolversTypes['PortfolioCurrency']>,
    ParentType,
    ContextType
  >;
  selectedExchange?: Resolver<
    Maybe<ResolversTypes['ExchangeCode']>,
    ParentType,
    ContextType
  >;
  updatePortfolioPopupWasShown?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
};

export type RemoveUserResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RemoveUserResponse'] =
    ResolversParentTypes['RemoveUserResponse'],
> = {
  invoiceToPayId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type ResetPasswordResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ResetPasswordResponse'] =
    ResolversParentTypes['ResetPasswordResponse'],
> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type SendResetPasswordEmailResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SendResetPasswordEmailResponse'] =
    ResolversParentTypes['SendResetPasswordEmailResponse'],
> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type SignInResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SignInResponse'] =
    ResolversParentTypes['SignInResponse'],
> = {
  authIdentityID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totpEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type SignOutResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SignOutResponse'] =
    ResolversParentTypes['SignOutResponse'],
> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type SignUpResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SignUpResponse'] =
    ResolversParentTypes['SignUpResponse'],
> = {
  authIdentityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export interface TimeScalarConfig extends GraphQLScalarTypeConfig<
  ResolversTypes['Time'],
  any
> {
  name: 'Time';
}

export type TotpDisableResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TotpDisableResponse'] =
    ResolversParentTypes['TotpDisableResponse'],
> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type TotpValidateResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TotpValidateResponse'] =
    ResolversParentTypes['TotpValidateResponse'],
> = {
  backupCodes?: Resolver<
    Array<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type TotpVerifyResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TotpVerifyResponse'] =
    ResolversParentTypes['TotpVerifyResponse'],
> = {
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type UserExchangeResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserExchangeResponse'] =
    ResolversParentTypes['UserExchangeResponse'],
> = {
  aumBelowMinimum?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  exchangeCode?: Resolver<
    ResolversTypes['ExchangeCode'],
    ParentType,
    ContextType
  >;
  exchangeID?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  fiatCurrencies?: Resolver<
    Array<ResolversTypes['Currency']>,
    ParentType,
    ContextType
  >;
  keysCreatedAt?: Resolver<
    Maybe<ResolversTypes['Time']>,
    ParentType,
    ContextType
  >;
  keysStatus?: Resolver<ResolversTypes['KeysStatus'], ParentType, ContextType>;
  lastRebalanceReason?: Resolver<
    Maybe<ResolversTypes['LastRebalanceReasonType']>,
    ParentType,
    ContextType
  >;
  lastRebalanceReasonRequest?: Resolver<
    Maybe<ResolversTypes['LastRebalanceReasonType']>,
    ParentType,
    ContextType
  >;
  lastRebalanceReasonResponse?: Resolver<
    Maybe<ResolversTypes['LastRebalanceReasonType']>,
    ParentType,
    ContextType
  >;
  moneyUnderManagement?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType
  >;
  nextRebalanceDate?: Resolver<
    Maybe<ResolversTypes['Time']>,
    ParentType,
    ContextType
  >;
  onlyFiatInPortfolio?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  portfolioOutdated?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  rebalancingDate?: Resolver<
    Maybe<ResolversTypes['Time']>,
    ParentType,
    ContextType
  >;
  sentToRebalancing?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  subscriptionInitiatedDate?: Resolver<
    Maybe<ResolversTypes['Time']>,
    ParentType,
    ContextType
  >;
  subscriptionStartDate?: Resolver<
    Maybe<ResolversTypes['Time']>,
    ParentType,
    ContextType
  >;
  targetForSaleCurrencies?: Resolver<
    Array<ResolversTypes['Currency']>,
    ParentType,
    ContextType
  >;
  wizardStatus?: Resolver<
    ResolversTypes['WizardStatusType'],
    ParentType,
    ContextType
  >;
};

export type UserResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UserResponse'] =
    ResolversParentTypes['UserResponse'],
> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amountToInvest?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  authIdentities?: Resolver<
    Array<ResolversTypes['AuthIdentityResponse']>,
    ParentType,
    ContextType,
    Partial<UserResponseAuthIdentitiesArgs>
  >;
  authProvider?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  controlledByUser?: Resolver<
    Maybe<ResolversTypes['UserResponse']>,
    ParentType,
    ContextType
  >;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currenciesLocked?: Resolver<
    Array<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  dateOfBirth?: Resolver<
    Maybe<ResolversTypes['Time']>,
    ParentType,
    ContextType
  >;
  dateOfSignup?: Resolver<ResolversTypes['Time'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Time']>, ParentType, ContextType>;
  exchanges?: Resolver<
    Array<ResolversTypes['UserExchangeResponse']>,
    ParentType,
    ContextType
  >;
  firstName?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  gender?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hadCreditCard?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasActiveSubscription?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  hasUnpaidInvoices?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  houseNumber?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mollieStatus?: Resolver<
    ResolversTypes['MollieStatus'],
    ParentType,
    ContextType
  >;
  moneyPaid?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  nextRebalancingOn?: Resolver<
    Maybe<ResolversTypes['Time']>,
    ParentType,
    ContextType
  >;
  paymentSources?: Resolver<
    Array<ResolversTypes['PaymentSource']>,
    ParentType,
    ContextType
  >;
  pendingDiscount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  personalReferalCode?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profileValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  referralCode?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UserStatus'], ParentType, ContextType>;
  stripeStatus?: Resolver<
    ResolversTypes['StripeStatus'],
    ParentType,
    ContextType
  >;
  totpEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  trialEndDate?: Resolver<
    Maybe<ResolversTypes['Time']>,
    ParentType,
    ContextType
  >;
  vatNumber?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AdminPerformanceResponse?: AdminPerformanceResponseResolvers<ContextType>;
  AdminSignInAsResponse?: AdminSignInAsResponseResolvers<ContextType>;
  AdminUserResponse?: AdminUserResponseResolvers<ContextType>;
  AdminUsersResponse?: AdminUsersResponseResolvers<ContextType>;
  AggregatedDataRow?: AggregatedDataRowResolvers<ContextType>;
  AuthIdentityResponse?: AuthIdentityResponseResolvers<ContextType>;
  Currency?: CurrencyResolvers<ContextType>;
  CurrencyPortfolioPercentageCostResponse?: CurrencyPortfolioPercentageCostResponseResolvers<ContextType>;
  DirectInvoicePaymentResponse?: DirectInvoicePaymentResponseResolvers<ContextType>;
  ExchangeResponse?: ExchangeResponseResolvers<ContextType>;
  ExpectedPortfolioRowResponse?: ExpectedPortfolioRowResponseResolvers<ContextType>;
  GoogleSignInResponse?: GoogleSignInResponseResolvers<ContextType>;
  GoogleSignUpResponse?: GoogleSignUpResponseResolvers<ContextType>;
  InvoiceListResponse?: InvoiceListResponseResolvers<ContextType>;
  InvoiceResponse?: InvoiceResponseResolvers<ContextType>;
  MolliePaymentResponse?: MolliePaymentResponseResolvers<ContextType>;
  MollieTransitPaymentLinkResponse?: MollieTransitPaymentLinkResponseResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NewMollieClientResponse?: NewMollieClientResponseResolvers<ContextType>;
  NotificationResponse?: NotificationResponseResolvers<ContextType>;
  PaymentSource?: PaymentSourceResolvers<ContextType>;
  PortfolioRowResponse?: PortfolioRowResponseResolvers<ContextType>;
  PortfolioTotalsResponse?: PortfolioTotalsResponseResolvers<ContextType>;
  PrivatePortfolioRowResponse?: PrivatePortfolioRowResponseResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RemoveUserResponse?: RemoveUserResponseResolvers<ContextType>;
  ResetPasswordResponse?: ResetPasswordResponseResolvers<ContextType>;
  SendResetPasswordEmailResponse?: SendResetPasswordEmailResponseResolvers<ContextType>;
  SignInResponse?: SignInResponseResolvers<ContextType>;
  SignOutResponse?: SignOutResponseResolvers<ContextType>;
  SignUpResponse?: SignUpResponseResolvers<ContextType>;
  Time?: GraphQLScalarType;
  TotpDisableResponse?: TotpDisableResponseResolvers<ContextType>;
  TotpValidateResponse?: TotpValidateResponseResolvers<ContextType>;
  TotpVerifyResponse?: TotpVerifyResponseResolvers<ContextType>;
  UserExchangeResponse?: UserExchangeResponseResolvers<ContextType>;
  UserResponse?: UserResponseResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  auth?: AuthDirectiveResolver<any, any, ContextType>;
  client?: ClientDirectiveResolver<any, any, ContextType>;
  export?: ExportDirectiveResolver<any, any, ContextType>;
  field?: FieldDirectiveResolver<any, any, ContextType>;
  model?: ModelDirectiveResolver<any, any, ContextType>;
  validator?: ValidatorDirectiveResolver<any, any, ContextType>;
};
